import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../utils/withRouter";
import { ToastContainer, toast } from "react-toastify";
import {
  order_edit_details,
  order_cancel_reason_action,
  download_performa_invoice_action,
  download_no_due_action,
  download_exitPass_action,
  generate_nodue_action,
  postUpdate_additional_services_action, download_booking_form_action
} from "../../actions/myOrders_action/myOrders_action";

import { generate_unique_no_action, create_payment_order_action, payment_action } from '../../actions/bookingDetails_action/cart_action';
import {
  get_additional_services_action,
  getServiceVendorPackageDetail_action,
} from "../../actions/bookingDetails_action/aditionalServices_action";
import { Modal, Button, Tab, Nav } from "react-bootstrap";
import { fill_action } from "../../actions/fillList_action";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../utils/Loader";
import Header from "../../common_components/Header";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import {
  BASE_URL,
  cancellationReasonActionId,
  downloadReport,
  standardPremiumActionId,
  paymentPortalLink,
  sessionExpireMessage,
  tokenInavlidMessage,
  toastError,
  razorpayCheckoutUrl,
  key_id,
  merchantName,
  merchantDescription,
  prefilName,
  prefilContact,
  prefilEmail,
  prefilAddress,
  paymentVerificationUrl,
  key_secret,
  vendorActionId,
  orderRejectionActionId,
} from "../../utils/constants";
import {
  client_detail_action,
  client_add_action,
} from "../../actions/master_actions/client_action";
import {
  accountTypeActionId,
  cityActionId,
  companyStatusActionId,
  countryActionId,
  stateActionId,
} from "../../utils/constants";
import {
  emailValidator,
  gstNoValidator,
  mobileNoValidator,
  notMendetoryEmailValidator,
  notMendetoryMobileNoValidator,
  panNoValidator,
  pincodeValidator,
  tanNoValidator,
} from "../../utils/Validator";
import { get_booking_Details_action } from "../../actions/bookingDetails_action/bookingDetails_action";
import moment from "moment";
import {
  get_possession_list_action,
  get_exist_list_action,
} from "../../actions/checkList_action/checkList_action";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import {
  thirdParty_VendorOrder_detail_action,
  insertUpdate_thirdParty_vendorOrderDtl_action,
} from "../../actions/accounts_action/account_third_party_orders_action";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import {
  chat_detail_action,
  insert_chat_action,
} from "../../actions/myOrders_action/chat_action";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Link, Element } from "react-scroll";
import RenderRazorpay from '../payment/payment';
const floatingLabelCSSOrders = `
.floating-label-outside{
  top:-7px !important;
  font-size:10px !important;
  background:#fff !important;
}
.mendatory_class{
  font-size:12px;
}
`;

const marks = [];

for (let i = 0; i <= 100000; i++) {
  if (i % 250 === 0) {
    marks.push({
      value: i,
    });
  }
}
class MyOrdersEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deleteShow: false,
      isLoading: false,
      isChatLoading: false,
      isAccordionExpanded: false,
      PiShow: false,
      isEditMode: true,
      userId: "",
      OrderID: "",
      RoleID: "",
      Date: "",
      StatusID: "",
      OrderDate: "",
      ItmeCenter: "",
      TypeOfEventID: "",
      DeliveryStatus: "",
      TypeOfEvent: "",
      EventName: "",
      grandTotal: "",

      finalCurrency: "",
      Is_NoDue: false,
      NoDueDate: "",
      NoDueBy: "",
      AdditionalDiscount: "",
      AdditionalDiscountNote: "",
      AdditionalServiceApprovalStatus: "",
      AdditionalServiceStatus: "",
      Is_ExitPass: false,
      IsExitPassDate: "",
      IsExitPassBy: "",
      MyOrdersData: [],
      proformaList: [],
      filteredData: [],
      eventFillList: [],
      //client list
      checkboxFlag: false,
      stateId: "",
      stateList: [],
      countryId: "",
      countryList: [],
      firstName: "",
      lastName: "",
      designation: "",
      companyName: "",
      addressLine1: "",
      addressLine2: "",
      cityId: "",
      cityList: [],
      pincode: "",
      Mobile1: "",
      Mobile2: "",
      primaryEmailID: "",
      secondaryEmailID: "",
      website: "",
      mobileISD1: "",
      mobileISD2: "",
      accountType: "",
      accountTypeList: [],

      SameAsAbove: false,

      SAAFirstName: "",
      SAALastName: "",
      SAADesignation: "",
      SAACompanyName: "",
      SAAAddressLine1: "",
      SAAAddressLine2: "",
      SAACityId: "",
      SAAPincode: "",
      SAAMobile1: "",
      SAAMobile2: "",
      SAAPrimaryEmailID: "",
      SAASecondaryEmailID: "",
      SAAWebsite: "",
      SAAStateId: "",
      SAACountryId: "",
      SAATelephoneNumber: "",
      SAAMobileISD1: "",
      SAAMobileISD2: "",
      SAAISD: "",
      registrationNumber: "",
      PANCardNo: "",
      NameonPANCard: "",
      GSTNo: "",
      CompanyStatus: "",
      TANNumber: "",
      UINNumber: "",
      TelephoneNumber: "",
      accountName: "",
      accountNo: "",
      accountType: "",
      bankName: "",
      branchName: "",
      IFSCCode: "",
      EventCordinatorName: "",
      EventCordinatorDesignation: "",
      EventCordinatorEmail: "",
      EventCordinatorMobile: "",
      PrimaryContactName: "",
      PrimaryContactDesignation: "",
      PrimaryContactEmail: "",
      PrimaryContactMobile: "",

      EventCordinatorNameErr: "",
      EventCordinatorDesignationErr: "",
      EventCordinatorEmailErr: "",
      EventCordinatorMobileErr: "",
      PrimaryContactNameErr: "",
      PrimaryContactDesignationErr: "",
      PrimaryContactEmailErr: "",
      PrimaryContactMobileErr: "",

      CityName: "",
      tempCityList: [],
      SAACityName: "",
      companyStatusId: "",
      companyStatusList: [],
      ISD: "",

      CenterID: "",
      OrderID: "",
      ClientID: "",
      Is_CenterID: false,
      MaxPAX: "",
      LastDate: "",
      // input validate
      companyStatusErr: "",
      firstNameErr: "",
      lastNameErr: "",
      organizerErr: "",
      addressLine1Err: "",
      addressLine2Err: "",
      CityNameErr: "",
      countryIdErr: "",
      pincodeErr: "",
      Mobile1Err: "",
      primaryEmailIDErr: "",
      SAAFirstNameErr: "",
      SAALastNameErr: "",
      SAAAddressLine1Err: "",
      SAAAddressLine2Err: "",
      SAACityNameErr: "",
      SAACountryIdErr: "",
      SAAPincodeErr: "",
      SAAMobile1Err: "",
      SAAPrimaryEmailIDErr: "",
      PANCardNoErr: "",
      NameonPANCardErr: "",
      accountNameErr: "",
      accountNoErr: "",
      accountTypeErr: "",
      bankNameErr: "",
      branchNameErr: "",
      SAACompanyNameErr: "",
      preTel: "",
      SAAPreTel: "",
      AreaCode: "",
      SAAAreaCode: "",

      isDisplayCityList: false,
      isSAADisplayCityList: false,

      isDisplayStateList: false,
      tempStateList: [],

      isSAADisplayStateList: false,
      tempSAAStateList: [],

      SAAStateList: [],
      SAAtempStateList: [],

      SAACityList: [],
      SAAtempCityList: [],
      CancellationReasonID: "",
      cancelNote: "",
      //payment
      // paymentType: "",
      // ToPay: "",
      // isLoadPayment: false,
      // encPayload: "",
      // orderId: "",
      // changeAmt: 1,
      // paymentAccessCode: "AVVI64IL27CE56IVEC",
      // finalCurrency: "",
      // currencyErr: false,
      displayRazorpay: false, orderPaymentDetails: {},
      paymentOrderID: '',
      //Additional Services
      SelectedExtService: [],
      additionalServicesList: [],
      serviceName: "",
      addRequirement: "",
      standardPremiumId: "",
      standardPremiumList: [],
      isQuantity: "",
      Ammount: "",
      standerdArray: [],
      premiumArray: [],
      tempStandardArray: [],
      tempStandardArray2: [],
      isOpen: false,
      checkboxFlag: false,
      is_checkbox: "",
      Quantity: "",
      sList: [],
      CenterID: "",
      OrderID: "",
      fileList: [],
      currentImageIndex: 0,
      ClientID: "",
      orderDtlID: "",
      DetailsPremiumArray: [],
      DetailsStandardArray: [],
      show: false,
      CurrencyID: "",
      unlistedAddServices: "",
      includedServices: [],
      externalServices: [],
      vendorPackageList: [],
      dummyVendorPackageList: [],
      OtherInformation: "",
      downloadUrl: "",
      showtable: false,
      showPackageDetailsData: "",
      indexOfExternalService: "",
      //Booking Details
      EntryType: "",
      TypeOfEvent: "",
      SittingArrangement: "",
      bookingList: [],
      BookingEventDataList: [],
      PossesionStartDate: "",
      PossesionEndDate: "",
      PossesionStartTime: "",
      PossesionEndTime: "",
      eventStartDate: "",
      eventEndDate: "",
      eventStartTime: "",
      eventEndTime: "",
      dismantleStartDate: "",
      dismantleEndDate: "",
      dismantleStartTime: "",
      dismantleEndTime: "",
      //checkList
      possessionIncludedServicesList: [],
      possessionInhouseServicesList: [],
      exitConsumableList: [],
      possessionConsumableList: [],
      PossessionContactNameAndNumber: "",
      ExitContactNameAndNumber: "",
      possessionCheckList: [],
      isPossessionList: [],
      signatureData: "",
      isSignatureSaved: false,
      isSignatureSaveFlag: false,
      showCountryId: "",
      exitIncludedServicesList: [],
      ExitSubmittedUser: "",
      exitInhouseServicesList: [],
      exitCheckList: [],
      isExitList: [],
      ExitSubmittedBy: "",
      possessionTime: "",
      exitTime: "",
      ExitSubmittedDate: "",
      exitListShow: true,
      signatureData2: "",
      isSignatureSaved2: false,
      isSignatureSaveFlag2: false,
      exitDataListFlag: false,
      possessionDataListFlag: false,
      ExitSignatureData: "",
      possessionSignatureData: "",
      submitOrApproveAdditional: "",
      possessionCheckList: [],
      PossesionSubmittedUser: "",
      PossesionSubmittedDate: "",
      ExitSubmittedUser: "",
      exitSub: false,
      possessionSub: false,
      possessionCheckListAllSelected: false,
      possessionMaterialNameAndServiceName: "", PosssesionOperationNameContact: "", oppPossessionSignatureData: "", ExitOperationNameContact: "", oppExitSignatureData: "",
      possessionMaterialList: [],
      exitCheckListAllSelected: false,
      possessionSecurityList: [],
      PossessionSecurityChecklistNote: "",
      exitMaterialList: [],
      exitSecurityList: [],
      exitInstructionList: [],
      ExitSecurityChecklistNote: "",
      exitMaterialNameAndServiceName: "",
      AdditionHours: "",
      ExitSubmittedUser: "",
      exitVendorList: [],
      possessionVendorList: [],
      AdditionHoursExit: "",
      unlistedAddServicesExit: "",
      exitVendorList: [],
      electricityExit: "",
      electricityPossesion: "",
      existDataListFlag: false,
      isCollapsed: false,
      SliderValue: [0, 100000],
      minPrice: null,
      maxPrice: null,
      vendorNameList: [],
      //quotations section
      quotationFilePath: "",
      invoiceFilePath: "",
      receiptFilePath: "",
      additionalInvoiceFilePath: "",
      additionalReceiptFilePath: "",
      FinalAmount: "",
      AdditionalAmount: "",
      IsOrderAcceptedbyVendor: false,
      IsOrderAcceptedbyClient: false,
      IsQuotationSubmitted: false,
      IsQuotationApproved: false,
      IsInvoiceSubmitted: false,
      IsPaymentReceived: false,
      ServiceName: "",
      VendorCompany: "",
      IsFinalInvoiceSubmitted: false,
      FinalPaymentReceived: false,
      nodeMailFlag: "",
      ThirdPartyVendorOrderList: [],
      OrderAcceptedbyClientSignature: "",
      OrderAcceptedbyClientContact: "",
      OrderAcceptedbyClientSignatureBy: "",
      OrderAcceptedbyClientSignatureDate: "",
      //chat
      isChatOpen: false,
      chat: "",
      chatHdr: [],
      chatDtl: [],
      isClient: "",
      chatVendorCompany: "",
      chatServiceName: "",
      chatVendorID: "",
      chatServiceID: "",
      chatOrderID: "",
      currency: '',
      amount: '', piFilePath: '', exitPiFilePath: '', taxInvoiceFilePath: '',
    }; this.submitpayment = React.createRef()
    this.formatOrderDate = this.formatOrderDate.bind(this);
    this.createOrderConfirmationList =
      this.createOrderConfirmationList.bind(this);
    // this.navPayment = this.navPayment.bind(this);
    // this.navServicePayment = this.navServicePayment.bind(this);
  }
  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    // sessionStorage.removeItem('formFile')
    // sessionStorage.removeItem('membershipFormFileType')
    // sessionStorage.removeItem('fileName')
    // sessionStorage.removeItem('checkboxFlag')
    // console.log(this.props.location);
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    this.setState({
      OrderID:
        this.props.location.state != null &&
          this.props.location.state.OrderID != null
          ? this.props.location.state.OrderID
          : "",
      OrderNo:
        this.props.location.state != null &&
          this.props.location.state.OrderNo != null
          ? this.props.location.state.OrderNo
          : "",
      ClientID:
        this.props.location.state != null &&
          this.props.location.state.ClientID != null
          ? this.props.location.state.ClientID
          : "",
      CenterID:
        this.props.location.state != null &&
          this.props.location.state.CenterID != null
          ? this.props.location.state.CenterID
          : "",
      CompanyName:
        this.props.location.state != null &&
          this.props.location.state.CompanyName != null
          ? this.props.location.state.CompanyName
          : "",
      PrimaryEmailID:
        this.props.location.state != null &&
          this.props.location.state.PrimaryEmailID != null
          ? this.props.location.state.PrimaryEmailID
          : "",
      DeliveryStatus:
        this.props.location.state != null &&
          this.props.location.state.DeliveryStatus != null
          ? this.props.location.state.DeliveryStatus
          : "",
      OrderAmount:
        this.props.location.state != null &&
          this.props.location.state.OrderAmount != null
          ? this.props.location.state.OrderAmount
          : "",
      userId:
        sessionStorage.getItem("userId") == "" ||
          sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
    });
    const { userId } = this.state;
    this.getFillList(stateActionId, "", 1, "").then(() => {
      this.getFillList(countryActionId, '', '1', '').then(() => {
        this.getFillList(cityActionId, '', '1', '').then(() => {
          this.getFillList(companyStatusActionId, '', '', '').then(() => {
            this.getFillList(accountTypeActionId, '', '', '').then(() => {
              this.getFillList(cancellationReasonActionId, userId, '', '').then(() => {
                this.getFillList(orderRejectionActionId, userId, '', '').then(() => {
                  this.getFillList(standardPremiumActionId, userId, '', '').then(() => {
                    this.getFillList(vendorActionId, userId, '', '').then(() => {
                      setTimeout(() => {
                        this.getOrderEditDetails();
                        this.setState({ isLoading: false })
                      }, 200);
                    })
                  })
                })
              })
            })
          })
        })
      })
    })
  }
  getFillList(value, userId, keyword, keyvalue) {
    this.setState({ isLoading: true });
    return new Promise((resolve, reject) => {
      this.props
        .fill_action(
          value,
          userId == "" || userId == null ? null : userId,
          keyword != "" ? keyword : null,
          keyvalue != "" ? keyvalue : null
        )
        .then((data) => {
          if (data.error != 1) {
            if (value == stateActionId) {
              this.setState({
                stateList: data.data,
                tempStateList: data.data,

                SAAStateList: data.data,
                SAAtempStateList: data.data,
              }, () => resolve(true)
              )
            }
            if (value == countryActionId) {
              this.setState({ countryList: data.data }, () => resolve(true));
            }
            if (value == cityActionId) {
              this.setState({
                cityList: data.data,
                tempCityList: data.data,

                SAACityList: data.data,
                SAAtempCityList: data.data,
              }, () => resolve(true));
            }
            if (value == companyStatusActionId) {
              this.setState({ companyStatusList: data.data }, () => resolve(true));
            }
            if (value == accountTypeActionId) {
              this.setState({ accountTypeList: data.data }, () => resolve(true));
            }
            if (value == cancellationReasonActionId) {
              this.setState({
                cancellationReasonList: data.data,
              }, () => resolve(true));
            }
            if (value == orderRejectionActionId) {
              this.setState({
                rejectionReasonList: data.data,
              }, () => resolve(true));
            }
            if (value == standardPremiumActionId) {
              this.setState({ standardPremiumList: data.data }, () => resolve(true));
            }
            if (value == vendorActionId) {
              this.setState({ vendorFillList: data.data }, () => resolve(true));
            }
          }
        })
    })
      .catch((e) => {
        console.log(e);
      });
  }
  vendorModalShow = (filePath) => {
    this.setState({
      show: true,
    });
    if (filePath != null) {
      const filePathArray = [];
      filePathArray.push(filePath.split(","));
      console.log("filePathArray", filePathArray);
      this.setState({ fileList: filePathArray[0] });
    }
  };
  vendorModalClose = () => {
    this.setState({ show: false });
  };

  tablePackageDetailsShow = (data) => {
    this.setState({ showtable: true, showPackageDetailsData: data });
  };

  tablePackageDetailsClose = () => {
    this.setState({ showtable: false });
  };

  serviceModalShow = (id, index, serviceName, requirement) => {
    this.setState({
      isOpen: true,
      serviceName: serviceName,
      addRequirement: requirement,
      addRequirementID: id,
      addRequirementIndex: index,
      // minPrice:null,
      // maxPrice:null
    });
    setTimeout(() => {
      this.getServiceVendorPackageDetail(id, index);
    }, 100);
  };
  serviceModalClose = () => {
    this.setState({ isOpen: false });
  };
  onSearchPackage() {
    const { addRequirementID, addRequirementIndex } = this.state;
    this.getServiceVendorPackageDetail(addRequirementID, addRequirementIndex);
  }

  getOrderEditDetails() {
    const { userId, OrderID } = this.state;
    this.setState({ isLoading: true });
    // Assuming that this.props.order_edit_details returns a Promise
    this.props
      .order_edit_details(userId, OrderID)
      .then((data) => {
        if (data.error !== 1) {
          setTimeout(() => {
            this.createOrderConfirmationList(data.data);
            this.setState({ isLoading: false });
          }, 300);
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            toast.error(data.msg, {
              position: "top-center",
              autoClose: 1000,
              theme: "colored",
            });
            this.setState({ isLoading: false });
          }
        }
      })
      .catch((err) => {
        console.error(err); // Logging the error for debugging
        this.setState({ isLoading: false });
      });
  }
  createOrderConfirmationList(data) {
    const { MyOrdersData } = this.state;
    const orderIDList = [];
    const finalList = [];
    const proformaList = [];

    for (const order of data[1]) {
      const orderID = order.OrderID;

      if (!orderIDList.includes(orderID)) {
        orderIDList.push(orderID);

        const summaryArr = data[0].filter(
          (booking) => booking.OrderID === orderID
        );
        const additionalServicesArr = [];
        const data2 = data[2].filter((service) => service.OrderID === orderID);
        data2.map((item) => {
          if (item.GrossAmount !== null) {
            if (item.Type === "S") {
              additionalServicesArr.push(item);
            } else if (item.Type === "P") {
              additionalServicesArr.push(item);
            }
          }
        });

        const objectID = {
          OrderID: orderID,
          summary: summaryArr,
          additionalServices: additionalServicesArr,
          centerName: order.CenterName,
          centerAdd: order.ADDRESS,
          OrderNo: order.OrderNo,
          DeliveryStatus: order.OrderStatus,
          StatusID: order.StatusID,
          paymentStatus: order.PaymentStatus,
          Is_NoDue: order.Is_NoDue,
          NoDueDate: order.NoDueDate,
          NoDueBy: order.NoDueBy,
          Is_ExitPass: order.Is_ExitPass,
          IsExitPassDate: order.IsExitPassDate,
          AdditionalDiscount: order.AdditionalDiscount,
          AdditionalDiscountNote: order.AdditionalDiscountNote,
          IsExitPassBy: order.IsExitPassBy,
          Is_Closure: order.Is_Closure,
          currency: order.Currency,
          RoleID: order.RoleID,
          CenterID: order.CenterID,
          StatusID: order.StatusID,
          orderDate: this.formatOrderDate(order.OrderDate),
          UUID: order.UUID,
          IsMemberShip: order.IsMemberShip,
          piFilePath: order.piFilePath,
          exitPiFilePath: order.exitPiFilePath,
          taxInvoiceFilePath: order.taxInvoiceFilePath,
        };

        const priceData = data[3].find((price) => price.OrderID === orderID);
        const proformaData = data[4].filter(
          (proformaDetails) => proformaDetails.OrderID === orderID
        );
        const cancellationData = data[5].filter(
          (cancel) => cancel.OrderID === orderID
        );
        const rejectionData = data[6].filter(
          (rejected) => rejected.OrderID === orderID
        );
        const additionalChargesData = data[7].filter(
          (addhourGet) => addhourGet.OrderID === orderID
        );
        const additionalChargesDetails = data[8].filter(
          (addhourDetails) => addhourDetails.OrderID === orderID
        );
        objectID.Price = priceData;
        objectID.proformaDetails = proformaData;
        objectID.cancelArr = cancellationData;
        objectID.RejectionData = rejectionData;
        objectID.additionalChargesData = additionalChargesData;
        objectID.additionalChargesDetails = additionalChargesDetails;

        finalList.push(objectID);
        proformaList.push(proformaData);
      }
    }

    console.log("Final List:", finalList, proformaList);

    this.setState({
      BookingDate: data[0][0].BookingDate,
      MyOrdersData: finalList,
      proformaList: proformaList,
      CenterID: finalList.map((data) => data.CenterID),
      ClientID: finalList.map((data) => data.ClientID),
      StatusID: finalList.map((data) => data.StatusID),
      piFilePath: finalList.map((data) => data.piFilePath),
      exitPiFilePath: finalList.map((data) => data.exitPiFilePath),
      taxInvoiceFilePath: finalList.map((data) => data.taxInvoiceFilePath),
    });
    if (
      (finalList.map((data) => data.CenterID) != null &&
        finalList.map((data) => data.ClientID) != null) ||
      (this.props.location.state.ClientID != null &&
        this.props.location.state.CenterID != null)
    ) {
      this.setState({
        CenterID: finalList.map((data) => data.CenterID).join(", "),
        ClientID: finalList.map((data) => data.ClientID).join(", "),
        DeliveryStatus: finalList.map((data) => data.DeliveryStatus),
      });
      console.log(
        "==================== this",
        finalList.map((data) => data.CenterID).join(", "),
        finalList.map((data) => data.ClientID).join(", "),
        finalList.map((data) => data)
      );
      this.props
        .client_detail_action(
          finalList.map((data) => data.ClientID).join(", ") ||
          this.props.location.state.ClientID
        )
        .then((data) => {
          console.log("Client details--------", data);
          if (data.error != 1) {
            this.setState({ isLoading: true });

            this.setState({
              firstName: data.data[0]["FirstName"],
              lastName: data.data[0]["LastName"],
              designation: data.data[0]["Designation"],
              companyName: data.data[0]["CompanyName"],
              addressLine1: data.data[0]["AddressLine1"],
              addressLine2: data.data[0]["AddressLine2"],
              cityId: data.data[0]["CityName"],
              SAACityId: data.data[0]["Inv_CityName"],
              stateId: data.data[0]["StateName"],
              countryId: data.data[0]["CountryID"],
              pincode: data.data[0]["Pincode"],
              Mobile1: data.data[0]["Mobile1"],
              Mobile2: data.data[0]["Mobile2"],
              TelephoneNumber: data.data[0]["Telephone"],
              primaryEmailID: data.data[0]["PrimaryEmailID"],
              secondaryEmailID: data.data[0]["SecondaryEmailID"],
              website: data.data[0]["Website"],
              SameAsAbove: data.data[0]["IS_SameAsAbove"],
              SAAFirstName: data.data[0]["Inv_FirstName"],
              SAALastName: data.data[0]["Inv_LastName"],
              SAADesignation: data.data[0]["Inv_Designation"],
              SAACompanyName: data.data[0]["Inv_CompanyName"],
              SAAAddressLine1: data.data[0]["Inv_AddressLine1"],
              SAAAddressLine2: data.data[0]["Inv_AddressLine2"],
              SAACityName: data.data[0]["Inv_CityName"],
              SAAStateId: data.data[0]["Inv_StateName"],
              SAACountryId: data.data[0]["Inv_CountryID"],
              SAAPincode: data.data[0]["Inv_Pincode"],
              SAAMobile1: data.data[0]["Inv_Mobile1"],
              SAAMobile2: data.data[0]["Inv_Mobile2"],
              SAATelephoneNumber: data.data[0]["Inv_Telephone"],
              SAAPrimaryEmailID: data.data[0]["Inv_PrimaryEmailID"],
              SAASecondaryEmailID: data.data[0]["Inv_SecondaryEmailID"],
              SAAWebsite: data.data[0]["Inv_Website"],
              registrationNumber: data.data[0]["CompanyRegistrationNo"],
              PANCardNo: data.data[0]["PanNo"],
              NameonPANCard: data.data[0]["NameOnPanCard"],
              GSTNo: data.data[0]["GSTNo"],
              TANNumber: data.data[0]["TanNo"],
              UINNumber: data.data[0]["UINNo"],
              ClientID: data.data[0]["ClientID"],
              accountName: data.data[0]["AccountName"],
              accountNo: data.data[0]["AccountNo"],
              accountType: data.data[0]["AccountType"],
              bankName: data.data[0]["BankName"],
              branchName: data.data[0]["BranchName"],
              IFSCCode: data.data[0]["IFSCCode"],
              clientUser: data.data[0]["UserID"],
              EventCordinatorName: data.data[0]["EventCordinatorName"],
              EventCordinatorDesignation:
                data.data[0]["EventCordinatorDesignation"],
              EventCordinatorEmail: data.data[0]["EventCordinatorEmail"],
              EventCordinatorMobile: data.data[0]["EventCordinatorMobile"],
              PrimaryContactName: data.data[0]["PrimaryContactName"],
              PrimaryContactDesignation:
                data.data[0]["PrimaryContactDesignation"],
              PrimaryContactEmail: data.data[0]["PrimaryContactEmail"],
              PrimaryContactMobile: data.data[0]["PrimaryContactMobile"],
            });
            const { countryList, countryId } = this.state;
            // for (var i = 0; i < countryList.length; i++) {

            //     if (data.data['data'][0]['CountryID'] == 1) {

            //         this.setState({ ISD: countryList[i]['ExtensionCode'] })
            //         setTimeout(() => {
            //             console.log("ISD", this.state.ISD)
            //         }, 300);
            //     }
            // }
            if (
              data.data[0]["Telephone"] != null &&
              data.data[0]["Telephone"].includes("-")
            ) {
              const concateData = data.data[0]["Telephone"].split("-");
              this.setState({
                preTel: concateData[0],
                AreaCode: concateData[1],
                TelephoneNumber: concateData[2],
              });
            } else {
              this.setState({ TelephoneNumber: data.data[0]["Telephone"] });
            }

            if (
              data.data[0]["Inv_Telephone"] != null &&
              data.data[0]["Inv_Telephone"].includes("-")
            ) {
              const concateData = data.data[0]["Inv_Telephone"].split("-");
              this.setState({
                SAAPreTel: concateData[0],
                SAAAreaCode: concateData[1],
                SAATelephoneNumber: concateData[2],
              });
            } else {
              this.setState({
                SAATelephoneNumber: data.data[0]["Inv_Telephone"],
              });
            }
            setTimeout(() => {
              countryList.map((itme) => {
                if (itme.Countryid == data.data[0]["CountryID"]) {
                  this.setState({ ISD: itme.ExtensionCode });
                }
                if (itme.Countryid == data.data[0]["Inv_CountryID"]) {
                  this.setState({ SAAISD: itme.ExtensionCode });
                }
              });
              this.getAdditionalServicesList();
              this.getBookingDetails();
            }, 500);
          } else {
            if (
              data.msg == sessionExpireMessage ||
              data.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              this.setState({ isLoading: false });
              toast.error(data.data, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
    const currencyArr = [...new Set(finalList.map((item) => item.currency))];
    const grandTotal = finalList.reduce(
      (total, item) => total + item.Price?.Total,
      0
    );
    this.setState({ grandTotal });

    if (currencyArr.length === 1) {
      this.setState({ finalCurrency: currencyArr[0] });
    }
  }
  getAdditionalServicesList() {
    const { orderDtlID } = this.state;
    const CenterID =
      this.props.location.state != null &&
        this.props.location.state.CenterID != null
        ? this.props.location.state.CenterID
        : "";
    const OrderID =
      this.props.location.state != null &&
        this.props.location.state.OrderID != null
        ? this.props.location.state.OrderID
        : "";
    // this.setState({ isLoading: true })
    this.props
      .get_additional_services_action(OrderID, CenterID)
      .then((data) => {
        if (data.error != 1) {
          // console.log("additionalServicesList1234", data.data['additionServices'])
          if (data.data["externalServices"] != "") {
            data.data["externalServices"].map((item) => {
              if (item.Qty == 0) {
                item.Qty = null;
              }
            });
            this.setState({
              externalServices: data.data["externalServices"],
            });
          }
          if (data.data["additionServices"] != "") {
            this.setState({
              CurrencyID: data.data["additionServices"][0]["CurrencyID"],
            });
          }
          if (data.data["otherData"] != "") {
            this.setState({
              unlistedAddServices:
                data.data["otherData"][0]["UnlistedAddServices"],
            });
          }
          if (data.data["includedServices"] != "") {
            this.setState({ includedServices: data.data["includedServices"] });
          }

          for (let i = 0; i < data.data["additionServices"].length; i++) {
            const filterData = data.data["additionServices"].filter(
              (item) => item.Name == data.data["additionServices"][i]["Name"]
            );

            if (filterData.length == 2) {
              data.data["additionServices"][i]["Disabled"] = 2;
            } else {
              data.data["additionServices"][i]["Disabled"] = 1;
            }

            if (filterData.length == 2) {
              filterData.map((item) => {
                if (item.IsSelected == 1) {
                  item.Is_SelectedServiceId = 1;
                }
              });
            }

            let checked = filterData.every((obj) => obj.IsSelected == 0);
            if (checked) {
              data.data["additionServices"][i]["Is_SelectedServiceId"] = 1;
            } else {
              if (data.data["additionServices"][i]["ServiceType"] == "S") {
                data.data["additionServices"][i]["Is_SelectedServiceId"] = 1;
              }
            }

            data.data['additionServices'].map((item) => {
              if (item.CurrencyID == 1) {
                const electricityFlag = item.Name.split(' ').includes('Electricity')
                if (electricityFlag) {
                  item.Amount = item.Amount != '' && item.Amount != null ? item.Amount : data.PriceInUSD != 0 ? (data.PriceInUSD) * 30 : ''
                } else {
                  item.Amount = item.Amount != '' && item.Amount != null ? item.Amount : data.PriceInINR != 0 ? (data.PriceInINR) : ''
                }
              } else {
                const electricityFlag = item.Name.split(' ').includes('Electricity')
                if (electricityFlag) {
                  item.Amount = item.Amount != '' && item.Amount != null ? item.Amount : data.PriceInUSD != 0 ? (data.PriceInUSD) * 30 : ''
                } else {
                  item.Amount = item.Amount != '' && item.Amount != null ? item.Amount : data.PriceInINR != 0 ? (data.PriceInINR) : ''
                }
              }
            })
          }
          const SelectedExtServiceData = data.data["externalServices"];
          const SelectedExtService = SelectedExtServiceData.filter(service => service.IsSelected === 1);

          console.log(SelectedExtService, "SelectedExtService")
          this.setState({
            SelectedExtService: SelectedExtService,
            additionalServicesList: data.data["additionServices"],
          });
          this.getVendorOrderDetails(SelectedExtService);
          if (data.data["materialList"] != '') {
            const selectedData = data.data["materialList"].map((item) => ({
              ServiceID: item.ServiceID,
              VendorID: item.VendorID,
              VendorServicesMaterialID: item.VendorServicesMaterialID
            }));
            console.log("data.data]", data.data["materialList"])
            this.setState(
              {
                SelectedExtService: selectedData,
              },
              () => {
                this.getpossesionList(selectedData);
                this.getExitList(selectedData);
              }
            );
          } else {
            const filteredServices = data.data["externalServices"].filter(
              (item) => item.IsSelected === 1
            );
            const selectedData = filteredServices.map((item) => ({
              ServiceID: item.ServiceID,
              VendorID: item.VendorID,
              VendorServicesMaterialID: null
            }));
            // Update the state with the filtered services
            this.setState(
              {
                SelectedExtService: selectedData,
              },
              () => {
                this.getpossesionList(selectedData);
                this.getExitList(selectedData);
              }
            );
          }
          this.setState({ isLoading: false });
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.data, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  getServiceVendorPackageDetail(serviceId, index) {
    const {
      orderDtlID,
      externalServices,
      dummyVendorPackageList,
      maxPrice,
      minPrice,
    } = this.state;
    const CenterID =
      this.props.location.state != null &&
        this.props.location.state.CenterID != null
        ? this.props.location.state.CenterID
        : "";
    const OrderID =
      this.props.location.state != null &&
        this.props.location.state.OrderID != null
        ? this.props.location.state.OrderID
        : "";
    this.setState({ isLoading: true });
    this.props
      .getServiceVendorPackageDetail_action(
        CenterID,
        serviceId,
        OrderID,
        minPrice,
        maxPrice
      )
      .then((data) => {
        if (data.error != 1) {
          if (data.data != "") {
            var array = [];
            data.data.map((item) => {
              item.index = index;
            });
            array = data.data;
            array.map((item) => {
              dummyVendorPackageList.push(item);
            });

            setTimeout(() => {
              const arrayOfObjects = this.removeDuplicatesFromArray(
                dummyVendorPackageList
              );
              this.setState({ dummyVendorPackageList: arrayOfObjects });

              const newObject = this.calculateFrequencyAndConvert(data.data);
              const array = [];
              data.data.map((item, i) => {
                if (!array.some((obj) => obj.VendorID == item.VendorID)) {
                  array.push({
                    name: item.CompanyName,
                    VendorID: item.VendorID,
                    isCollapsed: false,
                  });
                }
              });

              array.map((item, i) => {
                newObject.map((obj, i) => {
                  if (item.VendorID == obj.VendorID) {
                    item.frequency = newObject[i]["frequency"];
                  }
                });
              });
              console.log("newObject", newObject);
              console.log("data.data", data.data);
              console.log("array", array);

              if (data.price != "") {
                const priceArray = [];
                priceArray.push(
                  data.price[0]["MinPrice"],
                  data.price[0]["MaxPrice"]
                );
                console.log("priceArray--------", priceArray);

                this.setState({
                  SliderValue: priceArray,
                  minPrice: data.price[0]["MinPrice"],
                  maxPrice: data.price[0]["MaxPrice"],
                });
              }

              this.setState({
                vendorPackageList: data.data,
                vendorNameList: array,
              });
              console.log("vendorPackageList---", data.data);
            }, 100);

            this.setState({ indexOfExternalService: index, isLoading: false });
          } else {
            this.setState({
              isLoading: false,
              vendorPackageList: [],
              vendorNameList: [],
            });
          }
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.data, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  removeDuplicatesFromArray(arrayOfObjects) {
    // Create a map to store unique combinations of id and index
    let uniqueMap = {};

    // Filter out duplicates based on id and index
    let uniqueArray = arrayOfObjects.filter((obj) => {
      // Create a unique key based on id and index
      let key = obj.VendorID + "-" + obj.index;

      // If the key is not in the map, add it and return true (include in the result)
      if (!uniqueMap[key]) {
        uniqueMap[key] = true;
        return true;
      }

      // If the key is already in the map, return false (exclude from the result)
      return false;
    });

    return uniqueArray;
  }

  checkVendorPackageSelectedOrNot() {
    const { vendorPackageList } = this.state;

    const condition = vendorPackageList.some((item) => item.IsSelected == 1);

    return condition;
  }

  isQuantity(e, index, name, maxQantity) {
    const { additionalServicesList } = this.state;
    const cList = [...additionalServicesList];

    const event = e.target.value.replace(/\D/, "");

    const electricityFlag = name.split(" ").includes("Electricity");
    console.log("event electricityFlag", electricityFlag);

    cList.forEach((data, i) => {
      if (data.Name == name) {
        if (data.CurrencyID == 1) {
          if (event > 0) {
            if (maxQantity >= event) {
              if (electricityFlag) {
                data.Quantity = event;
                data.Amount = data.PriceInINR * 30 * event;
              } else {
                data.Quantity = event;
                data.Amount = data.PriceInINR * event;
              }
            } else {
              toastError(`Max Qantity is ${maxQantity}`);
              data.Amount = data.PriceInINR;
              data.Quantity = "";
            }
          } else {
            if (electricityFlag) {
              data.Quantity = "";
              data.Amount = data.PriceInINR * 30;
            } else {
              data.Quantity = "";
              data.Amount = data.PriceInINR;
            }
          }
        } else {
          if (event > 0) {
            if (maxQantity >= event) {
              if (electricityFlag) {
                data.Quantity = event;
                data.Amount = data.PriceInUSD * 30 * event;
              } else {
                data.Quantity = event;
                data.Amount = data.PriceInUSD * event;
              }
            } else {
              toastError(`Max Qantity is ${maxQantity}`);
              data.Amount = data.PriceInUSD;
              data.Quantity = "";
            }
          } else {
            if (electricityFlag) {
              data.Quantity = "";
              data.Amount = data.PriceInUSD * 30;
            } else {
              data.Quantity = "";
              data.Amount = data.PriceInUSD;
            }
          }
        }
      }
    });

    this.setState({
      additionalServicesList: cList,
    });
    // console.log("XXXXXXXX checkboxFlag XXXXXXX", cList)
  }
  isAmountQuantity(e, index, name, maxQantity) {
    const { additionalServicesList } = this.state;
    const cList = [...additionalServicesList];

    const event = e.target.value.replace(/\D/, '')

    const electricityFlag = name.split(' ').includes('Electricity')
    console.log("event electricityFlag", electricityFlag)

    cList.forEach((data, i) => {
      if (data.Name == name) {
        if (event != '') {
          data.Amount = event
        } else {
          data.Amount = ''
        }
      }
    });

    this.setState({
      additionalServicesList: cList,
    });
    // console.log("XXXXXXXX checkboxFlag XXXXXXX", cList)

  }

  externalServicesAdditionalRequirement(e, index) {
    const { externalServices } = this.state;
    const cList = [...externalServices];

    const event = e.target.value;

    cList.forEach((data, i) => {
      if (i === index) {
        data.AdditionalRequirement = event;
      }
    });

    this.setState({
      externalServices: cList,
    });
    // console.log("XXXXXXXX checkboxFlag XXXXXXX", cList)
  }

  externalServicesQuantity(e, index) {
    const { externalServices } = this.state;
    const cList = [...externalServices];

    const event = e.target.value.replace(/\D/, "");

    cList.forEach((data, i) => {
      if (i === index) {
        if (event != "") {
          data.Qty = event;
        } else {
          data.Qty = "";
        }
      }
    });

    this.setState({
      externalServices: cList,
    });
    // console.log("XXXXXXXX checkboxFlag XXXXXXX", cList)
  }

  includedServicesCheckbox(index, IsSelected, e) {
    const { includedServices } = this.state;
    const cList = [...includedServices];
    const event = e.target.checked;

    cList.forEach((data, i) => {
      if (i === index) {
        if (IsSelected == 0) {
          data.IsSelected = 1;
        } else {
          data.IsSelected = 0;
        }
      }
    });

    this.setState({
      includedServices: cList,
    });
    // console.log("XXXXXXXX checkboxFlag XXXXXXX", cList)
  }

  externalServicesCheckbox(index, IsSelected, e) {
    const { externalServices } = this.state;
    const cList = [...externalServices];
    const event = e.target.checked;

    cList.forEach((data, i) => {
      if (i === index) {
        if (IsSelected == 0) {
          data.IsSelected = 1;
        } else {
          data.IsSelected = 0;
          data.Qty = "";
          data.Package = null;
          data.Price = 0;
          data.PackageID = 0;
          data.VendorName = "";
          data.AdditionalRequirement = "";
          data.VendorID = "";
          this.clearPackageValue();
        }
      }
    });

    this.setState({
      externalServices: cList,
    });
  }
  clearPackageValue() {
    const { vendorPackageList, externalServices, indexOfExternalService } =
      this.state;

    if (vendorPackageList != "" && vendorPackageList.length > 0) {
      vendorPackageList.map((item) => {
        item.IsSelected = 0;
      });
      this.setState({ vendorPackageList: vendorPackageList });
    }

    // externalServices.map((item, i) => {
    //     if (i === indexOfExternalService) {
    //         item.Package = null
    //         item.Price = 0
    //         item.PackageID = 0
    //         item.VendorName = ''
    //         item.AdditionalRequirement = ''
    //         item.VendorID = ''
    //     }
    // })
  }

  checkbox(index, IsSelected, e) {

    const { additionalServicesList } = this.state;
    const cList = [...additionalServicesList];
    const event = e.target.checked
    cList.forEach((data, i) => {
      if (i === index) {
        const electricityFlag = data.Name.split(' ').includes('Electricity')
        if (data.CurrencyID == 1) {
          if (IsSelected == 0) {
            if (electricityFlag) {
              data.IsSelected = 1
              if (data.Name != 'Event Services') {
                data.Quantity = 1
              }
              data.Amount = data.PriceInINR != 0 ? (data.PriceInINR) * 30 : ''
            } else {
              data.IsSelected = 1
              if (data.Name != 'Event Services') {
                data.Quantity = 1
              }
              data.Amount = data.PriceInINR != 0 ? (data.PriceInINR) : ''
            }
          } else {
            if (electricityFlag) {
              data.IsSelected = 0
              data.Quantity = ''
            } else {
              data.IsSelected = 0
              data.Quantity = ''
            }
          }
        } else {
          if (IsSelected == 0) {
            if (electricityFlag) {
              data.IsSelected = 1
              data.Quantity = 1
              data.Amount = data.PriceInUSD != 0 ? (data.PriceInUSD) * 30 : ''
            } else {
              data.IsSelected = 1
              data.Quantity = 1
              data.Amount = data.PriceInUSD != 0 ? (data.PriceInUSD) : ''
            }
          } else {
            if (electricityFlag) {
              data.IsSelected = 0
              data.Quantity = ''
            } else {
              data.IsSelected = 0
              data.Quantity = ''
            }
          }
        }
      }
    });

    this.setState({
      additionalServicesList: cList,
    });
    console.log("XXXXXXXX checkboxFlag XXXXXXX", cList)

  }

  onServicetypechange(e, index, name, Quantity) {
    const { additionalServicesList } = this.state;
    const cList = [...additionalServicesList];
    const event = e.target.value;
    console.log("event", event[0].toString());
    var List;

    cList.forEach((data, i) => {
      // if (i === index) {
      if (data.Name == name) {
        console.log(data.ServiceType);

        if (data.ServiceType == event[0].toString()) {
          // console.log('sdgfsd');

          data.Is_SelectedServiceId = 1;
          data.IsSelected = 1;
          // console.log("data.Quantity", Quantity)
          data.Quantity = Quantity;
          this.setState({
            additionalServicesList: cList,
          });
        } else {
          // console.log('sdgfqweqsd');
          data.Is_SelectedServiceId = 0;
          data.IsSelected = 0;
          this.setState({
            additionalServicesList: cList,
          });
        }

        console.log("data", data);
      }
      // }
    });

    this.setState({
      additionalServicesList: cList,
    });
    console.log("XXXXXXXX onServicetypechange XXXXXXX", cList);
  }

  handleKeyDown(e) {
    if (e.code === "Enter") {
      this.handleSubmit(e);
    }
  }

  vendorPackageCheckbox(index, IsSelected, e) {
    const {
      vendorPackageList,
      indexOfExternalService,
      externalServices,
      dummyVendorPackageList,
    } = this.state;
    const cList = [...vendorPackageList];
    const event = e.target.checked;
    console.log("event----", event);

    cList.forEach((data, i) => {
      if (i === index) {
        if (event) {
          data.IsSelected = 1;
          dummyVendorPackageList.map((obj) => {
            if (
              obj.VendorServicesPackageID == data.VendorServicesPackageID &&
              obj.index == data.index
            ) {
              obj.IsSelected = 1;
            } else {
              obj.IsSelected = 0;
            }
          });
          externalServices.map((item, i) => {
            if (i === indexOfExternalService) {
              item.Package = data.Package;
              item.Price = data.Rate;
              item.PackageID = data.VendorServicesPackageID;
              item.VendorName = data.VendorName;
              item.CompanyName = data.CompanyName;
              item.VendorID = data.VendorID;
            }
          });
          this.setState({
            externalServices: externalServices,
            dummyVendorPackageList: dummyVendorPackageList,
          });
        } else {
          data.IsSelected = 0;
          data.Description = "";
          dummyVendorPackageList.map((obj) => {
            if (
              obj.VendorServicesPackageID == data.VendorServicesPackageID &&
              obj.index == data.index
            ) {
              obj.IsSelected = 0;
            }
          });
          externalServices.map((item, i) => {
            if (i === indexOfExternalService) {
              item.Package = null;
              item.Price = 0;
              item.PackageID = 0;
              item.VendorName = "";
              item.CompanyName = "";
              item.VendorID = "";
            }
          });
          this.setState({
            externalServices: externalServices,
            dummyVendorPackageList: dummyVendorPackageList,
          });
        }
      } else {
        data.IsSelected = 0;
      }
    });
    setTimeout(() => {
      console.log("vendorPackageList---", cList);
    }, 200);

    this.setState({
      vendorPackageList: cList,
    });
  }

  additionRequirement(item) {
    const { externalServices, addRequirementID } = this.state;
    externalServices.map((data) => {
      if (addRequirementID == data.ServiceID) {
        if (data != "") {
          data.AdditionalRequirement = item;
        } else {
          data.AdditionalRequirement = "";
        }
      }
    });

    this.setState({ externalServices: externalServices });
  }

  onPrice(e, type) {
    const { minPrice, maxPrice } = this.state;
    const event = e.target.value.replace(/\D/, "");
    if (type == "min") {
      if (event <= maxPrice) {
        this.setState({ minPrice: event, SliderValue: [event, maxPrice] });
      }
    } else {
      if (event >= minPrice) {
        this.setState({ maxPrice: event, SliderValue: [minPrice, event] });
      }
    }
  }

  calculateFrequencyAndConvert(data) {
    const frequencyMap = {};
    data.forEach((obj) => {
      const value = obj.VendorID;
      frequencyMap[value] = (frequencyMap[value] || 0) + 1;
    });
    const result = [];
    for (const key in frequencyMap) {
      result.push({ frequency: frequencyMap[key], VendorID: parseInt(key) });
    }

    return result;
  }
  onSliderHandleChange(e, value) {
    const { } = this.state;
    this.setState({ minPrice: value[0], maxPrice: value[1] });
    setTimeout(() => {
      this.onSearchPackage();
    }, 200);
  }

  toggleCollapseAdditionalService(isCollapsed, index) {
    const { vendorNameList } = this.state;

    // const $content = $('#collapseContent');

    vendorNameList.map((item, i) => {
      if (i === index) {
        if (!isCollapsed) {
          item.isCollapsed = true;
        } else {
          item.isCollapsed = false;
        }
      }
    });

    this.setState({ vendorNameList: vendorNameList });

    // if (!isCollapsed) {
    //     $content.slideDown();
    // } else {
    //     $content.slideUp();
    // }
  }

  toggleChat = (VendorCompany, ServiceName, OrderID, VendorID, ServiceID) => {
    console.log(
      VendorCompany,
      ServiceName,
      OrderID,
      VendorID,
      ServiceID,
      "toggleChat"
    );
    const { isChatOpen } = this.state;
    this.setState((prevState) => ({
      isChatOpen: !prevState.isChatOpen,
    }));

    if (isChatOpen == true) {
      clearInterval(this.chatInterval);
      this.setState({
        chatServiceName: "",
        chatVendorCompany: "",
        chat: "",
        chatVendorID: "",
        chatServiceID: "",
        chatOrderID: "",
        chatDtl: [],
      });
    } else {
      this.setState({
        chatVendorCompany: VendorCompany,
        chatServiceName: ServiceName,
        chatVendorID: VendorID,
        chatServiceID: ServiceID,
        chatOrderID: OrderID,
      });
      this.setState({ isChatLoading: true });
      setTimeout(() => {
        this.setState({ isChatLoading: false });
      }, 3000);
      this.chatInterval = setInterval(() => {
        this.props
          .chat_detail_action(OrderID, ServiceID, VendorID)
          .then((data) => {
            // Handle the response data

            if (data.error !== 1) {
              this.setState({
                chatHdr: data.chatHdr,
                chatDtl: data.chatDtl,
              });
              console.log("chat", data);
            } else {
              // Handle error messages
              if (
                data.msg == sessionExpireMessage ||
                data.msg == tokenInavlidMessage
              ) {
                //after session expire.....................
                sessionStorage.clear();
                this.props.navigate("/normalView");
                setTimeout(() => {
                  toast.error(data.msg, {
                    position: "top-center",
                    theme: "colored",
                    autoClose: 3000,
                    hideProgressBar: true,
                  });
                }, 500);
              } else {
                toast.error(data.data, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }, 3000);
      console.log("chatTrue");
    }
  };

  sendMessage = (OrderID, VendorID, ServiceID) => {
    const { chat } = this.state;
    if (chat.trim() === "") {
      toast.error("Kindly enter message", {
        position: "top-center",
        theme: "colored",
        hideProgressBar: true,
        autoClose: 3000,
      });
    } else {
      this.props
        .insert_chat_action(OrderID, VendorID, ServiceID, chat, 1)
        .then((data) => {
          console.log(data, "chat submitted");
          if (data.error !== 1) {
            this.setState({ chat: "" });
            // toast.success("Chat Submitted Successfully", {
            //   theme: "colored",
            //   position: "top-center",
            //   autoClose: 3000,
            //   hideProgressBar: true,
            // });
          } else {
            if (
              data.msg == sessionExpireMessage ||
              data.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  //booking details
  getBookingDetails() {
    const { OrderID } = this.state;

    console.log("OrderID id", OrderID);
    this.setState({ isLoading: true });
    this.props
      .get_booking_Details_action(OrderID)
      .then((data) => {
        if (data.error != 1) {
          const BookingEventDataList = data.data["tableData"].map((item) => {
            return {
              EventStartDate: item.EventStartDate,
              EventEndDate: item.EventEndDate,
              EventStartTime: item.EventStartTime,
              EventEndTime: item.EventEndTime,
            };
          });

          console.log(BookingEventDataList);

          this.setState(
            {
              TypeOfEvent: data.data["data"][0]["TypeOfEvent"],
              SittingArrangement: data.data["data"][0]["SittingType"],
              bookingList: data.data["tableData"],
              BookingEventDataList: BookingEventDataList,
              // possesion
              PossesionStartDate:
                data.data["tableData"][0]["PossessionStartDate"] != "" &&
                  data.data["tableData"][0]["PossessionStartDate"] != null
                  ? moment(
                    data.data["tableData"][0]["PossessionStartDate"],
                    "YYYY-MM-DD"
                  ).format("DD/MM/YYYY") // Format the date to "DD/MM/YYYY"
                  : "",
              PossesionEndDate:
                data.data["tableData"][0]["PossessionEndDate"] != "" &&
                  data.data["tableData"][0]["PossessionEndDate"] != null
                  ? moment(
                    data.data["tableData"][0]["PossessionEndDate"],
                    "YYYY-MM-DD"
                  ).format("DD/MM/YYYY") // Format the date to "DD/MM/YYYY"
                  : "",
              PossesionStartTime:
                data.data["tableData"][0]["PossessionStartTime"] != "" &&
                  data.data["tableData"][0]["PossessionStartTime"] != null
                  ? data.data["tableData"][0]["PossessionStartTime"]
                  : "",
              PossesionEndTime:
                data.data["tableData"][0]["PossessionEndTime"] != "" &&
                  data.data["tableData"][0]["PossessionEndTime"] != null
                  ? data.data["tableData"][0]["PossessionEndTime"]
                  : "",

              // Dismantle
              dismantleStartDate:
                data.data["tableData"][0]["DismentalStartDate"] != "" &&
                  data.data["tableData"][0]["DismentalStartDate"] != null
                  ? moment(
                    data.data["tableData"][0]["DismentalStartDate"],
                    "YYYY-MM-DD"
                  ).format("DD/MM/YYYY") // Format the date to "DD/MM/YYYY"
                  : "",
              dismantleEndDate:
                data.data["tableData"][0]["DismentalEndDate"] != "" &&
                  data.data["tableData"][0]["DismentalEndDate"] != null
                  ? moment(
                    data.data["tableData"][0]["DismentalEndDate"],
                    "YYYY-MM-DD"
                  ).format("DD/MM/YYYY") // Format the date to "DD/MM/YYYY"
                  : "",
              dismantleStartTime:
                data.data["tableData"][0]["DismentalStartTime"] != "" &&
                  data.data["tableData"][0]["DismentalStartTime"] != null
                  ? data.data["tableData"][0]["DismentalStartTime"]
                  : "",
              dismantleEndTime:
                data.data["tableData"][0]["DismentalEndTime"] != "" &&
                  data.data["tableData"][0]["DismentalEndTime"] != null
                  ? data.data["tableData"][0]["DismentalEndTime"]
                  : "",
            },
            () => {
              console.log(
                this.state.dismantleStartDate,
                "dismantleStartDate ---- 1234"
              );
            }
          );

          if (
            data.data["data"][0]["SittingTypeID"] != "" &&
            data.data["data"][0]["SittingTypeID"] != null
          ) {
            this.setState({ NoOfPAXFlag: false });
          } else {
            this.setState({ NoOfPAXFlag: true, NoofPAX: "" });
          }

          this.setState({
            MembershipFilePath: data.data["data"][0]["MembershipFilePath"],
          });

          for (let i = 0; i < data.data["tableData"].length; i++) {
            if (data.data["tableData"].length - 1 == i) {
              this.setState({
                LastDate: data.data["tableData"][i]["Date"],
              });

              // this.setState({ LastDate: data.data['recordsets'][1] != '' ? moment(data.data['recordsets'][1][i]['Date']).format('DD-MM-YYYY') : <></> })
            }
          }
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.data, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  //Checklist Details
  toggleCollapse(isCollapsed, index) {
    const { possessionMaterialNameAndServiceName } = this.state

    // const $content = $('#collapseContent');

    possessionMaterialNameAndServiceName.map((item, i) => {
      if (i === index) {
        if (!isCollapsed) {
          item.isCollapsed = true
        } else {
          item.isCollapsed = false
        }
      } else {
        item.isCollapsed = false
      }
    })

    this.setState({ possessionMaterialNameAndServiceName: possessionMaterialNameAndServiceName })
  };
  toggleCollapse2(isCollapsed, index) {
    const { exitMaterialNameAndServiceName } = this.state

    // const $content = $('#collapseContent');

    exitMaterialNameAndServiceName.map((item, i) => {
      if (i === index) {
        if (!isCollapsed) {
          item.isCollapsed = true
        } else {
          item.isCollapsed = false
        }
      } else {
        item.isCollapsed = false
      }
    })

    this.setState({ exitMaterialNameAndServiceName: exitMaterialNameAndServiceName })
  };
  getpossesionList(VendorIdAndServiceIdList) {
    const { userId, OrderID, CenterID, existDataListFlag } = this.state;
    this.setState({ isLoading: true });
    // Assuming that this.props.order_edit_details returns a Promise
    if (OrderID != null) {
      this.props
        .get_possession_list_action(
          CenterID,
          OrderID,
          VendorIdAndServiceIdList != "" ? VendorIdAndServiceIdList : null
        )
        .then((data) => {
          if (data.error !== 1) {
            this.setState({
              isLoading: false,
              possessionIncludedServicesList:
                data.data["possesionIncludedServices"],
              possessionCheckList: data.data["possessionCheckList"],
              PossesionSubmittedUser:
                data.data["data"] != ""
                  ? data.data["data"][0]["PossesionSubmittedUser"]
                  : "",
              PossesionSubmittedDate:
                data.data["data"] != ""
                  ? data.data["data"][0]["PossessionSubmittedDate"]
                  : "",
              possessionTime:
                data.data["data"] != ""
                  ? data.data["data"][0]["PossessionSubmittedDate"]
                  : new Date(
                    new Date().getTime() -
                    new Date().getTimezoneOffset() * 60000
                  ).toISOString(),
              possessionVendorList: data.data["vendorList"],
              electricityPossesion:
                data.data["data"] != ""
                  ? data.data["data"][0]["PossessionElectricityUnit"]
                  : "",
              PossessionContactNameAndNumber:
                data.data["data"] != ""
                  ? data.data["data"][0]["PossessionContactNameAndNumber"]
                  : "",
              PosssesionOperationNameContact: data.data['data'] != '' ? data.data['data'][0]['PosssesionOpeartionNameContact'] : '',
              PossessionSecurityChecklistNote:
                data.data["data"] != ""
                  ? data.data["data"][0]["PossessionSecurityChecklistNote"]
                  : "",
              possessionConsumableList: data.data["consumableList"],
              possessionSecurityList: data.data["securityList"],
            });
            if (data.data["materialList"] != "") {
              data.data["materialList"].map((item) => {
                item.isCollapsed = false;
              });
              const arrayOfObjects = this.removeDuplicatesFromArray(
                data.data["materialList"]
              );
              // console.log("possessionMaterialList--", data.data['materialList'])
              // console.log("arrayOfObjects--", arrayOfObjects)
              this.setState({
                possessionMaterialNameAndServiceName: arrayOfObjects,
                possessionMaterialList: data.data["materialList"],
              });
            }
            if (existDataListFlag) {
              this.setState({
                electricityExit:
                  data.data["data"] != ""
                    ? data.data["data"][0]["PossessionElectricityUnit"]
                    : "",
              });
            }
            console.log(":data.data['vendorList']", data.data["vendorList"]);
            data.data["possessionInhouseServices"] != "" ? (
              data.data["possessionInhouseServices"].map((item) => {
                if (item.ServiceType == "S") {
                  this.state.possessionInhouseServicesList.push(item);
                }
              })
            ) : (
              <></>
            );

            if (
              data.data["possessionImg"] != [] &&
              data.data["possessionImg"] != ""
            ) {
              const dataURL =
                "data:image/png;base64," + data.data["possessionImg"];
              this.setState({ possessionSignatureData: dataURL });
              this.setState({
                possessionDataListFlag: true,
                possessionCheckListAllSelected: true,
              });
            }
            if (data.data['possessionOppImg'] != [] && data.data['possessionOppImg'] != '') {
              const dataURL = 'data:image/png;base64,' + data.data['possessionOppImg']
              this.setState({ oppPossessionSignatureData: dataURL, oppIsSignatureSaved: true });
            }
          } else {
            if (
              data.msg == sessionExpireMessage ||
              data.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              toastError(data.msg);
              this.setState({ isLoading: false });
            }
          }
        })
        .catch((err) => {
          console.error(err); // Logging the error for debugging
          this.setState({ isLoading: false });
        });
    } else {
      this.props.navigate("/orders");
    }
  }
  getExitList(VendorIdAndServiceIdList) {
    const { userId, OrderID, CenterID } = this.state;
    this.setState({ isLoading: true });
    // Assuming that this.props.order_edit_details returns a Promise
    if (OrderID != null) {
      this.props
        .get_exist_list_action(
          CenterID,
          OrderID,
          VendorIdAndServiceIdList != "" ? VendorIdAndServiceIdList : null
        )
        .then((data) => {
          if (data.error !== 1) {
            if (data.data["ExitSubmittedUser"] != undefined) {
              this.setState({
                ExitSubmittedUser: data.data["ExitSubmittedUser"],
                ExitSubmittedDate: data.data["ExitSubmittedDate"],
                exitTime: data.data["ExitSubmittedDate"],
              });
            }

            this.setState({
              isLoading: false,
              exitInstructionList: data.data["ExitCheckList"],
              exitVendorList: data.data["VendorList"],
              unlistedAddServices: data.data["ExitRemark"],
              AdditionHours:
                data.data["data"] != ""
                  ? data.data["data"][0]["AdditionHours"]
                  : "",
              electricityExit:
                data.data["data"] != ""
                  ? data.data["data"][0]["ExitElectricityUnit"]
                  : "",
              ExitContactNameAndNumber:
                data.data["data"] != ""
                  ? data.data["data"][0]["ExitContactNameAndNumber"]
                  : "",
              ExitOperationNameContact: data.data['data'] != '' ? data.data['data'][0]['ExitOperationNameContact'] : '',

              ExitSecurityChecklistNote:
                data.data["data"] != ""
                  ? data.data["data"][0]["ExitSecurityChecklistNote"]
                  : "",
              exitConsumableList: data.data["consumableList"],
              exitSecurityList: data.data["securityList"],
              FinalExitSubmit: data.data["data"][0]["FinalExitSubmit"]
            });
            if (data.data["materialList"] != "") {
              data.data["materialList"].map((item) => {
                item.isCollapsed = false;
              });
              const arrayOfObjects = this.removeDuplicatesFromArray(
                data.data["materialList"]
              );
              console.log("arrayOfObjects", arrayOfObjects);
              this.setState({
                exitMaterialNameAndServiceName: arrayOfObjects,
                exitMaterialList: data.data["materialList"],
              });
            }

            data.data["ExitIncludedServices"] != "" ? (
              data.data["ExitIncludedServices"].map((item) => {
                if (item.IsSelected == 1) {
                  item.Is_checked = 1;
                } else {
                  item.Is_checked = 0;
                }
              })
            ) : (
              <></>
            );

            this.setState({
              exitIncludedServicesList: data.data["ExitIncludedServices"],
            });

            const list = [];
            data.data["ExitInhouseServices"] != "" ? (
              data.data["ExitInhouseServices"].map((item) => {
                if (item.ServiceType == "S") {
                  if (item.IsSelected == 1) {
                    item.Is_checked = 1;
                  } else {
                    item.Is_checked = 0;
                  }
                  list.push(item);
                }
              })
            ) : (
              <></>
            );
            this.setState({ exitInhouseServicesList: list });

            if (
              data.data["ExitFilePath"] != "" &&
              data.data["ExitFilePath"] != []
            ) {
              const dataURL =
                "data:image/png;base64," + data.data["ExitFilePath"];
              this.setState({
                ExitSignatureData: dataURL,
                isSignatureSaved2: true,
              });
              if (data.data["data"][0]["FinalExitSubmit"]) {
                this.setState({
                  exitCheckListAllSelected: true,
                  existDataListFlag:
                    data.data["ExitFilePath"] != "" ? true : false,
                });
              } else {
                const checked = data.data["ExitCheckList"].every(
                  (item) => item.IsSelected == 1
                );
                if (checked) {
                  this.setState({ exitCheckListAllSelected: true });
                } else {
                  this.setState({ exitCheckListAllSelected: false });
                }
              }
            }
            if (data.data['oppExitFilePath'] != '' && data.data['oppExitFilePath'] != []) {
              const dataURL = 'data:image/png;base64,' + data.data['oppExitFilePath']
              this.setState({ oppExitSignatureData: dataURL, oppIsSignatureSaved2: true });
            }
          } else {
            if (
              data.msg == sessionExpireMessage ||
              data.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/login");
              setTimeout(() => {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              toastError(data.msg);
              this.setState({ isLoading: false });
            }
          }
        })
        .catch((err) => {
          console.error(err); // Logging the error for debugging
          this.setState({ isLoading: false });
        });
    } else {
      this.props.navigate("/orders");
    }
  }
  //vendor section
  getVendorOrderDetails(SelectedExtService) {
    const { OrderID } = this.state;

    console.log(SelectedExtService, "SelectedExtService from")
    this.setState({ isLoading: true });

    // Create an array of promises for each API call
    const promises = SelectedExtService.map((sItem) => {
      return this.props
        .thirdParty_VendorOrder_detail_action(
          OrderID,
          sItem.ServiceID,
          sItem.VendorID
        )
        .then((data) => {
          let signatureData = null;
          if (
            data.VendorOrderDtl["OrderAcceptedbyClientSignature"] &&
            data.VendorOrderDtl["OrderAcceptedbyClientSignature"] !== ""
          ) {
            const dataURL =
              "data:image/png;base64," +
              data.VendorOrderDtl["OrderAcceptedbyClientSignature"];
            signatureData = dataURL;
          }
          return {
            ServiceName: data.VendorOrderDtl.ServiceName,
            ClientName: data.VendorOrderDtl.ClientName,
            VendorCompany: data.VendorOrderDtl.VendorCompany,
            VendorEmail: data.VendorOrderDtl.VendorEmail,
            VendorOrderDtlID: data.VendorOrderDtl.VendorOrderDtlID,
            OrderID: data.VendorOrderDtl.OrderID,
            VendorID: data.VendorOrderDtl.VendorID,
            ServiceID: data.VendorOrderDtl.ServiceID,
            IsOrderAcceptedbyVendor:
              data.VendorOrderDtl.IsOrderAcceptedbyVendor,
            quotationFilePath: data.VendorOrderDtl.quotationFilePath,
            IsQuotationSubmitted: data.VendorOrderDtl.IsQuotationSubmitted,
            IsQuotationApproved: data.VendorOrderDtl.IsQuotationApproved,
            FinalAmount: data.VendorOrderDtl.FinalAmount,
            invoiceFilePath: data.VendorOrderDtl.invoiceFilePath,
            IsInvoiceSubmitted: data.VendorOrderDtl.IsInvoiceSubmitted,
            IsFinalInvoiceSubmitted:
              data.VendorOrderDtl.IsFinalInvoiceSubmitted,
            IsPaymentReceived: data.VendorOrderDtl.IsPaymentReceived,
            receiptFilePath: data.VendorOrderDtl.receiptFilePath,
            AdditionalAmount: data.VendorOrderDtl.AdditionalAmount,
            IsOrderAcceptedbyClient:
              data.VendorOrderDtl.IsOrderAcceptedbyClient,
            additionalInvoiceFilePath:
              data.VendorOrderDtl.additionalInvoiceFilePath,
            additionalReceiptFilePath:
              data.VendorOrderDtl.additionalReceiptFilePath,
            Package: data.VendorOrderDtl.Package,
            OrderAcceptedbyClientContact:
              data.VendorOrderDtl.OrderAcceptedbyClientContact,
            OrderAcceptedbyClientSignatureBy:
              data.VendorOrderDtl.OrderAcceptedbyClientSignatureBy,
            OrderAcceptedbyClientSignatureDate:
              data.VendorOrderDtl.OrderAcceptedbyClientSignatureDate,
            OrderAcceptedbyClientSignature: signatureData,
          };
        })
        .catch((error) => {
          console.error("Error fetching vendor order details:", error);
          return null; // Return null if there's an error fetching data
        });
    });

    Promise.all(promises)
      .then((dataArray) => {
        // Filter out null values and update the state
        const filteredDataArray = dataArray.filter((data) => data !== null);
        this.setState((prevState) => ({
          ThirdPartyVendorOrderList: [
            ...prevState.ThirdPartyVendorOrderList,
            ...filteredDataArray,
          ],
          isLoading: false,
        }));
      })
      .catch((error) => {
        console.error("Error fetching vendor order details:", error);
        this.setState({ isLoading: false });
        // Handle errors if necessary
      });
  }
  submitVendorUploads(
    submitType,
    IsQuotationApproved,
    VendorOrderDtlID,
    IsOrderAcceptedbyVendor,
    quotationFilePath
  ) {
    const {
      OrderNo,
      ClientName,
      ClientEmail,
      VendorCompany,
      VendorEmail,
      BookingDate,
      OrderDtlID,
      ServiceID,
      VendorServicesPackageID,
      FinalAmount,
      AdditionalAmount,
      quotationFileName,
      quotationFileType,
      quotationFormFile,
      invoiceFilePath,
      invoiceFileName,
      invoiceFileType,
      invoiceFormFile,
      receiptFilePath,
      receiptFileName,
      receiptFileType,
      receiptFormFile,
      additionalInvoiceFilePath,
      additionalInvoiceFileName,
      additionalInvoiceFileType,
      additionalInvoiceFormFile,
      additionalReceiptFilePath,
      additionalReceiptFileName,
      additionalReceiptFileType,
      additionalReceiptFormFile,
      OrderID,
      VendorID,
      IsPaymentReceived,
      IsQuotationSubmitted,
      IsOrderAcceptedbyClient,
      IsInvoiceSubmitted,
      FinalPaymentReceived,
      IsFinalInvoiceSubmitted,
      nodeMailFlag,
    } = this.state;

    this.setState({ isLoading: false });

    let isQuotationApproved = IsQuotationApproved;
    let NodeMailFlag = nodeMailFlag;

    if (submitType == "acceptQuoClient") {
      console.log("yes");
      isQuotationApproved = true;
      NodeMailFlag = "acceptQuoClient";
    } else if (submitType == "rejectQuoClient") {
      isQuotationApproved = false;
      NodeMailFlag = "rejectQuoClient";
    }
    this.props
      .insertUpdate_thirdParty_vendorOrderDtl_action(
        OrderNo,
        ClientName,
        ClientEmail,
        VendorCompany,
        VendorEmail,
        BookingDate,
        VendorOrderDtlID,
        OrderDtlID,
        ServiceID,
        VendorServicesPackageID,
        FinalAmount,
        AdditionalAmount,
        IsOrderAcceptedbyVendor,
        IsOrderAcceptedbyClient,
        IsQuotationSubmitted,
        isQuotationApproved,
        IsInvoiceSubmitted,
        IsPaymentReceived,
        IsFinalInvoiceSubmitted,
        FinalPaymentReceived,
        quotationFilePath,
        quotationFileName,
        quotationFileType,
        quotationFormFile,
        invoiceFilePath,
        invoiceFileName,
        invoiceFileType,
        invoiceFormFile,
        receiptFilePath,
        receiptFileName,
        receiptFileType,
        receiptFormFile,
        additionalInvoiceFilePath,
        additionalInvoiceFileName,
        additionalInvoiceFileType,
        additionalInvoiceFormFile,
        additionalReceiptFilePath,
        additionalReceiptFileName,
        additionalReceiptFileType,
        additionalReceiptFormFile,
        OrderID,
        VendorID,
        NodeMailFlag
      )
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          toast.success("Submitted Successfully", {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
          window.location.reload();
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  // search city
  onCitytSearch(e) {
    const {
      cityList,
      tempCityList,
      billTempCityList,
      cityId,
      countryId,
      SameAsAbove,
    } = this.state;
    if (countryId == "91" || countryId == "" || countryId == "Country*") {
      if (e.target.value != "") {
        var searchCityList = tempCityList.filter((data) => {
          return data.CityName.toLowerCase().includes(
            e.target.value.toLowerCase()
          );
        });
        this.setState({
          cityId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          CityNameErr: "",
          tempCityList: searchCityList,
          isDisplayCityList: true,
        });
      } else {
        this.setState({
          cityId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          tempCityList: cityList,
          isDisplayCityList: false,
        });
      }
      if (SameAsAbove) {
        this.setState({
          SAACityId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAACityNameErr: "",
        });
      }
    } else {
      this.setState({
        cityId: e.target.value
          .replace(/[^a-zA-Z ]/g, "")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        isDisplayCityList: false,
        CityNameErr: "",
      });
      if (SameAsAbove) {
        this.setState({
          SAACityId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAACityNameErr: "",
        });
      }
    }
  }

  // render city
  renderCityList() {
    const { tempCityList } = this.state;
    return (
      <ul
        class="list-group pincode-drop"
        style={{ position: "absolute", zIndex: 100 }}
      >
        {tempCityList.length > 0 &&
          tempCityList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={() => this.mainCityListData(data)}
            >
              {data.CityName}
            </li>
          ))}
      </ul>
    );
  }

  mainCityListData(data) {
    const { SameAsAbove } = this.state;
    this.setState({
      cityId: data.CityName,
      isDisplayCityList: false,
      CityNameErr: "",
    });

    if (SameAsAbove) {
      this.setState({ SAACityId: data.CityName, SAACityNameErr: "" });
    }
  }
  // same as above search city
  onSAACitytSearch(e) {
    const {
      SAACityList,
      SAAtempCityList,
      billTempCityList,
      cityId,
      SAACountryId,
    } = this.state;
    if (
      SAACountryId == "91" ||
      SAACountryId == "" ||
      SAACountryId == "Country*"
    ) {
      console.log("SAAtempCityList +++++++++++++++++", SAAtempCityList);
      if (e.target.value != "") {
        var searchCityList = SAAtempCityList.filter((data) => {
          return data.CityName.toLowerCase().includes(
            e.target.value.toLowerCase()
          );
        });
        this.setState({
          SAACityId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAACityNameErr: "",
          SAAtempCityList: searchCityList,
          isSAADisplayCityList: true,
        });
      } else {
        this.setState({
          SAACityId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAAtempCityList: SAACityList,
          isSAADisplayCityList: false,
        });
      }
    } else {
      this.setState({
        SAACityNameErr: "",
        SAACityId: e.target.value
          .replace(/[^a-zA-Z ]/g, "")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        isSAADisplayCityList: false,
      });
    }
  }
  // same as above render city
  renderSAACityList() {
    const { SAAtempCityList } = this.state;
    return (
      <ul
        class="list-group pincode-drop"
        style={{ position: "absolute", zIndex: 100 }}
      >
        {SAAtempCityList.length > 0 &&
          SAAtempCityList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={() => this.mainSAACityListData(data)}
            >
              {data.CityName}
            </li>
          ))}
      </ul>
    );
  }
  mainSAACityListData(data) {
    this.setState({
      SAACityId: data.CityName,
      isSAADisplayCityList: false,
      SAACityNameErr: "",
    });
  }
  // search State
  onStateSearch(e) {
    const { stateList, tempStateList, SameAsAbove, countryId } = this.state;
    console.log("countryId -------------------onStateSearch", countryId);
    if (countryId == "91" || countryId == "" || countryId == "Country*") {
      if (e.target.value != "") {
        var searchStateList = tempStateList.filter((data) => {
          return data.Description.toLowerCase().includes(
            e.target.value.toLowerCase()
          );
        });
        this.setState({
          stateId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          stateErr: "",
          tempStateList: searchStateList,
          isDisplayStateList: true,
        });
      } else {
        this.setState({
          stateId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          stateErr: "",
          tempStateList: stateList,
          isDisplayStateList: false,
        });
      }
      if (SameAsAbove) {
        this.setState({
          SAAStateId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAAStateErr: "",
        });
      }
    } else {
      this.setState({
        stateId: e.target.value
          .replace(/[^a-zA-Z ]/g, "")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        isDisplayStateList: false,
        stateErr: "",
      });
      if (SameAsAbove) {
        this.setState({
          SAAStateId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAAStateErr: "",
        });
      }
    }
  }
  // render State
  renderStateList() {
    const { tempStateList } = this.state;
    return (
      <ul
        class="list-group pincode-drop"
        style={{ position: "absolute", zIndex: 100 }}
      >
        {tempStateList.length > 0 &&
          tempStateList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={() => this.mainStateListData(data)}
            >
              {data.Description}
            </li>
          ))}
      </ul>
    );
  }
  mainStateListData(data) {
    const { SameAsAbove } = this.state;
    this.setState({
      stateId: data.Description,
      isDisplayStateList: false,
      stateErr: "",
    });

    if (SameAsAbove) {
      this.setState({ SAAStateId: data.Description, SAAStateErr: "" });
    }
  }
  // same as above search State
  onSAAStateSearch(e) {
    const { SAAStateList, tempSAAStateList, isDisplayStateList, SAACountryId } =
      this.state;
    if (
      SAACountryId == "91" ||
      SAACountryId == "" ||
      SAACountryId == "Country*"
    ) {
      if (e.target.value != "") {
        var searchStateList = tempSAAStateList.filter((data) => {
          return data.Description.toLowerCase().includes(
            e.target.value.toLowerCase()
          );
        });
        this.setState({
          SAAStateId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          SAAStateErr: "",
          tempSAAStateList: searchStateList,
          isSAADisplayStateList: true,
        });
      } else {
        this.setState({
          SAAStateId: e.target.value
            .replace(/[^a-zA-Z ]/g, "")
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" "),
          tempSAAStateList: SAAStateList,
          isSAADisplayStateList: false,
        });
      }
    } else {
      this.setState({
        SAAStateErr: "",
        SAAStateId: e.target.value
          .replace(/[^a-zA-Z ]/g, "")
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        isSAADisplayStateList: false,
      });
    }
  }
  //same as above render State
  renderSAAStateList() {
    const { tempSAAStateList } = this.state;
    return (
      <ul
        class="list-group pincode-drop"
        style={{ position: "absolute", zIndex: 100 }}
      >
        {tempSAAStateList.length > 0 &&
          tempSAAStateList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={() => this.mainSAAStateListData(data)}
            >
              {data.Description}
            </li>
          ))}
      </ul>
    );
  }
  mainSAAStateListData(data) {
    this.setState({
      SAAStateId: data.Description,
      isSAADisplayStateList: false,
      stateErr: "",
    });
  }
  SameAsAbove(e) {
    const {
      SameAsAbove,
      firstName,
      lastName,
      designation,
      TelephoneNumber,
      addressLine1,
      addressLine2,
      city,
      pincode,
      Mobile1,
      Mobile2,
      ISD,
      STD,
      primaryEmailID,
      secondaryEmailID,
      website,
      mobileISD1,
      mobileISD2,
      stateId,
      countryId,
      CityName,
      companyName,
      cityId,
      preTel,
      AreaCode,
    } = this.state;
    this.setState({ SameAsAbove: !SameAsAbove });
    if (!SameAsAbove) {
      this.setState({
        SAAFirstName: firstName,
        SAALastName: lastName,
        SAADesignation: designation,
        SAACompanyName: companyName,
        SAAAddressLine1: addressLine1,
        SAAAddressLine2: addressLine2,
        SAACityId: cityId,
        SAAPincode: pincode,
        SAAMobile1: Mobile1,
        SAAMobile2: Mobile2,
        SAAISD: ISD,
        SAASTD: STD,
        SAAPrimaryEmailID: primaryEmailID,
        SAASecondaryEmailID: secondaryEmailID,
        SAAWebsite: website,
        SAAStateId: stateId,
        SAACountryId: countryId,
        SAATelephoneNumber: TelephoneNumber,
        SAAMobileISD1: mobileISD1,
        SAAMobileISD2: mobileISD2,
        SAAPreTel: preTel,
        SAAAreaCode: AreaCode,
        SAAFirstNameErr: "",
        SAALastNameErr: "",
        SAACompanyNameErr: "",
        SAAAddressLine1Err: "",
        SAACityNameErr: "",
        SAACountryIdErr: "",
        SAAPincodeErr: "",
        SAAMobile1Err: "",
        SAAPrimaryEmailIDErr: "",
        SAAStateErr: "",
      });
      console.log("stateId", stateId);
      console.log("countryId", countryId);
    } else {
      this.setState({
        SAAFirstName: "",
        SAALastName: "",
        SAADesignation: "",
        SAACompanyName: "",
        SAAAddressLine1: "",
        SAAAddressLine2: "",
        SAACityId: "",
        SAAPincode: "",
        SAAMobile1: "",
        SAAMobile2: "",
        SAAISD: "",
        SAASTD: "",
        SAAPrimaryEmailID: "",
        SAASecondaryEmailID: "",
        SAAWebsite: "",
        SAAStateId: "",
        SAACountryId: "",
        SAATelephoneNumber: "",
        SAAMobileISD1: "",
        SAAMobileISD2: "",
        SAACityId: "",
        SAAPreTel: "",
      });
    }
  }
  inputValidate() {
    const {
      firstName,
      lastName,
      designation,
      companyName,
      addressLine1,
      addressLine2,
      stateId,
      cityId,
      cityList,
      pincode,
      Mobile1,
      Mobile2,
      ISD,
      primaryEmailID,
      secondaryEmailID,
      website,
      SameAsAbove,
      SAAFirstName,
      SAALastName,
      SAADesignation,
      SAAAddressLine1,
      SAAAddressLine2,
      SAACityId,
      SAAPincode,
      SAAMobile1,
      SAAMobile2,
      SAAISD,
      SAASTD,
      SAAPrimaryEmailID,
      SAASecondaryEmailID,
      SAAWebsite,
      SAAStateId,
      registrationNumber,
      PANCardNo,
      NameonPANCard,
      GSTNo,

      TANNumber,
      UINNumber,
      SAATelephoneNumber,
      TelephoneNumber,
      SAACountryId,
      mobileISD1,
      mobileISD2,
      SAAMobileISD1,
      SAAMobileISD2,
      isDisplayCityList,
      CityName,
      SAACityName,
      CenterID,
      accountName,
      accountNo,
      accountType,
      bankName,
      branchName,
      IFSCCode,
      countryId,
      SAACompanyName,
      EventCordinatorName,
      EventCordinatorDesignation,
      EventCordinatorEmail,
      EventCordinatorMobile,
      PrimaryContactName,
      PrimaryContactDesignation,
      PrimaryContactEmail,
      PrimaryContactMobile,
    } = this.state;

    console.log("*******************", stateId);

    if (firstName == "" || firstName == null) {
      this.setState({ firstNameErr: "Please enter first name" });
    }
    if (lastName == "" || lastName == null) {
      this.setState({ lastNameErr: "Please enter last name" });
    }
    if (companyName == "" || companyName == null) {
      this.setState({ organizerErr: "Please enter organizer name" });
    }
    if (addressLine1 == "" || addressLine1 == null) {
      this.setState({ addressLine1Err: "Please enter address line 1" });
    }
    if (addressLine2 == "" || addressLine2 == null) {
      this.setState({ addressLine2Err: "Please enter address line 2" });
    }
    if (cityId == "" || cityId == null) {
      this.setState({
        CityNameErr: "Please enter city",
        isDisplayCityList: false,
      });
    }
    if (stateId == "" || stateId == null) {
      this.setState({ stateErr: "Please select state" });
    }
    if (countryId == "" || countryId == "Country*" || countryId == null) {
      this.setState({ countryIdErr: "Please select country" });
    }
    if (pincode == "" || pincode == null) {
      if (countryId == "91" || countryId == "" || countryId == "Country*") {
        this.setState({ pincodeErr: "Please enter pincode" });
      } else {
        this.setState({ pincodeErr: "Please enter zipCode" });
      }
    }
    if (Mobile1 == "" || Mobile1 == null) {
      this.setState({ Mobile1Err: "Please enter mobile number" });
    }
    if (primaryEmailID == "" || primaryEmailID == null) {
      this.setState({ primaryEmailIDErr: "Please enter email id" });
    }
    if (SAAFirstName == "" || SAAFirstName == null) {
      this.setState({ SAAFirstNameErr: "Please enter first name" });
    }
    if (SAALastName == "" || SAALastName == null) {
      this.setState({ SAALastNameErr: "Please enter last name" });
    }
    if (SAACompanyName == "" || SAACompanyName == null) {
      this.setState({ SAACompanyNameErr: "Please enter organizer name" });
    }
    if (SAAAddressLine1 == "" || SAAAddressLine1 == null) {
      this.setState({ SAAAddressLine1Err: "Please enter address line 1" });
    }
    if (SAAAddressLine2 == "" || SAAAddressLine2 == null) {
      this.setState({ SAAAddressLine2Err: "Please enter address line 2" });
    }
    if (SAACityId == "" || SAACityId == null) {
      this.setState({
        SAACityNameErr: "Please enter city",
        isSAADisplayCityList: false,
      });
    }
    if (SAAStateId == "" || SAAStateId == null) {
      this.setState({ SAAStateErr: "Please select state" });
    }
    if (
      SAACountryId == "" ||
      SAACountryId == "Country*" ||
      SAACountryId == null
    ) {
      this.setState({ SAACountryIdErr: "Please select country" });
    }
    if (SAAPincode == "" || SAAPincode == null) {
      if (
        SAACountryId == "91" ||
        SAACountryId == "" ||
        SAACountryId == "Country*"
      ) {
        this.setState({ SAAPincodeErr: "Please enter pincode" });
      } else {
        this.setState({ SAAPincodeErr: "Please enter zipCode" });
      }
    }
    if (SAAMobile1 == "" || SAAMobile1 == null) {
      this.setState({ SAAMobile1Err: "Please enter mobile number" });
    }
    if (SAAPrimaryEmailID == "" || SAAPrimaryEmailID == null) {
      this.setState({ SAAPrimaryEmailIDErr: "Please enter email id" });
    }
    if (PANCardNo == "" || PANCardNo == null) {
      this.setState({ PANCardNoErr: "Please enter pancard number" });
    }
    if (NameonPANCard == "" || NameonPANCard == null) {
      this.setState({ NameonPANCardErr: "Please enter name on pancard" });
    }
    if (accountName == "" || accountName == null) {
      this.setState({ accountNameErr: "Please enter account name" });
    }
    if (accountNo == "" || accountNo == null) {
      this.setState({ accountNoErr: "Please enter account number" });
    }
    if (
      accountType == "" ||
      accountType == "Select" ||
      accountType == "Account Type*" ||
      accountType == null
    ) {
      this.setState({ accountTypeErr: "Please select account type" });
    }
    if (bankName == "" || bankName == null) {
      this.setState({ bankNameErr: "Please enter bank name" });
    }
    if (branchName == "" || branchName == null) {
      this.setState({ branchNameErr: "Please enter branch name" });
    }
    if (IFSCCode == "" || IFSCCode == null) {
      if (countryId == "91" || countryId == "" || countryId == "Country*") {
        this.setState({ IFSCCodeErr: "Please enter IFSC code" });
      } else {
        this.setState({ IFSCCodeErr: "Please enter Swift code" });
      }
    }
    // event Cordinator details
    if (EventCordinatorName == "" || EventCordinatorName == null) {
      this.setState({
        EventCordinatorNameErr: "Please enter event cordinator name",
      });
    }
    if (
      EventCordinatorDesignation == "" ||
      EventCordinatorDesignation == null
    ) {
      this.setState({
        EventCordinatorDesignationErr:
          "Please enter event cordinator designation",
      });
    }
    if (EventCordinatorEmail == "" || EventCordinatorEmail == null) {
      this.setState({
        EventCordinatorEmailErr: "Please enter event cordinator email",
      });
    }

    if (EventCordinatorMobile == "" || EventCordinatorMobile == null) {
      this.setState({
        EventCordinatorMobileErr: "Please enter event cordinator mobile no",
      });
    }

    // primary contact details
    if (PrimaryContactName == "" || PrimaryContactName == null) {
      this.setState({
        PrimaryContactNameErr: "Please enter primary contact name",
      });
    }
    if (PrimaryContactDesignation == "" || PrimaryContactDesignation == null) {
      this.setState({
        PrimaryContactDesignationErr:
          "Please enter primary contact designation",
      });
    }
    if (PrimaryContactEmail == "" || PrimaryContactEmail == null) {
      this.setState({
        PrimaryContactEmailErr: "Please enter primary contact email",
      });
    }
    if (PrimaryContactMobile == "" || PrimaryContactMobile == null) {
      this.setState({
        PrimaryContactMobileErr: "Please enter primary contact mobile no",
      });
    }
  }
  onCountryId(e) {
    const { countryList, countryId, SameAsAbove, ISD } = this.state;
    this.setState({ countryId: e.target.value, countryIdErr: "" });

    countryList.map((data) => {
      if (data.Countryid == e.target.value) {
        console.log("************* e target value 1234", data.ExtensionCode);
        this.setState({ ISD: data.ExtensionCode });
        if (SameAsAbove) {
          this.setState({ SAAISD: data.ExtensionCode });
        }
      }
    });

    setTimeout(() => {
      if (SameAsAbove) {
        this.setState({
          SAACountryId: e.target.value,
          SAACountryIdErr: "",
        });
        if (e.target.value != 91) {
          this.setState({
            SAAPincode: "",
            SAACityId: "",
            SAAStateId: "",
            SAAAddressLine1: "",
            SAAAddressLine2: "",
          });
        }
      }
    }, 100);

    if (e.target.value == "91") {
      this.getFillList(stateActionId, "", e.target.value, "");
      this.getFillList(cityActionId, "", e.target.value, "");
    } else {
      this.setState({
        PANCardNo: "",
        PANCardNoErr: "",
        TANNumber: "",
        UINNumber: "",
        GSTNo: "",
        registrationNumber: "",
        NameonPANCard: "",
        NameonPANCardErr: "",
        PANCardNoErr: "",
        NameonPANCardErr: "",
        accountName: "",
        accountNo: "",
        accountType: "",
        bankName: "",
        branchName: "",
        IFSCCode: "",
        accountNameErr: "",
        accountNoErr: "",
        accountTypeErr: "",
        bankNameErr: "",
        branchNameErr: "",
        IFSCCodeErr: "",
      });
    }

    if (e.target.value != 91) {
      this.setState({
        cityId: "",
        stateId: "",
        pincode: "",
        isDisplayStateList: false,
        isDisplayCityList: false,
        addressLine1: "",
        addressLine2: "",
        CityNameErr: "",
        stateErr: "",
        pincodeErr: "",
      });
    } else {
      this.setState({
        CityNameErr: "",
        stateErr: "",
        pincodeErr: "",
      });
    }
  }

  onSAACountryId(e) {
    const { countryList, SAACountryId } = this.state;
    this.setState({ SAACountryId: e.target.value, SAACountryIdErr: "" });
    if (e.target.value != "") {
      countryList.map((data) => {
        if (data.Countryid == e.target.value) {
          console.log("************* e target value", e.target.value);
          setTimeout(() => {
            this.setState({ SAAISD: data.ExtensionCode });
          }, 100);
        } else {
          this.setState({
            SAAISD: "",
          });
        }
      });
    }
    if (e.target.value == "91") {
      this.getFillList(stateActionId, "", e.target.value, "");
      this.getFillList(cityActionId, "", e.target.value, "");
    }
    if (e.target.value != 91) {
      this.setState({
        SAACityId: "",
        SAAStateId: "",
        SAAPincode: "",
        SAAAddressLine1: "",
        SAAAddressLine2: "",
        isSAADisplayStateList: false,
        isSAADisplayCityList: false,
        SAACityNameErr: "",
        SAAStateErr: "",
        SAAPincodeErr: "",
      });
    } else {
      this.setState({
        SAACityNameErr: "",
        SAAStateErr: "",
        SAAPincodeErr: "",
      });
    }
  }
  firstName(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      firstName: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      firstNameErr: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAAFirstName: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        SAAFirstNameErr: "",
      });
    }
  }

  lastName(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      lastName: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      lastNameErr: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAALastName: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        SAALastNameErr: "",
      });
    }
  }

  designation(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      designation: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
    });
    if (SameAsAbove) {
      this.setState({
        SAADesignation: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
      });
    }
  }

  organizerName(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      companyName: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      organizerErr: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAACompanyName: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        SAACompanyNameErr: "",
      });
    }
  }
  onCountryId(e) {
    const { countryList, countryId, SameAsAbove, ISD } = this.state;
    this.setState({ countryId: e.target.value, countryIdErr: "" });

    console.log("************* e target value", e.target.value);
    console.log(
      "************* e target value type----------",
      typeof e.target.value
    );
    setTimeout(() => {
      if (SameAsAbove) {
        this.setState({
          SAACountryId: e.target.value,
          SAACountryIdErr: "",
        });
        if (e.target.value != 1) {
          this.setState({
            SAAPincode: "",
            SAACityId: "",
            SAAStateId: "",
            SAAAddressLine1: "",
            SAAAddressLine2: "",
          });
        }
      }
    }, 100);
    console.log("e.target.value", e.target.value);
    if (e.target.value == "91") {
      countryList.map((data) => {
        if (data.Countryid == e.target.value) {
          this.setState({ ISD: data.ExtensionCode });
          if (SameAsAbove) {
            this.setState({ SAAISD: data.ExtensionCode });
          }
        }
      });
      this.getFillList(
        stateActionId,
        "",
        e.target.value == "91" ? 1 : e.target.value,
        ""
      );
      this.getFillList(
        cityActionId,
        "",
        e.target.value == "91" ? 1 : e.target.value,
        ""
      );
    } else {
      this.setState({
        ISD: "",
        SAAISD: "",
        PANCardNo: "",
        PANCardNoErr: "",
        TANNumber: "",
        UINNumber: "",
        GSTNo: "",
        registrationNumber: "",
        NameonPANCard: "",
        NameonPANCardErr: "",
        PANCardNoErr: "",
        NameonPANCardErr: "",
        accountName: "",
        accountNo: "",
        accountType: "",
        bankName: "",
        branchName: "",
        IFSCCode: "",
        accountNameErr: "",
        accountNoErr: "",
        accountTypeErr: "",
        bankNameErr: "",
        branchNameErr: "",
        IFSCCodeErr: "",
      });
    }

    if (e.target.value != 1) {
      this.setState({
        cityId: "",
        stateId: "",
        pincode: "",
        isDisplayStateList: false,
        isDisplayCityList: false,
        addressLine1: "",
        addressLine2: "",
        CityNameErr: "",
        stateErr: "",
        pincodeErr: "",
      });
    } else {
      this.setState({
        CityNameErr: "",
        stateErr: "",
        pincodeErr: "",
      });
    }
  }

  onSAACountryId(e) {
    const { countryList, SAACountryId } = this.state;
    this.setState({ SAACountryId: e.target.value, SAACountryIdErr: "" });
    if (e.target.value != "") {
      countryList.map((data) => {
        if (data.Countryid == e.target.value) {
          console.log("************* e target value", e.target.value);
          setTimeout(() => {
            this.setState({ SAAISD: data.ExtensionCode });
          }, 100);
        } else {
          this.setState({
            SAAISD: "",
          });
        }
      });
    }
    if (e.target.value != 1) {
      this.setState({
        SAACityId: "",
        SAAStateId: "",
        SAAPincode: "",
        SAAAddressLine1: "",
        SAAAddressLine2: "",
        isSAADisplayStateList: false,
        isSAADisplayCityList: false,
        SAACityNameErr: "",
        SAAStateErr: "",
        SAAPincodeErr: "",
      });
    } else {
      this.setState({
        SAACityNameErr: "",
        SAAStateErr: "",
        SAAPincodeErr: "",
      });
    }
  }
  addressLine1(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      addressLine1: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      addressLine1Err: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAAAddressLine1: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        SAAAddressLine1Err: "",
      });
    }
  }

  addressLine2(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      addressLine2: e.target.value
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      addressLine2Err: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAAAddressLine2: e.target.value
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" "),
        SAAAddressLine2Err: "",
      });
    }
  }

  pincode(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      pincode: e.target.value.replace(/\D/, ""),
      pincodeErr: "",
    });
    if (SameAsAbove) {
      this.setState({
        SAAPincode: e.target.value.replace(/\D/, ""),
        SAAPincodeErr: "",
      });
    }
  }

  mobile1(e) {
    const { SameAsAbove } = this.state;
    this.setState({
      Mobile1: e.target.value.replace(/\D/, ""),
      Mobile1Err: "",
    });
    if (SameAsAbove) {
      this.setState({ SAAMobile1: e.target.value, SAAMobile1Err: "" });
    }
  }

  mobile2(e) {
    const { SameAsAbove } = this.state;
    this.setState({ Mobile2: e.target.value.replace(/\D/, "") });
    if (SameAsAbove) {
      this.setState({ SAAMobile2: e.target.value });
    }
  }

  telephone(e) {
    const { SameAsAbove } = this.state;
    this.setState({ TelephoneNumber: e.target.value.replace(/\D/, "") });
    if (SameAsAbove) {
      this.setState({ SAATelephoneNumber: e.target.value });
    }
  }
  preTelephone(e) {
    const { SameAsAbove } = this.state;
    this.setState({ preTel: e.target.value });
    if (SameAsAbove) {
      this.setState({ SAAPreTel: e.target.value });
    }
  }
  areaCode(e) {
    const { SameAsAbove } = this.state;
    this.setState({ AreaCode: e.target.value });
    if (SameAsAbove) {
      this.setState({ SAAAreaCode: e.target.value });
    }
  }

  primaryEmail(e) {
    const { SameAsAbove } = this.state;
    this.setState({ primaryEmailID: e.target.value, primaryEmailIDErr: "" });
    if (SameAsAbove) {
      this.setState({
        SAAPrimaryEmailID: e.target.value,
        SAAPrimaryEmailIDErr: "",
      });
    }
  }

  secondaryEmail(e) {
    const { SameAsAbove } = this.state;
    this.setState({ secondaryEmailID: e.target.value });
    if (SameAsAbove) {
      this.setState({ SAASecondaryEmailID: e.target.value });
    }
  }

  website(e) {
    const { SameAsAbove } = this.state;
    this.setState({ website: e.target.value });
    if (SameAsAbove) {
      this.setState({ SAAWebsite: e.target.value });
    }
  }

  clearFields() {
    this.setState({
      ClientID: "",
      FirstName: "",
      LastName: "",
      Designation: "",
      CompanyName: "",
      AddressLine1: "",
      AddressLine2: "",
      CityID: "",
      StateID: "",
      Countryid: "",
      Pincode: "",
      Mobile1: "",
      Mobile2: "",
      Telephone: "",
      PrimaryEmailID: "",
      SecondaryEmailID: "",
      Website: "",
      IS_SameAsAbove: "",
      Inv_FirstName: "",
      Inv_LastName: "",
      Inv_Designation: "",
      Inv_CompanyName: "",
      Inv_AddressLine1: "",
      Inv_AddressLine2: "",
      Inv_CityID: "",
      Inv_StateID: "",
      Inv_Countryid: "",
      Inv_Pincode: "",
      Inv_Mobile1: "",
      Inv_Mobile2: "",
      Inv_Telephone: "",
      Inv_PrimaryEmailID: "",
      Inv_SecondaryEmailID: "",
      Inv_Website: "",
      CompanyRegistrationNo: "",
      PanNo: "",
      NameOnPanCard: "",
      GSTNo: "",
      TanNo: "",
      UINNo: "",
      accountName: "",
      accountNo: "",
      accountType: "",
      bankName: "",
      branchName: "",
      IFSCCode: "",
    });
  }

  handleInputChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  editCompany(event) {
    const {
      firstName,
      lastName,
      designation,
      companyName,
      addressLine1,
      addressLine2,
      stateId,
      countryId,
      pincode,
      Mobile1,
      Mobile2,
      TelephoneNumber,
      primaryEmailID,
      secondaryEmailID,
      website,
      SameAsAbove,
      SAAFirstName,
      SAALastName,
      SAADesignation,
      SAAAddressLine1,
      SAAAddressLine2,
      cityId,
      SAAStateId,
      SAACountryId,
      SAAPincode,
      SAAMobile1,
      SAAMobile2,
      SAATelephoneNumber,
      SAAPrimaryEmailID,
      SAASecondaryEmailID,
      SAAWebsite,
      registrationNumber,
      PANCardNo,
      NameonPANCard,
      GSTNo,
      TANNumber,
      UINNumber,
      SAACityId,
      CityName,
      cityList,
      SAACityName,
      ClientID,
      accountName,
      accountNo,
      accountType,
      bankName,
      branchName,
      IFSCCode,
      CenterID,
      bookingList,
      SAACompanyName,
      SAAPreTel,
      preTel,
      is_Update_Membership,
      EventCordinatorName,
      EventCordinatorDesignation,
      EventCordinatorEmail,
      EventCordinatorMobile,
      PrimaryContactName,
      PrimaryContactDesignation,
      PrimaryContactEmail,
      PrimaryContactMobile,
      AreaCode,
      SAAAreaCode,
    } = this.state;
    const isEdit =
      this.props.location.state != null &&
        this.props.location.state.isEdit != null
        ? this.props.location.state.isEdit
        : null;

    setTimeout(() => {
      this.inputValidate();
    }, 100);
    if (countryId == "91") {
      if (
        firstName != "" &&
        firstName != null &&
        lastName != "" &&
        lastName != null &&
        companyName != "" &&
        companyName != null &&
        addressLine1 != "" &&
        addressLine1 != null &&
        stateId != null &&
        stateId != "" &&
        countryId != "" &&
        countryId != null &&
        countryId == "91" &&
        countryId != "Country*" &&
        cityId != "" &&
        cityId != null &&
        pincode != "" &&
        pincode != null &&
        Mobile1 != "" &&
        Mobile1 != null &&
        primaryEmailID != "" &&
        primaryEmailID != null &&
        SAAFirstName != "" &&
        SAAFirstName != null &&
        SAALastName != "" &&
        SAALastName != null &&
        SAACompanyName != "" &&
        SAACompanyName != null &&
        SAAAddressLine1 != "" &&
        SAAAddressLine1 != null &&
        SAACountryId != "" &&
        SAACountryId != null &&
        SAACountryId != "Country*" &&
        SAAStateId != null &&
        SAAStateId != "" &&
        SAACityId != "" &&
        SAACityId != null &&
        SAAPincode != "" &&
        SAAPincode != null &&
        SAAMobile1 != "" &&
        SAAMobile1 != null &&
        SAAPrimaryEmailID != "" &&
        SAAPrimaryEmailID != null &&
        PANCardNo != "" &&
        PANCardNo != null &&
        NameonPANCard != "" &&
        NameonPANCard != null &&
        accountName != "" &&
        accountName != null &&
        accountNo != "" &&
        accountNo != null &&
        accountType != "" &&
        accountType != null &&
        accountType != "Select" &&
        accountType != "Account Type*" &&
        bankName != "" &&
        bankName != null &&
        branchName != "" &&
        branchName != null &&
        IFSCCode != "" &&
        IFSCCode != null &&
        EventCordinatorName != "" &&
        EventCordinatorName != null &&
        EventCordinatorDesignation != "" &&
        EventCordinatorDesignation != null &&
        EventCordinatorEmail != "" &&
        EventCordinatorEmail != null &&
        EventCordinatorMobile != "" &&
        EventCordinatorMobile != null &&
        PrimaryContactName != "" &&
        PrimaryContactName != null &&
        PrimaryContactDesignation != "" &&
        PrimaryContactDesignation != null &&
        PrimaryContactEmail != "" &&
        PrimaryContactEmail != null &&
        PrimaryContactMobile != "" &&
        PrimaryContactMobile != null
      ) {
        var errMsg1 = emailValidator(primaryEmailID);
        var errMsg2 = notMendetoryEmailValidator(secondaryEmailID);
        var errMsg3 = emailValidator(SAAPrimaryEmailID);
        var errMsg4 = notMendetoryEmailValidator(SAASecondaryEmailID);
        var panErrMsg = panNoValidator(PANCardNo);
        var gstErrMsg = gstNoValidator(GSTNo);
        var tanErrMsg = tanNoValidator(TANNumber);
        var pincodeErrMsg = pincodeValidator(pincode);
        var pincodeSaaErrMsg = pincodeValidator(SAAPincode);
        var mobile1ErrMsg = mobileNoValidator(Mobile1);
        var mobile2ErrMsg = notMendetoryMobileNoValidator(Mobile2);
        var SAAMobile1ErrMsg = mobileNoValidator(SAAMobile1);
        var SAAMobile2ErrMsg = notMendetoryMobileNoValidator(SAAMobile2);
        var EventCordinatorMobileErrMsg = mobileNoValidator(
          EventCordinatorMobile
        );
        var PrimaryContactMobileErrMsg =
          mobileNoValidator(PrimaryContactMobile);
        var EventCordinatorEmailErrMsg = emailValidator(EventCordinatorEmail);
        var PrimaryContactEmailErrMsg = emailValidator(PrimaryContactEmail);

        if (
          errMsg1 != "" ||
          errMsg3 != "" ||
          panErrMsg != "" ||
          pincodeErrMsg != "" ||
          pincodeSaaErrMsg != "" ||
          mobile1ErrMsg != "" ||
          SAAMobile1ErrMsg != "" ||
          EventCordinatorMobileErrMsg != "" ||
          PrimaryContactMobileErrMsg != "" ||
          EventCordinatorEmailErrMsg != "" ||
          PrimaryContactEmailErrMsg != ""
        ) {
          toast.error(
            errMsg1 != ""
              ? errMsg1
              : errMsg3 != ""
                ? errMsg3
                : panErrMsg != ""
                  ? panErrMsg
                  : pincodeErrMsg != ""
                    ? pincodeErrMsg
                    : pincodeSaaErrMsg != ""
                      ? pincodeSaaErrMsg
                      : mobile1ErrMsg != ""
                        ? mobile1ErrMsg
                        : SAAMobile1ErrMsg != ""
                          ? SAAMobile1ErrMsg
                          : EventCordinatorMobileErrMsg != ""
                            ? EventCordinatorMobileErrMsg
                            : PrimaryContactMobileErrMsg != ""
                              ? PrimaryContactMobileErrMsg
                              : EventCordinatorEmailErrMsg != ""
                                ? EventCordinatorEmailErrMsg
                                : PrimaryContactEmailErrMsg != ""
                                  ? PrimaryContactEmailErrMsg
                                  : "",
            {
              position: "top-center",
              theme: "colored",
              autoClose: 1000,
              hideProgressBar: true,
            }
          );

          if (errMsg1) {
            this.setState({ primaryEmailIDErr: "Please enter proper email" });
          } else if (errMsg3) {
            this.setState({
              SAAPrimaryEmailIDErr: "Please enter proper email",
            });
          } else if (panErrMsg) {
            this.setState({ PANCardNoErr: "Please enter proper PAN No" });
          } else if (pincodeErrMsg) {
            this.setState({ pincodeErr: "Please Enter proper pincode" });
          } else if (pincodeSaaErrMsg) {
            this.setState({ SAAPincodeErr: "Please Enter proper pincode" });
          } else if (mobile1ErrMsg) {
            this.setState({ Mobile1Err: "Please Enter proper mobile number" });
          } else if (SAAMobile1ErrMsg) {
            this.setState({
              SAAMobile1Err: "Please Enter proper mobile number",
            });
          } else if (EventCordinatorMobileErrMsg) {
            this.setState({
              EventCordinatorMobileErr: "Please Enter proper mobile number",
            });
          } else if (PrimaryContactMobileErrMsg) {
            this.setState({
              PrimaryContactMobileErr: "Please Enter proper mobile number",
            });
          } else if (EventCordinatorEmailErrMsg) {
            this.setState({
              EventCordinatorEmailErr: "Please enter proper email",
            });
          } else if (PrimaryContactEmailErrMsg) {
            this.setState({
              PrimaryContactEmailErr: "Please enter proper email",
            });
          }
        } else if (
          gstErrMsg != "" ||
          tanErrMsg != "" ||
          errMsg2 != "" ||
          errMsg4 != "" ||
          mobile2ErrMsg != "" ||
          SAAMobile2ErrMsg != ""
        ) {
          toast.error(
            gstErrMsg != ""
              ? gstErrMsg
              : tanErrMsg != ""
                ? tanErrMsg
                : errMsg2 != ""
                  ? errMsg2
                  : errMsg4 != ""
                    ? errMsg4
                    : mobile2ErrMsg != ""
                      ? mobile2ErrMsg
                      : SAAMobile2ErrMsg != ""
                        ? SAAMobile2ErrMsg
                        : "",
            {
              position: "top-center",
              theme: "colored",
              autoClose: 1000,
              hideProgressBar: true,
            }
          );
        } else {
          if (
            Mobile1 != EventCordinatorMobile &&
            Mobile1 != PrimaryContactMobile
          ) {
            this.setState({ isLoading: true });

            this.props
              .client_add_action(
                ClientID,
                firstName,
                lastName,
                designation,
                companyName,
                addressLine1,
                addressLine2,
                cityId,
                stateId,
                countryId,
                pincode,
                Mobile1,
                Mobile2,
                TelephoneNumber != "" &&
                  TelephoneNumber != null &&
                  preTel != "" &&
                  preTel != null
                  ? preTel + "-" + TelephoneNumber
                  : TelephoneNumber,
                primaryEmailID,
                secondaryEmailID,
                website,
                SameAsAbove,
                SAAFirstName,
                SAALastName,
                SAADesignation,
                SAACompanyName,
                SAAAddressLine1,
                SAAAddressLine2,
                SAACityId,
                SAAStateId,
                SAACountryId,
                SAAPincode,
                SAAMobile1,
                SAAMobile2,
                SAATelephoneNumber != "" &&
                  SAATelephoneNumber != null &&
                  SAAPreTel != "" &&
                  SAAPreTel != null
                  ? SAAPreTel + "-" + SAATelephoneNumber
                  : SAATelephoneNumber,
                SAAPrimaryEmailID,
                SAASecondaryEmailID,
                SAAWebsite,
                registrationNumber,
                PANCardNo,
                NameonPANCard,
                GSTNo,
                TANNumber,
                UINNumber,
                accountName,
                accountNo,
                accountType,
                bankName,
                branchName,
                IFSCCode,
                EventCordinatorName,
                EventCordinatorDesignation,
                EventCordinatorEmail,
                EventCordinatorMobile,
                PrimaryContactName,
                PrimaryContactDesignation,
                PrimaryContactEmail,
                PrimaryContactMobile,
                1
              )
              .then((data) => {
                if (data.error != 1) {
                  console.log("data.data", data.data);
                  this.setState({ isLoading: false, isEditMode: true });
                } else {
                  if (
                    data.msg == sessionExpireMessage ||
                    data.msg == tokenInavlidMessage
                  ) {
                    //after session expire.....................
                    sessionStorage.clear();
                    this.props.navigate("/normalView");
                    setTimeout(() => {
                      toast.error(data.msg, {
                        position: "top-center",
                        theme: "colored",
                        autoClose: 3000,
                        hideProgressBar: true,
                      });
                    }, 500);
                  } else {
                    this.setState({ isLoading: false });
                    toast.error(data.msg, {
                      position: "top-center",
                      theme: "colored",
                      autoClose: 3000,
                      hideProgressBar: true,
                    });
                  }
                }
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            toast.error(
              "Provide Different Contact Number for Event Coordinator!",
              {
                position: "top-center",
                theme: "colored",
                autoClose: 1000,
                hideProgressBar: true,
              }
            );
            this.mobileCheckedSameOrNot();
          }
        }
      } else {
        toast.error("Please enter mandatory fields!", {
          position: "top-center",
          theme: "colored",
          autoClose: 1000,
          hideProgressBar: true,
        });
        this.setState({ isLoading: false });
      }
    } else {
      if (
        firstName != "" &&
        firstName != null &&
        lastName != "" &&
        lastName != null &&
        companyName != "" &&
        companyName != null &&
        countryId != "" &&
        countryId != null &&
        countryId != "Country*" &&
        stateId != null &&
        stateId != "" &&
        addressLine1 != "" &&
        addressLine1 != null &&
        cityId != "" &&
        cityId != null &&
        pincode != "" &&
        pincode != null &&
        Mobile1 != "" &&
        Mobile1 != null &&
        primaryEmailID != "" &&
        primaryEmailID != null &&
        SAAFirstName != "" &&
        SAAFirstName != null &&
        SAALastName != "" &&
        SAALastName != null &&
        SAACompanyName != "" &&
        SAACompanyName != null &&
        SAAAddressLine1 != "" &&
        SAAAddressLine1 != null &&
        SAACountryId != "" &&
        SAACountryId != null &&
        SAACountryId != "" &&
        SAACountryId != "Country*" &&
        SAACityId != "" &&
        SAACityId != null &&
        SAAStateId != null &&
        SAAStateId != "" &&
        SAAPincode != "" &&
        SAAPincode != null &&
        SAAMobile1 != "" &&
        SAAMobile1 != null &&
        SAAPrimaryEmailID != "" &&
        SAAPrimaryEmailID != null &&
        accountName != "" &&
        accountName != null &&
        accountNo != "" &&
        accountNo != null &&
        accountType != "" &&
        accountType != null &&
        accountType != "Select" &&
        accountType != "Account Type*" &&
        bankName != "" &&
        bankName != null &&
        branchName != "" &&
        branchName != null &&
        IFSCCode != "" &&
        IFSCCode != null &&
        EventCordinatorName != "" &&
        EventCordinatorName != null &&
        EventCordinatorDesignation != "" &&
        EventCordinatorDesignation != null &&
        EventCordinatorEmail != "" &&
        EventCordinatorEmail != null &&
        EventCordinatorMobile != "" &&
        EventCordinatorMobile != null &&
        PrimaryContactName != "" &&
        PrimaryContactName != null &&
        PrimaryContactDesignation != "" &&
        PrimaryContactDesignation != null &&
        PrimaryContactEmail != "" &&
        PrimaryContactEmail != null &&
        PrimaryContactMobile != "" &&
        PrimaryContactMobile != null
      ) {
        var errMsg1 = emailValidator(primaryEmailID);
        var errMsg2 = notMendetoryEmailValidator(secondaryEmailID);
        var errMsg3 = emailValidator(SAAPrimaryEmailID);
        var errMsg4 = notMendetoryEmailValidator(SAASecondaryEmailID);
        var EventCordinatorEmailErrMsg = emailValidator(EventCordinatorEmail);
        var PrimaryContactEmailErrMsg = emailValidator(PrimaryContactEmail);
        if (
          errMsg1 != "" ||
          errMsg3 != "" ||
          EventCordinatorEmailErrMsg != "" ||
          PrimaryContactEmailErrMsg != ""
        ) {
          console.log("stateId-------", stateId);
          console.log("cityId-------", cityId);
          toast.error(
            errMsg1 != ""
              ? errMsg1
              : errMsg3 != ""
                ? errMsg3
                : EventCordinatorEmailErrMsg != ""
                  ? EventCordinatorEmailErrMsg
                  : PrimaryContactEmailErrMsg != ""
                    ? PrimaryContactEmailErrMsg
                    : "",
            {
              position: "top-center",
              theme: "colored",
              autoClose: 1000,
              hideProgressBar: true,
            }
          );

          if (errMsg1) {
            this.setState({ primaryEmailIDErr: "Please enter proper email" });
          } else if (errMsg3) {
            this.setState({
              SAAPrimaryEmailIDErr: "Please enter proper email",
            });
          } else if (EventCordinatorEmailErrMsg) {
            this.setState({
              EventCordinatorEmailErr: "Please enter proper email",
            });
          } else if (PrimaryContactEmailErrMsg) {
            this.setState({
              PrimaryContactEmailErr: "Please enter proper email",
            });
          }
        }
        // else if (errMsg2 != '' || errMsg4 != '' || mobile2ErrMsg != '' || SAAMobile2ErrMsg != '') {

        //     toast.error(
        //         errMsg2 != '' ? errMsg2 :
        //             errMsg4 != '' ? errMsg4 :
        //                 mobile2ErrMsg != '' ? mobile2ErrMsg :
        //                     SAAMobile2ErrMsg != '' ? SAAMobile2ErrMsg :
        //                         '',
        //         {
        //             position: "top-center",
        //             theme: 'colored',
        //             autoClose: 1000,
        //             hideProgressBar: true,
        //         })

        // }
        else {
          if (
            Mobile1 != EventCordinatorMobile &&
            Mobile1 != PrimaryContactMobile
          ) {
            this.setState({ isLoading: true });
            this.props
              .client_add_action(
                ClientID,
                firstName,
                lastName,
                designation,
                companyName,
                addressLine1,
                addressLine2,
                cityId,
                stateId,
                countryId,
                pincode,
                Mobile1,
                Mobile2,
                TelephoneNumber != "" &&
                TelephoneNumber != null &&
                (AreaCode != "" && preTel != ""
                  ? preTel + "-" + AreaCode + "-" + TelephoneNumber
                  : preTel != ""
                    ? preTel + "-" + TelephoneNumber
                    : TelephoneNumber),
                primaryEmailID,
                secondaryEmailID,
                website,
                SameAsAbove,
                SAAFirstName,
                SAALastName,
                SAADesignation,
                SAACompanyName,
                SAAAddressLine1,
                SAAAddressLine2,
                SAACityId,
                SAAStateId,
                SAACountryId,
                SAAPincode,
                SAAMobile1,
                SAAMobile2,
                SAATelephoneNumber != "" &&
                SAATelephoneNumber != null &&
                (SAAAreaCode != "" && SAAPreTel != ""
                  ? SAAPreTel + "-" + SAAAreaCode + "-" + TelephoneNumber
                  : SAAPreTel != ""
                    ? preTel + "-" + SAATelephoneNumber
                    : SAATelephoneNumber),
                SAAPrimaryEmailID,
                SAASecondaryEmailID,
                SAAWebsite,
                registrationNumber,
                PANCardNo,
                NameonPANCard,
                GSTNo,
                TANNumber,
                UINNumber,
                accountName,
                accountNo,
                accountType,
                bankName,
                branchName,
                IFSCCode,
                EventCordinatorName,
                EventCordinatorDesignation,
                EventCordinatorEmail,
                EventCordinatorMobile,
                PrimaryContactName,
                PrimaryContactDesignation,
                PrimaryContactEmail,
                PrimaryContactMobile,
                1
              )
              .then((data) => {
                if (data.error != 1) {
                  console.log("data.data", data.data);
                  this.setState({ isLoading: false, isEditMode: true });
                } else {
                  if (
                    data.msg == sessionExpireMessage ||
                    data.msg == tokenInavlidMessage
                  ) {
                    //after session expire.....................
                    sessionStorage.clear();
                    this.props.navigate("/normalView");
                    setTimeout(() => {
                      toast.error(data.msg, {
                        position: "top-center",
                        theme: "colored",
                        autoClose: 3000,
                        hideProgressBar: true,
                      });
                    }, 500);
                  } else {
                    this.setState({ isLoading: false });
                    toast.error(data.msg, {
                      position: "top-center",
                      theme: "colored",
                      autoClose: 3000,
                      hideProgressBar: true,
                    });
                  }
                }
              })
              .catch((e) => {
                console.log(e);
              });
          } else {
            toast.error("MobileNo can not be same!", {
              position: "top-center",
              theme: "colored",
              autoClose: 1000,
              hideProgressBar: true,
            });
            this.mobileCheckedSameOrNot();
          }
        }
      } else {
        toast.error("Please enter mandatory fields!", {
          position: "top-center",
          theme: "colored",
          autoClose: 1000,
          hideProgressBar: true,
        });
        this.setState({ isLoading: false });
      }
    }
  }
  CompanyEditTrue() {
    const { isEditMode } = this.state;
    this.setState({ isEditMode: false });
  }
  CompanyEditFalse() {
    const { isEditMode } = this.state;
    this.setState({ isEditMode: true });
  }
  handleInputChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }
  //Add Additional Services part

  isQuantity(e, index, name) {
    const { additionalServicesList } = this.state;
    const cList = [...additionalServicesList];

    const event = e.target.value.replace(/\D/, "");
    console.log("event isQuantity", event);

    cList.forEach((data, i) => {
      // if (i === index) {
      // data.Quantity = event
      // data.Amount = data.PriceInINR * event

      if (data.Name == name) {
        console.log("%%%%%%%%%%%", data.Name);
        console.log("%%%%%%%%%%%", name);
        if (event > 0) {
          data.Quantity = event;
        } else {
          data.Quantity = "";
        }
        // if (data.CurrencyID != 2) {
        //     data.Amount = data.PriceInINR * event
        // } else {
        //     data.Amount = data.PriceInUSD * event
        // }
        this.setState({
          additionalServicesList: cList,
        });
      }
      console.log("data", data);

      // }
    });

    this.setState({
      additionalServicesList: cList,
    });
    console.log("XXXXXXXX checkboxFlag XXXXXXX", cList);
  }
  externalServicesDescription(e, index) {
    const { externalServices } = this.state;
    const cList = [...externalServices];

    const event = e.target.value;

    cList.forEach((data, i) => {
      if (i === index) {
        data.Description = event;
      }
    });

    this.setState({
      externalServices: cList,
    });
    // console.log("XXXXXXXX checkboxFlag XXXXXXX", cList)
  }
  includedServicesCheckbox(index, IsSelected, e) {
    const { includedServices } = this.state;
    const cList = [...includedServices];
    const event = e.target.checked;

    cList.forEach((data, i) => {
      if (i === index) {
        if (IsSelected == 0) {
          data.IsSelected = 1;
        } else {
          data.IsSelected = 0;
        }
      }
    });

    this.setState({
      includedServices: cList,
    });
    // console.log("XXXXXXXX checkboxFlag XXXXXXX", cList)
  }
  externalServicesCheckbox(index, IsSelected, e) {
    const { externalServices } = this.state;
    const cList = [...externalServices];
    const event = e.target.checked;

    cList.forEach((data, i) => {
      if (i === index) {
        if (IsSelected == 0) {
          data.IsSelected = 1;
        } else {
          data.IsSelected = 0;
          data.Qty = "";
          data.Package = null;
          data.Price = 0;
          data.PackageID = 0;
          data.VendorName = "";
          data.AdditionalRequirement = "";
          data.VendorID = "";
          this.clearPackageValue();
        }
      }
    });

    this.setState({
      externalServices: cList,
    });
  }
  checkbox(index, IsSelected, e) {
    const { additionalServicesList } = this.state;
    const cList = [...additionalServicesList];
    const event = e.target.checked;
    cList.forEach((data, i) => {
      if (i === index) {
        const electricityFlag = data.Name.split(" ").includes("Electricity");
        if (data.CurrencyID == 1) {
          if (IsSelected == 0) {
            if (electricityFlag) {
              data.IsSelected = 1;
              data.Quantity = 1;
              data.Amount = data.PriceInINR * 30;
            } else {
              data.IsSelected = 1;
              data.Quantity = 1;
              data.Amount = data.PriceInINR;
            }
          } else {
            if (electricityFlag) {
              data.IsSelected = 0;
              data.Quantity = "";
            } else {
              data.IsSelected = 0;
              data.Quantity = "";
            }
          }
        } else {
          if (IsSelected == 0) {
            if (electricityFlag) {
              data.IsSelected = 1;
              data.Quantity = 1;
              data.Amount = data.PriceInUSD * 30;
            } else {
              data.IsSelected = 1;
              data.Quantity = 1;
              data.Amount = data.PriceInUSD;
            }
          } else {
            if (electricityFlag) {
              data.IsSelected = 0;
              data.Quantity = "";
            } else {
              data.IsSelected = 0;
              data.Quantity = "";
            }
          }
        }
      }
    });

    this.setState({
      additionalServicesList: cList,
    });
    console.log("XXXXXXXX checkboxFlag XXXXXXX", cList);
  }
  onServicetypechange(e, index, name, Quantity) {
    const { additionalServicesList } = this.state;
    const cList = [...additionalServicesList];
    const event = e.target.value;
    console.log("event", event[0].toString());
    var List;

    cList.forEach((data, i) => {
      // if (i === index) {
      if (data.Name == name) {
        console.log(data.ServiceType);

        if (data.ServiceType == event[0].toString()) {
          console.log("sdgfsd");

          data.Is_SelectedServiceId = 1;
          data.IsSelected = 1;
          console.log("data.Quantity", Quantity);
          data.Quantity = Quantity;
          this.setState({
            additionalServicesList: cList,
          });
        } else {
          console.log("sdgfqweqsd");
          data.Is_SelectedServiceId = 0;
          data.IsSelected = 0;
          this.setState({
            additionalServicesList: cList,
          });
        }

        console.log("data", data);
      }
      // }
    });

    this.setState({
      additionalServicesList: cList,
    });
    console.log("XXXXXXXX onServicetypechange XXXXXXX", cList);
  }
  handleKeyDown(e) {
    if (e.code === "Enter") {
      this.handleSubmitAdditionalSubmit(e);
    }
  }
  vendorPackageCheckbox(index, IsSelected, e) {
    const {
      vendorPackageList,
      indexOfExternalService,
      externalServices,
      dummyVendorPackageList,
    } = this.state;
    const cList = [...vendorPackageList];
    const event = e.target.checked;
    console.log("event----", event);

    cList.forEach((data, i) => {
      if (i === index) {
        if (event) {
          data.IsSelected = 1;
          dummyVendorPackageList.map((obj) => {
            if (
              obj.VendorServicesPackageID == data.VendorServicesPackageID &&
              obj.index == data.index
            ) {
              obj.IsSelected = 1;
            } else {
              obj.IsSelected = 0;
            }
          });
          externalServices.map((item, i) => {
            if (i === indexOfExternalService) {
              item.Package = data.Package;
              item.Price = data.Rate;
              item.PackageID = data.VendorServicesPackageID;
              item.VendorName = data.VendorName;
              item.CompanyName = data.CompanyName;
              item.VendorID = data.VendorID;
            }
          });
          this.setState({
            externalServices: externalServices,
            dummyVendorPackageList: dummyVendorPackageList,
          });
        } else {
          data.IsSelected = 0;
          data.Description = "";
          dummyVendorPackageList.map((obj) => {
            if (
              obj.VendorServicesPackageID == data.VendorServicesPackageID &&
              obj.index == data.index
            ) {
              obj.IsSelected = 0;
            }
          });
          externalServices.map((item, i) => {
            if (i === indexOfExternalService) {
              item.Package = null;
              item.Price = 0;
              item.PackageID = 0;
              item.VendorName = "";
              item.CompanyName = "";
              item.VendorID = "";
            }
          });
          this.setState({
            externalServices: externalServices,
            dummyVendorPackageList: dummyVendorPackageList,
          });
        }
      } else {
        data.IsSelected = 0;
      }
    });
    setTimeout(() => {
      console.log("vendorPackageList---", cList);
    }, 200);

    this.setState({
      vendorPackageList: cList,
    });
  }
  handleSubmitAdditionalSubmit() {
    const {
      OrderNo,
      additionalServicesList,
      orderDtlID,
      submitOrApproveAdditional,
      unlistedAddServices,
      OtherInformation,
      externalServices,
      companyName,
      primaryEmailID,
      MyOrdersData,
    } = this.state;
    this.setState({ isLoading: false });
    const { CenterID, OrderID, ClientID } = this.state;

    console.log("Additional Serviceses CenterID", CenterID);

    console.log("Final standerdArray handle submit", externalServices);
    const externalNewArray = [];
    if (externalServices != "") {
      externalServices.map((item) => {
        if (item.IsSelected == 1) {
          externalNewArray.push(item);
        }
      });
    }
    var externalServicesCondition = externalNewArray.every(
      (item) => item.Package != null
    );

    const newArray = [];

    additionalServicesList.map((data, i) => {
      // data.Amount == null ? data.Quantity*data.PriceInINR
      if (data.IsSelected == 1) {
        newArray.push(
          data.CurrencyID != 2
            ? {
              CenterAdditionalServiceID: data.CenterAdditionalServicesID,
              Price: data.PriceInINR,
              Quantity: data.Quantity != "" ? data.Quantity : 1,
              Amount: data.Amount,
            }
            : {
              CenterAdditionalServiceID: data.CenterAdditionalServicesID,
              Price: data.PriceInUSD,
              Quantity: data.Quantity != "" ? data.Quantity : 1,
              Amount: data.Amount,
            }
        );
      }
    });
    console.log("newArray", newArray);

    const externalServicesNewArray = [];

    externalServices.map((data, i) => {
      // data.Amount == null ? data.Quantity*data.PriceInINR
      if (data.IsSelected == 1) {
        externalServicesNewArray.push({
          CenterServiceID: data.CenterServicesID,
          Service: data.Service,
          VendorservicepackageID: data.PackageID,
          Price: 0,
          Qty: 0,
          AdditionalRequirement: data.AdditionalRequirement,
          ServiceID: data.ServiceID,
          VendorID: data.VendorID,
        });
      }
    });
    const requestServiceMailList = [];
    let inhouseTotal = 0;
    additionalServicesList.map((data, i) => {
      if (data.IsSelected == 1) {
        requestServiceMailList.push(
          data.CurrencyID != 2
            ? {
              CenterAdditionalServiceID: data.CenterAdditionalServicesID,
              Amount: data.Amount,
              Service: data.Name,
            }
            : {
              CenterAdditionalServiceID: data.CenterAdditionalServicesID,
              Amount: data.Amount,
              Service: data.Name,
            }
        );
        inhouseTotal += parseFloat(data.Amount) || 0;
      }
    });

    var UnlistedAddServices = unlistedAddServices != null || unlistedAddServices != "" || unlistedAddServices != [] ? unlistedAddServices.toString() : ""
    console.log("newArray", externalServicesNewArray);
    if (externalServicesCondition) {
      this.props
        .postUpdate_additional_services_action(
          OrderID,
          OrderNo,
          companyName,
          primaryEmailID,
          orderDtlID,
          CenterID,
          // 1,
          UnlistedAddServices,
          OtherInformation,
          newArray,
          externalServicesNewArray, requestServiceMailList, inhouseTotal
        )
        .then((data) => {
          if (data.error != 1) {
            //  window.location.reload();
            this.setState({ isLoading: false });
          } else {
            if (
              data.msg == sessionExpireMessage ||
              data.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(data.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              this.setState({ isLoading: false });
              toast.error(data.data, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else {
      this.setState({ isLoading: false });
      toastError("Please select package of additional vendor services");
    }
  }

  //is view part
  isProformaDownload(DeliveryStatus) {
    const { StatusID } = this.state
    if (StatusID >= 11) {
      return true;
    }
    return false;
  }
  IsCancelledButton(DeliveryStatus, Is_NoDue) {
    if (
      DeliveryStatus === "Cancelled" ||
      DeliveryStatus === "Delivered" ||
      Is_NoDue === 1
    ) {
      return true;
    }
    return false;
  }
  isCreditDebit(DeliveryStatus) {
    if (DeliveryStatus === "Confirmed") {
      return true;
    }
    return false;
  }
  IsModifyButton(
    Is_NoDue,
    DeliveryStatus,
    OrderID,
    OrderNo,
    StatusID,
    CenterID,
    BookingDate
  ) {
    console.log(
      Is_NoDue,
      DeliveryStatus,
      OrderID,
      OrderNo,
      StatusID,
      CenterID,
      BookingDate
    );
    if (Is_NoDue == 0) {
      if (DeliveryStatus !== "Incomplete") {
        return false;
      } else {
        return (
          <>
            <a
              href="javascript:void(0);"
              onClick={() =>
                this.onEditNavigate(
                  OrderID,
                  OrderNo,
                  StatusID,
                  CenterID,
                  BookingDate
                )
              }
              className="btn btn-success my_custom_orderPage_btns m-2"
            >
              Modify Order
            </a>
          </>
        );
      }
    } else {
      return false;
    }
  }
  onEditNavigate = (OrderID, OrderNo, StatusID, CenterID, BookingDate) => {
    console.log(OrderID, OrderNo, StatusID, CenterID, BookingDate);

    if (StatusID === 1 || StatusID === 2 || StatusID === 3 || StatusID === 4) {
      this.props.navigate("");
    } else if (StatusID === 5) {
      this.props.navigate("/companyInfo", {
        state: { OrderID: OrderID, CenterID: CenterID },
      });
    } else if (StatusID === 6) {
      this.props.navigate("/BookingDetails", {
        state: { OrderID: OrderID, CenterID: CenterID },
      });
    } else if (StatusID === 7) {
      this.props.navigate("/additionalServices", {
        state: { OrderID: OrderID, CenterID: CenterID },
      });
    } else if (StatusID === 8) {
      this.props.navigate("/termsAndConditons", {
        state: { OrderID: OrderID, CenterID: CenterID },
      });
    } else if (StatusID === 9) {
      this.props.navigate("/summary", {
        state: { OrderID: OrderID, CenterID: CenterID },
      });
    } else if (StatusID === 10 || StatusID === 13) {
      this.props.navigate("/cart", {
        state: { OrderID: OrderID, CenterID: CenterID },
      });
    } else if (StatusID === 16) {
      sessionStorage.removeItem("navAgain");
      sessionStorage.setItem("Is_modify", true);
      sessionStorage.setItem("OrderID", OrderID);
      sessionStorage.setItem("OrderNo", OrderNo);
      sessionStorage.setItem("centerID", CenterID);
      this.props.navigate("/calenderView", {
        state: { date: BookingDate },
      });
    } else {
      this.props.navigate("");
    }
  };

  IsEventClosure(Is_Closure, DeliveryStatus) {
    if (Is_Closure === 1 && DeliveryStatus === "Confirmed") {
      return (
        <div className="col-md-4 text-right">
          <a
            href="javascript:void(0);"
            aria-disabled
            className="btn btn-outline-primary btn-sm m-2 make_paymentBtn"
          >
            Event Closure
          </a>
        </div>
      ); // Hide both buttons if Is_Closure is false or DeliveryStatus is "Cancelled"
    }
    return null;
  }

  IsNoDue(
    Is_NoDue,
    DeliveryStatus,
    AdditionalServiceStatus,
    NoDueBy,
    NoDueDate
  ) {
    const { OrderID, OrderNo } = this.state;
    switch (true) {
      case (Is_NoDue === 0 || Is_NoDue === 1) && DeliveryStatus === "Cancelled":
        return null;

      case (Is_NoDue === 1 &&
        DeliveryStatus === "Confirmed" &&
        AdditionalServiceStatus === 1) ||
        DeliveryStatus === "Delivered":
        return (
          <div className="col-md-4 text-right">
            <a
              href="javascript:void(0);"
              className="make_paymentLink m-2"
              onClick={() =>
                this.downloadNoDue(
                  this.props.location.state.OrderID || OrderID,
                  this.props.location.state.OrderNo || OrderNo
                )
              }
            >
              <i className="fa fa-download" /> No Due Certificate
            </a>
            {/* <br />
            <span>{NoDueBy}</span>
            <br />
            <span>{NoDueDate}</span> */}
          </div>
        );
      default:
        return null;
    }
  }
  Is_ExitPass(Is_ExitPass, DeliveryStatus, IsExitPassBy, IsExitPassDate) {
    const { OrderID, OrderNo } = this.state;
    switch (true) {
      case (Is_ExitPass === 0 || Is_ExitPass === 1) &&
        DeliveryStatus === "Cancelled":
        return null;

      case (Is_ExitPass === 1 && DeliveryStatus === "Confirmed") ||
        DeliveryStatus === "Delivered":
        return (
          <div className="col-md-4 text-right">
            <a
              href="javascript:void(0);"
              className="make_paymentLink m-2"
              onClick={() =>
                this.downloadExitPass(
                  this.props.location.state.OrderID || OrderID,
                  this.props.location.state.OrderNo || OrderNo
                )
              }
            >
              <i className="fa fa-download" /> Exit Pass
            </a>
            {/* <br />
            <span>{IsExitPassBy}</span>
            <br />
            <span>{IsExitPassDate}</span> */}
          </div>
        );
      default:
        return null;
    }
  }
  IsAddAdditionalServices(deliveryStatus, paymentStatus) {
    if (
      deliveryStatus === "Confirmed" ||
      deliveryStatus === "Delivered" ||
      deliveryStatus === "Approved"
    ) {
      return true;
    }
    return false;
  }
  IsPossessionCheckList(PossessionSubmittedBy) {
    var isPosSubmitted;
    if (PossessionSubmittedBy[0] == null) {
      isPosSubmitted = 0;
    } else {
      isPosSubmitted = 1;
    }
    if (isPosSubmitted == 0) {
      return false;
    }
    return true;
  }

  renderPaymentForm(paymentStatus, deliveryStatus) {
    const { encPayload, paymentAccessCode, MyOrdersData, amount, OrderID, orderPaymentDetails, displayRazorpay, paymentOrderID } = this.state;
    const Outstanding = deliveryStatus === "Approved" || deliveryStatus === "Confirmed" || deliveryStatus === "Delivered" ? MyOrdersData.map((data) => data.proformaDetails[0].Outstanding).join(", ") : null
    if (deliveryStatus === "Confirmed" || deliveryStatus === "Delivered") {
      if ((Outstanding == 0 || Outstanding < 0) || paymentStatus === "Delivered") {
        return (
          <div className="d-flex align-items-center">
            <div className="mx-2">Booking Payment Status:</div>
            <div className="btn btn-success btn-sm">PAID</div>
          </div>
        );
      } else {
        return (
          <div className="d-flex align-items-center">
            UNPAID
            {/* <div className="mx-2">Booking Payment Status:</div>
            <form method="POST"
              //  onSubmit={(e)=>this.handleCreateOrder(e)}
              action={razorpayCheckoutUrl}
              ref={this.submitpayment}
            >
              <input type="hidden" name="key_id" value={key_id} />
              <input type="hidden" name="amount" value={amount} />
              <input type="hidden" name="order_id" value={paymentOrderID} />
              <input type="hidden" name="name" value={merchantName} />
              <input type="hidden" name="description" value={merchantDescription} />
              <input type="hidden" name="prefill[name]" value={prefilName} />
              <input type="hidden" name="prefill[contact]" value={prefilContact} />
              <input type="hidden" name="prefill[email]" value={prefilEmail} />
              <input type="hidden" name="notes[shipping address]" value={prefilAddress} />
              <input type="hidden" name="callback_url" value={paymentVerificationUrl} />
              <input type="hidden" name="cancel_url" value={paymentVerificationUrl} />
              <input type="hidden" name="notes" value={{ 'key': 'test' }} />
              <div className="btn btn-danger btn-sm" onClick={(e) => this.handleCreateOrder(e)}>
                Make Payment

              </div>
            </form>
            {displayRazorpay && (
              <RenderRazorpay
                amount={orderPaymentDetails.amount}
                currency={orderPaymentDetails.currency}
                orderId={orderPaymentDetails.orderId}
                keyId={key_id}
                keySecret={key_secret}
                onPaymentResponse={this.handlePaymentResponse}
              />)
            } */}
          </div>
        );
      }
    } else if (deliveryStatus === "Approved") {
      return (
        <div className="d-flex align-items-center">
          UNPAID
          {/* <div className="mx-2">Payment Status:</div>
          <a
            className="btn btn-danger btn-sm"
            href="javascript:void(0);"
            onClick={() => this.props.navigate("/cart")}
          >
            Make Payment
          </a> */}
        </div>
      ); // Display payment form if deliveryStatus is "Approved"
    } else {
      return null; // Return null for all other casesparse// parse.int() krke bhej
    }
  }
  handleCreateOrder(e) {
    e.preventDefault()
    const { MyOrdersData, OrderID, isLoading, paymentOrderID } = this.state
    const Outstanding = MyOrdersData.map((data) => data.proformaDetails[0].Outstanding).join(",")
    const finalCurrency = MyOrdersData.map((data) => data.currency).join(",")

    var orderIDList = []
    orderIDList.push({
      orderID: OrderID
    })

    if (orderIDList.length > 0 && Outstanding != 0 && Outstanding != '' && finalCurrency != '' && Outstanding != null && finalCurrency != null) {
      this.setState({ isLoading: true })
      this.props.create_payment_order_action(parseInt(Outstanding), finalCurrency, orderIDList, 0, 1, 'Initiated')
        .then((data) => {
          console.log(data.order_id)
          if (data.error != 1) {
            this.setState({
              paymentOrderID: data.order_id,
              orderPaymentDetails: {
                paymentOrderID: data.order_id,
                currency: data.currency,
                amount: data.amount,
              }
            }, () => {
              console.log(data)
              setTimeout(() => {
                // this.setState({ displayRazorpay: true })
                this.submitpayment.current.submit()
                console.log(this.state.orderPaymentDetails)
              }, 200);

            })
          } else {
            this.setState({ isLoading: false })
            toastError("Something went Wrong...")
          }
        })
    } else {
      toastError("something went wrong...")
    }
  }
  handlePaymentResponse = (response) => {
    this.setState({ isLoading: false, displayRazorpay: false, });
    if (response == 'Cancelled') {
      toastError("Payment Cancelled")
    }
    else if (response == 'timedout') {
      toastError("Session TimeOut")
    }
    else if (response == 'Cancelled') {
      toastError("Payment failed")
    }
    else {
      toastError("Something went wrong...")
    }
    console.log("Payment response received from child:", response);
  };
  //Order part
  backToOrders() {
    this.props.navigate("/my_orders");
  }
  navigateToDebitNote(OrderID, ClientID, PrimaryEmailID, RoleID) {
    console.log(OrderID, ClientID, PrimaryEmailID, RoleID);
    this.props.navigate("/debitNoteau", {
      state: {
        OrderID: OrderID,
        ClientID: ClientID,
        PrimaryEmailID: PrimaryEmailID,
        RoleID: RoleID,
      },
    });
  }
  navigateToCreditNote(OrderID, ClientID, PrimaryEmailID, RoleID) {
    console.log(OrderID, ClientID, PrimaryEmailID, RoleID);
    this.props.navigate("/creditNoteau", {
      state: {
        OrderID: OrderID,
        ClientID: ClientID,
        PrimaryEmailID: PrimaryEmailID,
        RoleID: RoleID,
      },
    });
  }
  deleteModalShow(
    OrderID,
    OrderNo,
    CompanyName,
    PrimaryEmailID,
    RoleID,
    OrderAmount
  ) {
    this.setState({
      deleteShow: true,
      OrderID: OrderID,
      OrderNo: OrderNo,
      CompanyName: CompanyName,
      PrimaryEmailID: PrimaryEmailID,
      RoleID: RoleID,
      OrderAmount: OrderAmount,
    });
    console.log(
      "deleteModal",
      OrderID,
      OrderNo,
      CompanyName,
      PrimaryEmailID,
      RoleID,
      OrderAmount
    );
  }
  deleteModalClose() {
    this.setState({
      deleteShow: false,
      CancellationReasonID: "",
      cancelNote: "",
    });
  }

  piModalShow(OrderID, OrderNo, proformaList) {
    console.log(OrderID, OrderNo, proformaList);

    this.setState({
      PiShow: true,
      OrderID: OrderID,
      OrderNo: OrderNo,
      proformaList: proformaList,
    });
  }
  piModalClose() {
    this.setState({ PiShow: false });
  }

  formatOrderDate(orDate) {
    const options = { day: "numeric", month: "long", year: "numeric" };
    const date = new Date(orDate);
    return date.toLocaleDateString(undefined, options);
  }
  formatDate(orDate) {
    console.log("Original Date:", orDate);
    if (typeof orDate !== "string" || !orDate.includes("/")) {
      return "--";
    }
    const date =
      typeof orDate === "string" ? this.parseDateFromString(orDate) : orDate;
    if (isNaN(date.getTime())) {
      return "--";
    }
    const options = { month: "long", day: "numeric", year: "numeric" };
    return date.toLocaleDateString(undefined, options);
  }

  parseDateFromString(dateString) {
    const parts = dateString.split("/");
    if (parts.length !== 3) {
      return new Date(NaN);
    }
    const formattedDate = `${parts[1]}/${parts[0]}/${parts[2]}`;
    return new Date(formattedDate);
  }
  downloadBookingForm(OrderID, OrderNo) {
    const { userId } = this.state;
    const formattedOrderNo = OrderNo.replace(
      /[\/-]/g,
      "_"
    );
    this.setState({ isLoading: true });
    this.props
      .download_booking_form_action(
        userId,
        OrderID,
        formattedOrderNo
      )
      .then((downloadData) => {
        if (downloadData.error !== 1) {
          this.setState({ isLoading: false });
          console.log(downloadData);

          // Open the report in a new tab
          const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
          window.open(url, "_blank");
        } else {
          if (downloadData.msg == sessionExpireMessage || downloadData.msg == tokenInavlidMessage) {
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(downloadData.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(downloadData.msg, {
              position: "top-center",
              theme: "colored"
            });
          }
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isLoading: false });
      });
  }
  downloadPerformaInvoice(ProformaInvoiceID, ProformaInvoice_No, ProformaType) {
    const { userId } = this.state;
    const formattedProformaInvoiceNo = ProformaInvoice_No.replace(
      /[\/-]/g,
      "_"
    );
    this.setState({ isLoading: true });

    if (ProformaInvoiceID) {
      console.log(ProformaInvoiceID, formattedProformaInvoiceNo);
      const selectedProformaType = ProformaType === 'Slot Booking' ? 1 : ProformaType === "Additionalservices" ? 1 : 0
      this.props
        .download_performa_invoice_action(
          userId,
          ProformaInvoiceID,
          formattedProformaInvoiceNo, selectedProformaType
        )
        .then((downloadData) => {
          if (downloadData.error !== 1) {
            this.setState({ isLoading: false });
            console.log(downloadData);

            // Open the report in a new tab
            const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
            window.open(url, "_blank");
          } else {
            if (downloadData.msg == sessionExpireMessage || downloadData.msg == tokenInavlidMessage) {
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(downloadData.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              this.setState({ isLoading: false });
              toast.error(downloadData.msg, {
                position: "top-center",
                theme: "colored"
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({ isLoading: false });
      toast.error("Cannot open: Proforma Invoice ID not found.", {
        position: "top-center", theme: "colored"
      });
    }
  }
  downloadNoDue(OrderID, OrderNo) {
    const { userId } = this.state;
    this.setState({ isLoading: false });
    if (OrderID) {
      console.log(OrderID, OrderNo);
      const formattedOrderNo = OrderNo.replace(/[\/-]/g, "_");
      this.props
        .download_no_due_action(userId, OrderID, formattedOrderNo)
        .then((downloadData) => {
          if (downloadData.error !== 1) {
            this.setState({ isLoading: false });
            console.log(downloadData);
            const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
            window.open(url, "_blank");
          } else {
            if (
              downloadData.msg == sessionExpireMessage ||
              downloadData.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(downloadData.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              this.setState({ isLoading: false });
              toast.error(downloadData.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 1000,
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({ isLoading: false });
      toast.error("Cannot download: OrderID not found.", {
        position: "top-center",
        autoClose: 1000,
        theme: "colored",
      });
    }
  }
  downloadExitPass(OrderID, OrderNo) {
    const { userId } = this.state;
    this.setState({ isLoading: false });
    if (OrderID) {
      console.log(OrderID, OrderNo);
      const formattedOrderNo = OrderNo.replace(/[\/-]/g, "_");
      this.props
        .download_exitPass_action(userId, OrderID, formattedOrderNo)
        .then((downloadData) => {
          if (downloadData.error !== 1) {
            this.setState({ isLoading: false });
            console.log(downloadData);
            const url = `${downloadReport}?SessionIdentifier=${downloadData}&Export=true`;
            window.open(url, "_blank");
          } else {
            if (
              downloadData.msg == sessionExpireMessage ||
              downloadData.msg == tokenInavlidMessage
            ) {
              //after session expire.....................
              sessionStorage.clear();
              this.props.navigate("/normalView");
              setTimeout(() => {
                toast.error(downloadData.msg, {
                  position: "top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
            } else {
              this.setState({ isLoading: false });
              toast.error(downloadData.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 1000,
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ isLoading: false });
        });
    } else {
      this.setState({ isLoading: false });
      toast.error("Cannot download: OrderID not found.", {
        position: "top-center",
        theme: "colored",
        autoClose: 1000,
      });
    }
  }
  generateNoDue(OrderID) {
    this.setState({ isLoading: false });
    this.props
      .generate_nodue_action(OrderID)
      .then((data) => {
        console.log("No Due Generated", data, OrderID);
        if (data.error !== 1) {
          this.setState({ isLoading: false });
          toast.success("No Due Generated Successfully", {
            position: "top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
          this.getOrderEditDetails(); // Fetch the updated list of holidays
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            this.setState({ isLoading: false });
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  handleDelete(OrderID) {
    const {
      userId,
      OrderNo,
      CancellationReasonID,
      cancelNote,
      CompanyName,
      PrimaryEmailID,
      RoleID,
      OrderAmount,
    } = this.state;
    this.setState({ isLoading: false });
    // First, execute order_cancel_reason_action
    this.props
      .order_cancel_reason_action(
        userId,
        OrderID,
        CancellationReasonID,
        cancelNote,
        OrderNo,
        CompanyName,
        PrimaryEmailID,
        RoleID,
        OrderAmount
      )
      .then((data) => {
        if (data.error !== 1) {
          toast.success(
            `Your request to cancel the order ${OrderNo} has been submitted and send to the office. You will be intimated once confirm.`,
            {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            }
          );
          this.setState({ isLoading: false });
          this.deleteModalClose();
          this.getOrderEditDetails();
          this.props.navigate("/my_orders");
        } else {
          if (
            data.msg == sessionExpireMessage ||
            data.msg == tokenInavlidMessage
          ) {
            //after session expire.....................
            sessionStorage.clear();
            this.props.navigate("/normalView");
            setTimeout(() => {
              toast.error(data.msg, {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
          } else {
            toast.error(data.msg, {
              position: "top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  render() {
    const { displayRazorpay, orderPaymentDetails, FinalExitSubmit, piFilePath, exitPiFilePath, taxInvoiceFilePath,
      isLoading,
      isAccordionExpanded,
      isChatLoading,
      PiShow,
      userId,
      MyOrdersData,
      proformaList,
      OrderID,
      Date,
      OrderDate,
      ItmeCenter,
      deleteShow,
      OrderNo,
      additionalDiscount,
      AdditionalDiscount,
      AdditionalDiscountNote,
      Note,
      AdditionalServiceApprovalStatus,
      AdditionalServiceStatus,
      //client
      stateId,
      stateList,
      countryId,
      countryList,
      firstName,
      lastName,
      designation,
      companyName,
      addressLine1,
      addressLine2,
      cityId,
      cityList,
      pincode,
      Mobile1,
      Mobile2,
      ISD,
      primaryEmailID,
      secondaryEmailID,
      website,
      SameAsAbove,
      SAAFirstName,
      SAALastName,
      SAADesignation,
      SAAAddressLine1,
      SAAAddressLine2,
      SAACityId,
      SAAPincode,
      SAAMobile1,
      SAAMobile2,
      SAAISD,
      SAASTD,
      SAAPrimaryEmailID,
      SAASecondaryEmailID,
      SAAWebsite,
      SAAStateId,
      registrationNumber,
      PANCardNo,
      NameonPANCard,
      GSTNo,
      CompanyStatus,
      TANNumber,
      UINNumber,
      SAATelephoneNumber,
      TelephoneNumber,
      SAACountryId,
      mobileISD1,
      mobileISD2,
      SAAMobileISD1,
      SAAMobileISD2,
      isDisplayCityList,
      CityName,
      SAACityName,
      companyStatusId,
      companyStatusList,
      accountName,
      accountNo,
      accountType,
      bankName,
      branchName,
      IFSCCode,
      accountTypeList,
      SAACompanyName,
      firstNameErr,
      lastNameErr,
      organizerErr,
      addressLine1Err,
      addressLine2Err,
      CityNameErr,
      countryIdErr,
      pincodeErr,
      Mobile1Err,
      primaryEmailIDErr,
      SAAFirstNameErr,
      SAALastNameErr,
      SAAAddressLine1Err,
      SAAAddressLine2Err,
      SAACityNameErr,
      SAACountryIdErr,
      SAAPincodeErr,
      SAAMobile1Err,
      SAAPrimaryEmailIDErr,
      PANCardNoErr,
      NameonPANCardErr,
      accountNameErr,
      accountNoErr,
      accountTypeErr,
      bankNameErr,
      branchNameErr,
      IFSCCodeErr,
      SAACompanyNameErr,
      stateErr,
      SAAStateErr,
      isSAADisplayCityList,
      isDisplayStateList,
      isSAADisplayStateList,
      cancellationReasonList,
      CancellationReasonID,
      cancelNote,
      isEditMode,
      DeliveryStatus,
      //Additional Services
      SliderValue,
      minPrice,
      maxPrice,
      vendorNameList,
      serviceName,
      SelectedExtService,
      addRequirement,
      standardPremiumId,
      standardPremiumList,
      standerdArray,
      isOpen,
      fileList,
      additionalServicesList,
      CenterID,
      show,
      CurrencyID,
      unlistedAddServices,
      OtherInformation,
      includedServices,
      externalServices,
      vendorPackageList,
      downloadUrl,
      showPackageDetailsData,
      showtable,
      //booking Details
      EntryType,
      TypeOfEvent,
      SittingArrangement,
      bookingList,
      PossesionStartDate,
      PossesionEndDate,
      PossesionStartTime,
      PossesionEndTime,
      BookingEventDataList,
      dismantleStartDate,
      dismantleEndDate,
      dismantleStartTime,
      dismantleEndTime,
      //list Possession & Exit
      PosssesionOperationNameContact, oppPossessionSignatureData, ExitOperationNameContact, oppExitSignatureData,
      possessionIncludedServicesList,
      possessionConsumableList,
      PossessionContactNameAndNumber,
      exitConsumableList,
      ExitContactNameAndNumber,
      possessionInhouseServicesList,
      exitIncludedServicesList,
      exitCheckList,
      possessionCheckList,
      exitInhouseServicesList,
      exitDataListFlag,
      possessionDataListFlag,
      possessionSignatureData,
      ExitSignatureData,
      isExitList,
      isPossessionList,
      PossesionSubmittedUser,
      PossesionSubmittedDate,
      exitSub,
      possessionSub,
      possessionCheckListAllSelected,
      possessionMaterialNameAndServiceName,
      possessionMaterialList,
      possessionSecurityList,
      PossessionSecurityChecklistNote,
      possessionTime,
      exitTime,
      exitMaterialNameAndServiceName,
      exitCheckListAllSelected,
      exitMaterialList,
      exitSecurityList,
      ExitSecurityChecklistNote,
      AdditionHours,
      exitVendorList,
      ExitSubmittedBy,
      ExitSubmittedDate,
      existDataListFlag,
      exitListShow,
      possessionVendorList,
      electricityExit,
      electricityPossesion,
      unlistedAddServicesExit,
      exitInstructionList,
      AdditionHoursExit,
      ExitSubmittedUser,
      //rest
      StatusID,
      BookingDate,
      IsExitPassBy,
      IsExitPassDate,
      Is_ExitPass,
      Is_NoDue,
      NoDueBy,
      NoDueDate,
      EventCordinatorName,
      EventCordinatorDesignation,
      EventCordinatorEmail,
      EventCordinatorMobile,
      PrimaryContactName,
      PrimaryContactDesignation,
      PrimaryContactEmail,
      PrimaryContactMobile,
      EventCordinatorNameErr,
      EventCordinatorDesignationErr,
      EventCordinatorEmailErr,
      EventCordinatorMobileErr,
      PrimaryContactNameErr,
      PrimaryContactDesignationErr,
      PrimaryContactEmailErr,
      PrimaryContactMobileErr,
      //quotation section
      quotationFilePath,
      invoiceFilePath,
      receiptFilePath,
      additionalInvoiceFilePath,
      additionalReceiptFilePath,
      FinalAmount,
      AdditionalAmount,
      ServiceName,
      VendorCompany,
      IsOrderAcceptedbyVendor,
      IsOrderAcceptedbyClient,
      IsQuotationSubmitted,
      IsQuotationApproved,
      IsInvoiceSubmitted,
      IsPaymentReceived,
      FinalPaymentReceived,
      preTel,
      SAAPreTel,
      AreaCode,
      SAAAreaCode,
      IsFinalInvoiceSubmitted,
      ThirdPartyVendorOrderList,
      OrderAcceptedbyClientSignature,
      OrderAcceptedbyClientContact,
      OrderAcceptedbyClientSignatureBy,
      OrderAcceptedbyClientSignatureDate,
      chatHdr,
      chatDtl,
      isChatOpen,
      chat,
      chatServiceName,
      chatVendorCompany,
      chatVendorID,
      chatServiceID,
      chatOrderID,
    } = this.state;
    const roleId = sessionStorage.getItem("roleId");
    const validChatDtl = chatDtl.filter((message) =>
      moment(message.datetime, moment.ISO_8601, true).isValid()
    );

    // Sort chat messages by datetime using Moment.js
    const sortedChatDtl = validChatDtl.sort((a, b) =>
      moment(a.datetime).diff(moment(b.datetime))
    );

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[18]} />

            <div className="thankYou_page">

              <div className="thankYou_page_content">
                {MyOrdersData.length > 0 &&
                  MyOrdersData.map((data) => (
                    <div className="card product">
                      <div className="card-header">
                        <div className="order_no_and_date">
                          <div className="row">
                            <div className="col-md-6">
                              <p>Application No: {data.OrderID}</p>
                              <p>Order No : {data.OrderNo}</p>
                              <p>Order Date : {data.orderDate}</p>
                            </div>
                            <div className="col-md-6 text-right">
                              <h5>{data.DeliveryStatus}</h5>
                            </div>
                          </div>
                        </div>
                        <div className="search_accordion search_card">
                          <div className="panel-group" id="accordion">
                            <div className="panel panel-default">
                              <div
                                className="panel-heading accordion-toggle collapsed"
                                data-toggle="collapse"
                                data-parent="#accordion"
                                data-target="#collapseOne"
                                aria-expanded={isAccordionExpanded}
                                onClick={() =>
                                  this.setState({
                                    isAccordionExpanded: !isAccordionExpanded,
                                  })
                                }
                              >
                                <h4 className="panel-title">
                                  Organizer Details
                                </h4>
                              </div>
                              <div
                                id="collapseOne"
                                className={`panel-collapse collapse ${isAccordionExpanded ? "show" : ""
                                  }`}
                                aria-labelledby="headingOne"
                              >
                                <div class="text-right mx-3 row">
                                  <div class="col-10"></div>
                                  <div class="col-2">
                                    {isEditMode == true ? (
                                      <a
                                        href="javascript:void(0);"
                                        onClick={() => this.CompanyEditTrue()}
                                        className="btn btn-success"
                                      >
                                        Edit
                                      </a>
                                    ) : (
                                      <a
                                        href="javascript:void(0);"
                                        onClick={() => this.CompanyEditFalse()}
                                        className="btn btn-warning mx-2"
                                      >
                                        View
                                      </a>
                                    )}
                                  </div>
                                </div>
                                <div className="panel-body">
                                  <div className="card-body">
                                    <div className="company_info">
                                      <fieldset>
                                        <legend>
                                          Name and full address of the Organizer
                                        </legend>
                                        <div className="outside_input_field ">
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={firstName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    maxLength={30}
                                                    onChange={(e) =>
                                                      this.firstName(e)
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {firstNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    First Name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={lastName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    maxLength={30}
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.lastName(e)
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {lastNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Last Name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={designation}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    maxLength={50}
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.designation(e)
                                                    }
                                                  />
                                                  <span class="floating-label-outside">
                                                    Designation
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-12">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={companyName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    maxLength={100}
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.organizerName(e)
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {organizerErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Organizer / Organization
                                                    Name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group floating-group floating-diff">
                                                <label class="floating-label">
                                                  COUNTRY{" "}
                                                </label>
                                                <select
                                                  id="state"
                                                  name="Entry Type"
                                                  class="form-control floating-control"
                                                  // onKeyDown={(e) => this.handleKeyDown(e)}
                                                  value={countryId}
                                                  disabled={isEditMode}
                                                  style={{
                                                    background: isEditMode
                                                      ? "#FAFAFA"
                                                      : "none",
                                                  }}
                                                  onChange={(e) =>
                                                    this.onCountryId(e)
                                                  }
                                                >
                                                  <option value="">
                                                    Country
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </option>
                                                  {countryList.length > 0 &&
                                                    countryList.map((item) => (
                                                      <option
                                                        key={item.Countryid}
                                                        value={item.Countryid}
                                                      >
                                                        {item.CountryName}
                                                      </option>
                                                    ))}
                                                </select>
                                                {
                                                  <span className="text-danger text-start text-left d-block mt-1">
                                                    {countryIdErr}
                                                  </span>
                                                }
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={stateId}
                                                    type="text"
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    onChange={(e) =>
                                                      this.onStateSearch(e)
                                                    }
                                                    autocomplete="off"
                                                    maxLength={30}
                                                  />
                                                  {isDisplayStateList &&
                                                    this.renderStateList()}
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {stateErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    State Name
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={cityId}
                                                    type="text"
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    class="outside"
                                                    disabled={isEditMode}
                                                    required
                                                    onChange={(e) =>
                                                      this.onCitytSearch(e)
                                                    }
                                                    autocomplete="off"
                                                    maxLength={30}
                                                  />
                                                  {isDisplayCityList &&
                                                    this.renderCityList()}
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {CityNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    City Name
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={addressLine1}
                                                    type="text"
                                                    disabled={isEditMode}
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.addressLine1(e)
                                                    }
                                                    maxLength={70}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {addressLine1Err}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Address Line 1{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={addressLine2}
                                                    type="text"
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    onChange={(e) =>
                                                      this.addressLine2(e)
                                                    }
                                                    maxLength={70}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {addressLine2Err}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Address Line 2{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={pincode}
                                                    type="text"
                                                    class="outside"
                                                    disabled={isEditMode}
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.pincode(e)
                                                    }
                                                    maxLength={20}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {pincodeErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    {countryId == "91" ||
                                                      countryId == "" ||
                                                      countryId == "Country*"
                                                      ? "Pincode"
                                                      : "ZipCode"}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="tel_number">
                                                  <div class="ISD">
                                                    <input
                                                      type="text"
                                                      class="outside"
                                                      placeholder="ISD"
                                                      required
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      value={ISD}
                                                      disabled={true}
                                                    />
                                                  </div>
                                                  <div class="position-relative width_80">
                                                    <input
                                                      value={Mobile1}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      disabled={
                                                        isEditMode == true
                                                      }
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.mobile1(e)
                                                      }
                                                      maxLength={10}
                                                    />
                                                    {
                                                      <span className="text-danger text-start text-left d-block mt-1">
                                                        {Mobile1Err}
                                                      </span>
                                                    }
                                                    <span class="floating-label-outside">
                                                      Mobile 1{" "}
                                                      <span class="mendatory_class">
                                                        *
                                                      </span>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="tel_number">
                                                  <div class="ISD">
                                                    <input
                                                      type="text"
                                                      class="outside"
                                                      placeholder="ISD"
                                                      required
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      value={ISD}
                                                      disabled={true}
                                                    />
                                                  </div>
                                                  <div class="position-relative width_80">
                                                    <input
                                                      value={Mobile2}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      disabled={isEditMode}
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.mobile2(e)
                                                      }
                                                      maxLength={10}
                                                    />
                                                    <span class="floating-label-outside">
                                                      Mobile 2
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="tel_number">
                                                  <div class="ISD">
                                                    <input
                                                      type="text"
                                                      class="outside"
                                                      placeholder={
                                                        countryId == "91" ||
                                                          countryId == "" ||
                                                          countryId == "Country*"
                                                          ? "STD"
                                                          : "ISD"
                                                      }
                                                      disabled={isEditMode}
                                                      value={preTel}
                                                      required
                                                      onChange={(e) =>
                                                        this.preTelephone(e)
                                                      }
                                                      maxLength={5}
                                                    />
                                                  </div>
                                                  {countryId != "91" &&
                                                    countryId != "" &&
                                                    countryId != "Country*" ? (
                                                    <div class="ISD">
                                                      <input
                                                        type="text"
                                                        class="outside"
                                                        placeholder="CODE"
                                                        value={AreaCode}
                                                        required
                                                        disabled={isEditMode}
                                                        onChange={(e) =>
                                                          this.areaCode(e)
                                                        }
                                                        maxLength={10}
                                                      />
                                                    </div>
                                                  ) : (
                                                    <></>
                                                  )}
                                                  <div class="position-relative width_80">
                                                    <input
                                                      type="text"
                                                      class="outside"
                                                      value={TelephoneNumber}
                                                      required
                                                      disabled={isEditMode}
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.telephone(e)
                                                      }
                                                      maxLength={16}
                                                    />
                                                    <span class="floating-label-outside">
                                                      Telephone Number
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={primaryEmailID}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.primaryEmail(e)
                                                    }
                                                    maxLength={50}
                                                    disabled={isEditMode}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {primaryEmailIDErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Primary Email ID{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={secondaryEmailID}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.secondaryEmail(e)
                                                    }
                                                    maxLength={50}
                                                    disabled={isEditMode}
                                                  />
                                                  <span class="floating-label-outside">
                                                    Secondary Email ID{" "}
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={website}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.website(e)
                                                    }
                                                    maxLength={40}
                                                    disabled={isEditMode}
                                                  />
                                                  <span class="floating-label-outside">
                                                    Website{" "}
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </fieldset>
                                      <fieldset>
                                        <legend>
                                          Event Coordinator details{" "}
                                        </legend>

                                        <div class="outside_input_field ">
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={EventCordinatorName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    maxLength={30}
                                                    disabled={isEditMode}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        EventCordinatorName:
                                                          e.target.value
                                                            .replace(
                                                              /[^a-zA-Z]/g,
                                                              ""
                                                            )
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        EventCordinatorNameErr:
                                                          "",
                                                      })
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {EventCordinatorNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    {" "}
                                                    Name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={
                                                      EventCordinatorDesignation
                                                    }
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    maxLength={30}
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        EventCordinatorDesignation:
                                                          e.target.value
                                                            .replace(
                                                              /[^a-zA-Z]/g,
                                                              ""
                                                            )
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        EventCordinatorDesignationErr:
                                                          "",
                                                      })
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {
                                                        EventCordinatorDesignationErr
                                                      }
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Designation
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={EventCordinatorEmail}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    maxLength={30}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        EventCordinatorEmail:
                                                          e.target.value,
                                                        EventCordinatorEmailErr:
                                                          "",
                                                      })
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {EventCordinatorEmailErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Email
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={
                                                      EventCordinatorMobile
                                                    }
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    maxLength={30}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        EventCordinatorMobile:
                                                          e.target.value.replace(
                                                            /\D/,
                                                            ""
                                                          ),
                                                        EventCordinatorMobileErr:
                                                          "",
                                                      })
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {EventCordinatorMobileErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Mobile
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </fieldset>

                                      <fieldset>
                                        <legend>
                                          Primary Contact details{" "}
                                        </legend>

                                        <div class="outside_input_field ">
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={PrimaryContactName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    disabled={isEditMode}
                                                    maxLength={30}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        PrimaryContactName:
                                                          e.target.value
                                                            .replace(
                                                              /[^a-zA-Z]/g,
                                                              ""
                                                            )
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        PrimaryContactNameErr:
                                                          "",
                                                      })
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {PrimaryContactNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    {" "}
                                                    Name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={
                                                      PrimaryContactDesignation
                                                    }
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    maxLength={30}
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        PrimaryContactDesignation:
                                                          e.target.value
                                                            .replace(
                                                              /[^a-zA-Z]/g,
                                                              ""
                                                            )
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        PrimaryContactDesignationErr:
                                                          "",
                                                      })
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {
                                                        PrimaryContactDesignationErr
                                                      }
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Designation
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={PrimaryContactEmail}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    maxLength={30}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        PrimaryContactEmail:
                                                          e.target.value,
                                                        PrimaryContactEmailErr:
                                                          "",
                                                      })
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {PrimaryContactEmailErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Email
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={PrimaryContactMobile}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    maxLength={30}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        PrimaryContactMobile:
                                                          e.target.value.replace(
                                                            /\D/,
                                                            ""
                                                          ),
                                                        PrimaryContactMobileErr:
                                                          "",
                                                      })
                                                    }
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {PrimaryContactMobileErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Mobile
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </fieldset>
                                      <fieldset
                                        class={
                                          SameAsAbove
                                            ? "saveAsAbove_section"
                                            : ""
                                        }
                                      >
                                        <legend>Billing Address</legend>

                                        <div class="mb-2">
                                          <div class="bg">
                                            <div class="chiller_cb">
                                              <input
                                                value={SameAsAbove}
                                                id="SameAsAbove"
                                                type="checkbox"
                                                // onKeyDown={(e) => this.handleKeyDown(e)}
                                                selected={SameAsAbove}
                                                checked={SameAsAbove}
                                                onClick={
                                                  isEditMode == true
                                                    ? null
                                                    : (e) => this.SameAsAbove(e)
                                                }
                                                placeholder=""
                                              />
                                              <label
                                                for="SameAsAbove"
                                                style={{ color: "#979797" }}
                                              >
                                                Same As Above
                                              </label>
                                              <span></span>
                                            </div>
                                          </div>
                                        </div>

                                        <div class="outside_input_field">
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={SAAFirstName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    onChange={(e) =>
                                                      this.setState({
                                                        SAAFirstName:
                                                          e.target.value
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        SAAFirstNameErr: "",
                                                      })
                                                    }
                                                    maxLength={30}
                                                    disabled={SameAsAbove}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {SAAFirstNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    First Name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={SAALastName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    onChange={(e) =>
                                                      this.setState({
                                                        SAALastName:
                                                          e.target.value
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        SAALastNameErr: "",
                                                      })
                                                    }
                                                    maxLength={30}
                                                    disabled={SameAsAbove}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {SAALastNameErr}
                                                    </span>
                                                  }

                                                  <span class="floating-label-outside">
                                                    Last Name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    type="text"
                                                    value={SAADesignation}
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        SAADesignation:
                                                          e.target.value
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                      })
                                                    }
                                                    disabled={SameAsAbove}
                                                    maxLength={50}
                                                  />

                                                  <span class="floating-label-outside">
                                                    Designation{" "}
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-12">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={SAACompanyName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={SameAsAbove}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        SAACompanyName:
                                                          e.target.value
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        SAACompanyNameErr: "",
                                                      })
                                                    }
                                                    maxLength={100}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {SAACompanyNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Organizer / Organization
                                                    Name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group floating-group floating-diff">
                                                <select
                                                  id="state"
                                                  name="Entry Type"
                                                  class="form-control floating-control"
                                                  value={SAACountryId}
                                                  disabled={SameAsAbove}
                                                  style={{
                                                    background: SameAsAbove
                                                      ? "#FAFAFA"
                                                      : "none",
                                                  }}
                                                  // onKeyDown={(e) => this.handleKeyDown(e)}
                                                  onChange={(e) =>
                                                    this.onSAACountryId(e)
                                                  }
                                                >
                                                  <option>
                                                    Country
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </option>

                                                  {countryList.length > 0 &&
                                                    countryList.map((item) => (
                                                      <option
                                                        key={item.Countryid}
                                                        value={item.Countryid}
                                                      >
                                                        {item.CountryName}
                                                      </option>
                                                    ))}
                                                </select>
                                                {
                                                  <span className="text-danger text-start text-left d-block mt-1">
                                                    {SAACountryIdErr}
                                                  </span>
                                                }
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={SAAStateId}
                                                    type="text"
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    class="outside"
                                                    required
                                                    onChange={(e) =>
                                                      this.onSAAStateSearch(e)
                                                    }
                                                    autocomplete="off"
                                                    maxLength={30}
                                                    disabled={SameAsAbove}
                                                  />
                                                  {isSAADisplayStateList &&
                                                    this.renderSAAStateList()}
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {SAAStateErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    State Name
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={SAACityId}
                                                    type="text"
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    class="outside"
                                                    required
                                                    onChange={(e) =>
                                                      this.onSAACitytSearch(e)
                                                    }
                                                    autocomplete="off"
                                                    disabled={SameAsAbove}
                                                    maxLength={30}
                                                  />
                                                  {isSAADisplayCityList &&
                                                    this.renderSAACityList()}
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {SAACityNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    City Name
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={SAAAddressLine1}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        SAAAddressLine1:
                                                          e.target.value
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        SAAAddressLine1Err: "",
                                                      })
                                                    }
                                                    disabled={SameAsAbove}
                                                    maxLength={70}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {SAAAddressLine1Err}
                                                    </span>
                                                  }

                                                  <span class="floating-label-outside">
                                                    Address Line 1{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    type="text"
                                                    value={SAAAddressLine2}
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        SAAAddressLine2:
                                                          e.target.value
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        SAAAddressLine2Err: "",
                                                      })
                                                    }
                                                    disabled={
                                                      SameAsAbove ||
                                                      isEditMode == true
                                                    }
                                                    maxLength={70}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {SAAAddressLine2Err}
                                                    </span>
                                                  }

                                                  <span class="floating-label-outside">
                                                    Address Line 2{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={SAAPincode}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        SAAPincode:
                                                          e.target.value.replace(
                                                            /\D/,
                                                            ""
                                                          ),
                                                        SAAPincodeErr: "",
                                                      })
                                                    }
                                                    disabled={
                                                      SameAsAbove ||
                                                      isEditMode == true
                                                    }
                                                    maxLength={20}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {SAAPincodeErr}
                                                    </span>
                                                  }

                                                  <span class="floating-label-outside">
                                                    {SAACountryId == "91" ||
                                                      SAACountryId == "" ||
                                                      SAACountryId == "Country*"
                                                      ? "Pincode"
                                                      : "ZipCode"}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="tel_number">
                                                  <div class="ISD">
                                                    <input
                                                      type="text"
                                                      class="outside"
                                                      placeholder="ISD"
                                                      required
                                                      value={SAAISD}
                                                      disabled={true}
                                                    />
                                                  </div>
                                                  <div class="position-relative width_80">
                                                    <input
                                                      value={SAAMobile1}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.setState({
                                                          SAAMobile1:
                                                            e.target.value.replace(
                                                              /\D/,
                                                              ""
                                                            ),
                                                          SAAMobile1Err: "",
                                                        })
                                                      }
                                                      maxLength={10}
                                                      disabled={SameAsAbove}
                                                    />
                                                    {
                                                      <span className="text-danger text-start text-left d-block mt-1">
                                                        {SAAMobile1Err}
                                                      </span>
                                                    }
                                                    <span class="floating-label-outside">
                                                      Mobile 1{" "}
                                                      <span class="mendatory_class">
                                                        *
                                                      </span>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="tel_number">
                                                  <div class="ISD">
                                                    <input
                                                      type="text"
                                                      class="outside"
                                                      placeholder="ISD"
                                                      required
                                                      value={SAAISD}
                                                      disabled={true}
                                                    />
                                                  </div>
                                                  <div class="position-relative width_80">
                                                    <input
                                                      value={SAAMobile2}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.setState({
                                                          SAAMobile2:
                                                            e.target.value.replace(
                                                              /\D/,
                                                              ""
                                                            ),
                                                        })
                                                      }
                                                      maxLength={10}
                                                      disabled={SameAsAbove}
                                                    />

                                                    <span class="floating-label-outside">
                                                      Mobile 2{" "}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="tel_number">
                                                  <div class="ISD">
                                                    <input
                                                      type="text"
                                                      class="outside"
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      placeholder="ISD"
                                                      value={SAAISD}
                                                      required
                                                      disabled={true}
                                                    />
                                                  </div>
                                                  <div class="position-relative width_80">
                                                    <input
                                                      value={SAATelephoneNumber}
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      onChange={(e) =>
                                                        this.setState({
                                                          SAATelephoneNumber:
                                                            e.target.value.replace(
                                                              /\D/,
                                                              ""
                                                            ),
                                                        })
                                                      }
                                                      disabled={SameAsAbove}
                                                      maxLength={16}
                                                    />
                                                    <span class="floating-label-outside">
                                                      Telephone Number{" "}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    type="text"
                                                    value={SAAPrimaryEmailID}
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        SAAPrimaryEmailID:
                                                          e.target.value,
                                                        SAAPrimaryEmailIDErr:
                                                          "",
                                                      })
                                                    }
                                                    disabled={SameAsAbove}
                                                    maxLength={50}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {SAAPrimaryEmailIDErr}
                                                    </span>
                                                  }

                                                  <span class="floating-label-outside">
                                                    Primary Email ID{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={SAASecondaryEmailID}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        SAASecondaryEmailID:
                                                          e.target.value,
                                                      })
                                                    }
                                                    disabled={SameAsAbove}
                                                    maxLength={50}
                                                  />

                                                  <span class="floating-label-outside">
                                                    Secondary Email ID{" "}
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={SAAWebsite}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        SAAWebsite:
                                                          e.target.value,
                                                      })
                                                    }
                                                    disabled={SameAsAbove}
                                                    maxLength={40}
                                                  />

                                                  <span class="floating-label-outside">
                                                    Website{" "}
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </fieldset>
                                      {countryId == "91" ? (
                                        <fieldset>
                                          <legend>
                                            Organizer's / Organization's
                                            Information
                                          </legend>
                                          <div class="outside_input_field ">
                                            <div class="row">
                                              <div class="col-md-4">
                                                <div class="form-group">
                                                  <div class="position-relative">
                                                    <input
                                                      value={registrationNumber}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      disabled={isEditMode}
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.setState({
                                                          registrationNumber:
                                                            e.target.value.toUpperCase(),
                                                        })
                                                      }
                                                      maxLength={20}
                                                    />
                                                    <span class="floating-label-outside">
                                                      Registration Number{" "}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col-md-4">
                                                <div class="form-group">
                                                  <div class="position-relative">
                                                    <input
                                                      value={PANCardNo}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      disabled={isEditMode}
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.setState({
                                                          PANCardNo:
                                                            e.target.value.toUpperCase(),
                                                          PANCardNoErr: "",
                                                        })
                                                      }
                                                      maxLength={10}
                                                    />
                                                    {
                                                      <span className="text-danger text-start text-left d-block mt-1">
                                                        {PANCardNoErr}
                                                      </span>
                                                    }
                                                    <span class="floating-label-outside">
                                                      PAN Card No.{" "}
                                                      <span class="mendatory_class">
                                                        *
                                                      </span>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col-md-4">
                                                <div class="form-group">
                                                  <div class="position-relative">
                                                    <input
                                                      value={NameonPANCard}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      disabled={isEditMode}
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.setState({
                                                          NameonPANCard:
                                                            e.target.value
                                                              .split(" ")
                                                              .map(
                                                                (word) =>
                                                                  word
                                                                    .charAt(0)
                                                                    .toUpperCase() +
                                                                  word.slice(1)
                                                              )
                                                              .join(" "),
                                                          NameonPANCardErr: "",
                                                        })
                                                      }
                                                      maxLength={50}
                                                    />
                                                    {
                                                      <span className="text-danger text-start text-left d-block mt-1">
                                                        {NameonPANCardErr}
                                                      </span>
                                                    }
                                                    <span class="floating-label-outside">
                                                      Name on PAN Card{" "}
                                                      <span class="mendatory_class">
                                                        *
                                                      </span>
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="row">
                                              <div class="col-md-4">
                                                <div class="form-group">
                                                  <div class="position-relative">
                                                    <input
                                                      value={GSTNo}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      disabled={isEditMode}
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.setState({
                                                          GSTNo:
                                                            e.target.value.toUpperCase(),
                                                        })
                                                      }
                                                    />
                                                    <span class="floating-label-outside">
                                                      GST No.{" "}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>

                                              <div class="col-md-4">
                                                <div class="form-group">
                                                  <div class="position-relative">
                                                    <input
                                                      value={TANNumber}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      disabled={isEditMode}
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.setState({
                                                          TANNumber:
                                                            e.target.value.toUpperCase(),
                                                        })
                                                      }
                                                      maxLength={20}
                                                    />
                                                    <span class="floating-label-outside">
                                                      TAN Number{" "}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>

                                              <div class="col-md-4">
                                                <div class="form-group">
                                                  <div class="position-relative">
                                                    <input
                                                      value={UINNumber}
                                                      type="text"
                                                      class="outside"
                                                      required
                                                      disabled={isEditMode}
                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                      onChange={(e) =>
                                                        this.setState({
                                                          UINNumber:
                                                            e.target.value.toUpperCase(),
                                                        })
                                                      }
                                                      maxLength={20}
                                                    />
                                                    <span class="floating-label-outside">
                                                      UIN Number{" "}
                                                    </span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </fieldset>
                                      ) : (
                                        <></>
                                      )}
                                      <fieldset>
                                        <legend>Banking details</legend>
                                        <div class="outside_input_field ">
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={accountName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={
                                                      isEditMode == true
                                                    }
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        accountName:
                                                          e.target.value
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        accountNameErr: "",
                                                      })
                                                    }
                                                    maxLength={50}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {accountNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Account Name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={accountNo}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        accountNo:
                                                          e.target.value.replace(
                                                            /\D/,
                                                            ""
                                                          ),
                                                        accountNoErr: "",
                                                      })
                                                    }
                                                    maxLength={30}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {accountNoErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Account No.{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group floating-group floating-diff">
                                                <select
                                                  id="state"
                                                  name="Entry Type"
                                                  class="form-control floating-control"
                                                  value={accountType}
                                                  style={{
                                                    background: isEditMode
                                                      ? "#FAFAFA"
                                                      : "none",
                                                  }}
                                                  onChange={
                                                    isEditMode
                                                      ? null
                                                      : (e) =>
                                                        this.setState({
                                                          accountType:
                                                            e.target.value,
                                                          accountTypeErr: "",
                                                        })
                                                  }
                                                >
                                                  <option>
                                                    Account Type
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </option>

                                                  {accountTypeList.length > 0 &&
                                                    accountTypeList.map(
                                                      (item) => (
                                                        <option>
                                                          {item.Accounttype}
                                                        </option>
                                                      )
                                                    )}
                                                </select>
                                                {
                                                  <span className="text-danger text-start text-left d-block mt-1">
                                                    {accountTypeErr}
                                                  </span>
                                                }
                                              </div>
                                            </div>
                                          </div>
                                          <div class="row">
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={bankName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={isEditMode}
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        bankName: e.target.value
                                                          .split(" ")
                                                          .map(
                                                            (word) =>
                                                              word
                                                                .charAt(0)
                                                                .toUpperCase() +
                                                              word.slice(1)
                                                          )
                                                          .join(" "),
                                                        bankNameErr: "",
                                                      })
                                                    }
                                                    maxLength={50}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {bankNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    Bank name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={branchName}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={
                                                      isEditMode == true
                                                    }
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        branchName:
                                                          e.target.value
                                                            .split(" ")
                                                            .map(
                                                              (word) =>
                                                                word
                                                                  .charAt(0)
                                                                  .toUpperCase() +
                                                                word.slice(1)
                                                            )
                                                            .join(" "),
                                                        branchNameErr: "",
                                                      })
                                                    }
                                                    maxLength={30}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {branchNameErr}
                                                    </span>
                                                  }
                                                  <span class="floating-label-outside">
                                                    branch name{" "}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col-md-4">
                                              <div class="form-group">
                                                <div class="position-relative">
                                                  <input
                                                    value={IFSCCode}
                                                    type="text"
                                                    class="outside"
                                                    required
                                                    disabled={
                                                      isEditMode == true
                                                    }
                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        IFSCCode:
                                                          e.target.value.toUpperCase(),
                                                        IFSCCodeErr: "",
                                                      })
                                                    }
                                                    maxLength={20}
                                                  />
                                                  {
                                                    <span className="text-danger text-start text-left d-block mt-1">
                                                      {IFSCCodeErr}
                                                    </span>
                                                  }

                                                  <span class="floating-label-outside">
                                                    {countryId == "91" ||
                                                      countryId == "" ||
                                                      countryId == "Country*"
                                                      ? "IFSC code"
                                                      : "Swift code"}
                                                    <span class="mendatory_class">
                                                      *
                                                    </span>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </fieldset>
                                    </div>
                                    <div className="row">
                                      <div className="mx-3">
                                        {isEditMode == false ? (
                                          <a
                                            href="javascript:void(0);"
                                            onClick={(e) => this.editCompany(e)}
                                            className="btn save_btn"
                                          >
                                            Save
                                          </a>
                                        ) : null}
                                      </div>
                                      <div className="mx-3">
                                        <a
                                          href="javascript:void(0);"
                                          onClick={() =>
                                            this.setState({
                                              isAccordionExpanded:
                                                !isAccordionExpanded,
                                              isEditMode: true,
                                            })
                                          }
                                          className="btn back_btn"
                                        >
                                          Close
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="d-flex align-items-center gap-2 text-muted"
                          style={{ justifyContent: "space-between" }}
                        >
                          <div>
                            <h5 className="text-truncate head_text">
                              <a
                                href="javascript:void(0);"
                                className="text-dark"
                              >
                                {data.centerName}
                              </a>
                            </h5>
                            <p className="text-muted Address_para">
                              <i className="fa fa-map-marker" />
                              &nbsp;
                              {data.centerAdd}
                            </p>
                          </div>

                          <div className="row">
                            <div className="col-4">
                              <Link
                                to="bottom"
                                class="nav-link"
                                style={{ cursor: "pointer", background: '#87CEFA', color: 'white', borderRadius: '12px' }}
                                smooth={true}
                                duration={500}
                                offset={-100}
                              >
                                <i class="fa fa-solid fa-arrow-down"></i>
                              </Link>
                            </div>
                            {this.isProformaDownload(
                              MyOrdersData.map(
                                (data) => data.DeliveryStatus
                              ).join("")
                            ) ? (
                              <div className="col-8">
                                <button
                                  onClick={() =>
                                    this.piModalShow(
                                      data.OrderID,
                                      data.OrderNo,
                                      proformaList
                                    )
                                  }
                                  class="btn btn-success btn-sm fs-12"
                                >
                                  {" "}
                                  <a>
                                    <i class="fa fa-download"></i> Download
                                  </a>
                                </button>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                      <div className="row ml-1">
                        <div class="col">
                          <ul className="nav nav-tabs" style={{ width: '100%' }}>
                            <li className="nav-item">
                              <Link
                                to="rental"
                                class="nav-link active"
                                style={{ cursor: "pointer" }}
                                smooth={true}
                                duration={500}
                                offset={-100}
                              >
                                Order Summary
                              </Link>
                            </li>
                            {this.IsAddAdditionalServices(
                              data.DeliveryStatus ||
                              this.props.location.state.DeliveryStatus,
                              data.paymentStatus
                            ) ? (
                              <li class="nav-item">
                                <Link
                                  to="additionalService"
                                  class="nav-link"
                                  smooth={true}
                                  style={{ cursor: "pointer" }}
                                  duration={500}
                                  offset={-100}
                                >
                                  Additional Services
                                </Link>
                              </li>
                            ) : null}
                            {data.DeliveryStatus === "Approved" ||
                              data.DeliveryStatus === "Confirmed" ||
                              data.DeliveryStatus === "Delivered" ? (
                              <li class="nav-item">
                                <Link
                                  to="additionalServiceVendor"
                                  class="nav-link"
                                  style={{ cursor: "pointer" }}
                                  smooth={true}
                                  duration={500}
                                  offset={-100}
                                >
                                  Additional Vendor Services
                                </Link>
                              </li>
                            ) : (
                              <></>
                            )}
                            {PossesionSubmittedUser != ""
                              ? (
                                <li class="nav-item">
                                  <Link
                                    to="checklist"
                                    class="nav-link"
                                    style={{ cursor: "pointer" }}
                                    smooth={true}
                                    duration={500}
                                    offset={-100}
                                  >
                                    CheckList
                                  </Link>
                                </li>
                              ) : null}
                          </ul>
                        </div>
                        <div class="col-sm"></div>
                      </div>
                      <div className="row">
                        <div className="col-md-8">
                          <div className="card-body order_edit_css">
                            <div className=" gy-3">
                              <Element name="rental" className="element">
                                <legend>Order Summary</legend>
                              </Element>
                              <fieldset style={{ marginLeft: '10px' }}>
                                <div className="slot_para">
                                  <h6>Summary</h6>
                                  <div className="row mr_0">
                                    <div className="col-md-4 padding_0">
                                      <span>
                                        <strong>Type of Event</strong>
                                      </span>
                                    </div>
                                    <div className="col-md-4 padding_0">
                                      <span>
                                        <strong>Seating Arrangement</strong>
                                      </span>
                                    </div>
                                  </div>
                                  <div className="row mr_0">
                                    <div className="col-md-4 padding_0">
                                      <span>
                                        {TypeOfEvent
                                          ? TypeOfEvent
                                          : "Not Available"}
                                      </span>
                                    </div>
                                    <div className="col-md-4 padding_0">
                                      <span>
                                        {SittingArrangement
                                          ? SittingArrangement
                                          : "Not Available"}
                                      </span>
                                    </div>
                                  </div>

                                  <hr />
                                  <div className="row mr_0">
                                    <div className="col-md-4 padding_0">
                                      <span>
                                        <strong>Booking Date</strong>
                                      </span>
                                    </div>
                                    <div className="col-md-3 padding_0">
                                      <span>
                                        <strong>Booking Slot</strong>
                                      </span>
                                    </div>
                                    <div className="col-md-2 padding_0 text-center">
                                      <span>
                                        <strong>Selected Hrs</strong>
                                      </span>
                                    </div>
                                    <div className="col-md-3 padding_0 text-right">
                                      <span>
                                        <strong>Amount</strong>
                                      </span>
                                    </div>
                                  </div>

                                  {data.summary.map((summaryItem, index) => (
                                    <div key={index} className="row mr_0">
                                      <div className="col-md-4 padding_0">
                                        <span>
                                          {this.formatDate(
                                            summaryItem.BookingDate
                                          )}
                                        </span>
                                      </div>
                                      <div className="col-md-3 padding_0">
                                        <span>{summaryItem.BookingSlot}</span>
                                      </div>
                                      <div className="col-md-2 padding_0 text-center">
                                        <span>{summaryItem.Selectedhrs}</span>
                                      </div>
                                      <div className="col-md-3 padding_0 text-right">
                                        <span>
                                          {data.currency == "INR" ? "₹" : "$"}{" "}
                                          {summaryItem.NetAmount.toLocaleString(
                                            "en-IN"
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                                <div className="add_service_para" style={{ margin: '1rem' }}>
                                  <h6></h6>
                                  <div className="row mr_0">
                                    <div className="col-md-4 padding_0">
                                      <span>
                                        <strong>Dates</strong>
                                      </span>
                                    </div>
                                    <div className="col-md-2 padding_0 text-center">
                                      <span>
                                        <strong>Start Date</strong>
                                      </span>
                                    </div>
                                    <div className="col-md-2 padding_0 text-center">
                                      <span>
                                        <strong>End Date</strong>
                                      </span>
                                    </div>
                                    <div className="col-md-2 padding_0 text-center">
                                      <span>
                                        <strong>Start Time</strong>
                                      </span>
                                    </div>
                                    <div className="col-md-2 padding_0 text-center">
                                      <span>
                                        <strong>End Time</strong>
                                      </span>
                                    </div>
                                  </div>
                                  <div className="row mr_0">
                                    {/* <div className="col-md-4 padding_0">
                                    <span>Possession Date</span>
                                  </div>
                                  <div className="col-md-2 padding_0 text-center">
                                    <span>
                                      {PossesionStartDate
                                        ? this.formatDate(PossesionStartDate)
                                        : "--"}
                                    </span>
                                  </div>
                                  <div className="col-md-2 padding_0 text-center">
                                    <span>
                                      {PossesionEndDate
                                        ? this.formatDate(PossesionEndDate)
                                        : "--"}
                                    </span>
                                  </div>
                                  <div className="col-md-2 padding_0 text-center">
                                    <span>
                                      {PossesionStartTime
                                        ? PossesionStartTime
                                        : "--"}
                                    </span>
                                  </div>
                                  <div className="col-md-2 padding_0 text-center">
                                    <span>
                                      {PossesionEndTime
                                        ? PossesionEndTime
                                        : "--"}
                                    </span>
                                  </div> */}
                                    {BookingEventDataList.map(
                                      (eventData, index) => (
                                        <React.Fragment key={index}>
                                          <div className="col-md-4 padding_0">
                                            <span>Event Date</span>
                                          </div>
                                          <div className="col-md-2 padding_0 text-center">
                                            <span>
                                              {eventData.EventStartDate
                                                ? this.formatDate(
                                                  eventData.EventStartDate
                                                )
                                                : "--"}
                                            </span>
                                          </div>
                                          <div className="col-md-2 padding_0 text-center">
                                            <span>
                                              {eventData.EventEndDate
                                                ? this.formatDate(
                                                  eventData.EventEndDate
                                                )
                                                : "--"}
                                            </span>
                                          </div>
                                          <div className="col-md-2 padding_0 text-center">
                                            <span>
                                              {eventData.EventStartTime
                                                ? eventData.EventStartTime
                                                : "--"}
                                            </span>
                                          </div>
                                          <div className="col-md-2 padding_0 text-center">
                                            <span>
                                              {eventData.EventEndTime
                                                ? eventData.EventEndTime
                                                : "--"}
                                            </span>
                                          </div>
                                        </React.Fragment>
                                      )
                                    )}
                                    {/* <div className="col-md-4 padding_0">
                                    <span>Dismantle Date</span>
                                  </div>
                                  <div className="col-md-2 padding_0 text-center">
                                    <span>
                                      {dismantleStartDate
                                        ? this.formatDate(dismantleStartDate)
                                        : "--"}
                                    </span>
                                  </div>
                                  <div className="col-md-2 padding_0 text-center">
                                    <span>
                                      {dismantleEndDate
                                        ? this.formatDate(dismantleEndDate)
                                        : "--"}
                                    </span>
                                  </div>
                                  <div className="col-md-2 padding_0 text-center">
                                    <span>
                                      {dismantleStartTime
                                        ? dismantleStartTime
                                        : "--"}
                                    </span>
                                  </div>
                                  <div className="col-md-2 padding_0 text-center">
                                    <span>
                                      {dismantleEndTime
                                        ? dismantleEndTime
                                        : "--"}
                                    </span>
                                  </div> */}
                                  </div>
                                </div>
                              </fieldset>
                            </div>
                            <fieldset style={{ marginLeft: '10px' }}>
                              <div className="slot_para">
                                <h6>Billing Details</h6>
                                <div className="card-footer">
                                  <div className="align-items-center gy-3">
                                    <div className="">
                                      {data.Price?.DiscountAmount == 0 ? (
                                        <></>
                                      ) : (
                                        <>
                                          <div
                                            className="d-flex align-items-center gap-2 text-muted"
                                            style={{ justifyContent: "space-between", background: "#f1f1f1" }}
                                          >
                                            <div className="width_100 my_color">
                                              Venue Hire Charges
                                            </div>
                                            <h5 className="fs-14 mb-0 my_color">
                                              {data.currency == "INR" ? "₹" : "$"}
                                              <span className="product-line-price">
                                                {parseInt(data.Price?.GrossAmount, 10)
                                                  ? parseInt(data.Price?.GrossAmount, 10).toLocaleString("en-IN", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                  }) : "0.00"}
                                              </span>
                                            </h5>
                                          </div>
                                          <div
                                            className="d-flex align-items-center gap-2 text-muted"
                                            style={{
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <div className="width_100 my_color">
                                              Discount
                                            </div>
                                            <h5 className="fs-14 mb-0 text-danger">
                                              -{data.currency == "INR" ? "₹" : "$"}
                                              <span className="product-line-price">
                                                {parseInt(data.Price?.DiscountAmount, 10)
                                                  ? parseInt(data.Price?.DiscountAmount, 10).toLocaleString("en-IN", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                  }) : "0.00"}
                                              </span>
                                            </h5>
                                          </div>
                                        </>
                                      )}

                                      <div
                                        className="d-flex align-items-center gap-2 text-muted"
                                        style={{ justifyContent: "space-between", background: "#f1f1f1" }}
                                      >
                                        <div className="width_100 my_color">
                                          <b> A) Hire Venue Rental Net Amount</b>
                                        </div>
                                        <h5 className="fs-14 mb-0 my_color">
                                          {data.currency == "INR" ? "₹" : "$"}
                                          <span className="product-line-price">
                                            {data.Price?.NetAmount
                                              ? data.Price?.NetAmount?.toLocaleString("en-IN", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              }) : "0.00"}
                                          </span>
                                        </h5>
                                      </div>
                                      <div
                                        className="d-flex align-items-center gap-2 text-muted"
                                        style={{ justifyContent: "space-between", background: "#f1f1f1" }}
                                      >
                                        <div className="width_100 my_color">
                                          <b> B) Additional Paid Services Amount</b>
                                        </div>
                                        <h5 className="fs-14 mb-0 my_color">
                                          {data.currency == "INR" ? "₹" : "$"}
                                          <span className="product-line-price">
                                            {data.Price?.ServiceTotal
                                              ? data.Price?.ServiceTotal?.toLocaleString("en-IN", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              }) : "0.00"}
                                          </span>
                                        </h5>
                                      </div>
                                      {data.additionalChargesDetails[0]
                                        ?.AdditionalHourCharges == 0 || data.additionalChargesDetails[0]
                                          ?.AdditionalHourCharges == null ? (
                                        <></>
                                      ) : (
                                        <>
                                          <div
                                            className="d-flex align-items-center gap-2 text-muted"
                                            style={{
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <div className="width_100 my_color">
                                              Additional Hour Charges
                                            </div>
                                            <h5 className="fs-14 mb-0 my_color">
                                              {data.currency == "INR" ? "₹" : "$"}
                                              <span className="product-line-price">
                                                {data.DeliveryStatus ===
                                                  "Pending for Verification"
                                                  ? "0.00"
                                                  : data.additionalChargesDetails[0]
                                                    ?.AdditionalHourCharges
                                                    ? data.additionalChargesDetails[0]?.AdditionalHourCharges?.toLocaleString("en-IN", {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                    }) : "0.00"}
                                              </span>
                                            </h5>
                                          </div>
                                        </>
                                      )}
                                      {data.additionalChargesDetails[0]
                                        ?.OvernightCharges == 0 ||
                                        data.additionalChargesDetails[0]
                                          ?.OvernightCharges == null ? (
                                        <></>
                                      ) : (
                                        <>
                                          <div
                                            className="d-flex align-items-center gap-2 text-muted"
                                            style={{
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <div className="width_100 my_color">
                                              Overnight Charges
                                            </div>
                                            <h5 className="fs-14 mb-0 my_color">
                                              {data.currency == "INR" ? "₹" : "$"}
                                              <span className="product-line-price">
                                                {data.additionalChargesDetails[0]
                                                  ?.OvernightCharges
                                                  ? data.additionalChargesDetails[0]?.OvernightCharges?.toLocaleString("en-IN", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                  }) : "0.00"}
                                              </span>
                                            </h5>
                                          </div>
                                        </>
                                      )}
                                      {MyOrdersData.map(
                                        (data) => data.AdditionalDiscountNote
                                      ).join(" ") == 0 ? (
                                        <></>
                                      ) : (
                                        <>
                                          <div
                                            className="d-flex align-items-center gap-2 text-muted"
                                            style={{
                                              justifyContent: "space-between",
                                            }}
                                          >
                                            <div className="width_100 my_color">
                                              Additional Discount
                                            </div>
                                            {data.DeliveryStatus ===
                                              "Pending for Verification"
                                              ? ""
                                              : MyOrdersData.map(
                                                (data) =>
                                                  data.AdditionalDiscountNote
                                              ).join(" ")}
                                            &nbsp;
                                            <h5 className="fs-14 mb-0 my_color">
                                              {data.currency == "INR" ? "₹" : "$"}
                                              <span className="product-line-price">
                                                {data.DeliveryStatus ===
                                                  "Pending for Verification"
                                                  ? "0"
                                                  : MyOrdersData.map(
                                                    (data) =>
                                                      data.AdditionalDiscount
                                                  ).join(" ")
                                                    ? MyOrdersData.map(
                                                      (data) =>
                                                        data.AdditionalDiscount
                                                    )
                                                      .join(" ")
                                                      .toLocaleString("en-IN", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                      }) : "0.00"}
                                              </span>
                                            </h5>
                                          </div>
                                        </>
                                      )}

                                      <div
                                        className="d-flex align-items-center gap-2 text-muted"
                                        style={{ justifyContent: "space-between" }}
                                      >
                                        <div className="width_100 my_color">
                                          Sub Total Amount
                                        </div>
                                        <h5 className="fs-14 mb-0 my_color">
                                          {data.currency == "INR" ? "₹" : "$"}
                                          <span className="product-line-price">
                                            {data.Price?.SubTotal
                                              ? data.Price?.SubTotal?.toLocaleString("en-IN", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              }) : "0.00"}
                                          </span>
                                        </h5>
                                      </div>

                                      <div
                                        className="d-flex align-items-center gap-2 text-muted"
                                        style={{ justifyContent: "space-between" }}
                                      >
                                        <div className="width_100 my_color">
                                          GST ( 18% )
                                        </div>
                                        <h5 className="fs-14 mb-0 my_color">
                                          {data.currency == "INR" ? "₹" : "$"}
                                          <span className="product-line-price">
                                            {data.Price?.GST
                                              ? data.Price?.GST?.toLocaleString("en-IN", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              }) : "0.00"}
                                          </span>
                                        </h5>
                                      </div>
                                      <div
                                        className="d-flex align-items-center gap-2 text-muted"
                                        style={{ justifyContent: "space-between", background: "#f1f1f1" }}
                                      >
                                        <div className="width_100 my_color">
                                          <b> C) Refundable Security Deposit</b>
                                        </div>
                                        <h5 className="fs-14 mb-0 my_color">
                                          {data.currency == "INR" ? "₹" : "$"}
                                          <span className="product-line-price">
                                            {parseInt(data.Price?.SecurityDeposit, 10)
                                              ? parseInt(data.Price?.SecurityDeposit, 10)
                                                .toLocaleString("en-IN", {
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2,
                                                }) : "0.00"}
                                          </span>
                                        </h5>
                                      </div>

                                      <hr
                                        style={{
                                          margin: "5px 0px",
                                          borderTop: "1px dashed rgba(0,0,0,.1)",
                                        }}
                                      />
                                      <div
                                        className="d-flex align-items-center gap-2 text-muted"
                                        style={{ justifyContent: "space-between" }}
                                      >
                                        <div className="width_100 my_color">
                                          <b>Total</b>
                                        </div>
                                        <h5 className="fs-14 mb-0 my_color">
                                          {data.currency == "INR" ? "₹" : "$"}
                                          <span className="product-line-price">
                                            <b>
                                              {data.Price?.Total
                                                ? data.Price?.Total?.toLocaleString("en-IN", {
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2,
                                                }) : "0.00"}
                                            </b>
                                          </span>
                                        </h5>
                                      </div>

                                      <div
                                        className="d-flex align-items-center gap-2 text-muted"
                                        style={{ justifyContent: "space-between" }}
                                      >
                                        <div className="width_100 my_color">
                                          <b>Payment Recieved</b>
                                        </div>
                                        <h5 className="fs-14 mb-0 my_color">
                                          {data.currency == "INR" ? "₹" : "$"}
                                          <span className="product-line-price">
                                            <b>
                                              {data.proformaDetails[0]?.Paid ?
                                                data.proformaDetails[0]?.Paid?.toLocaleString("en-IN", {
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2,
                                                }) : "0.00"}
                                            </b>
                                          </span>
                                        </h5>
                                      </div>
                                      <div
                                        className="d-flex align-items-center gap-2 text-muted"
                                        style={{ justifyContent: "space-between" }}
                                      >
                                        <div className="width_100 my_color">
                                          <b>Balance</b>
                                        </div>
                                        <h5 className="fs-14 mb-0 my_color">
                                          {data.currency == "INR" ? "₹" : "$"}
                                          <span className="product-line-price">
                                            <b>
                                              {data.proformaDetails[0]?.Outstanding ?
                                                data.proformaDetails[0]?.Outstanding?.toLocaleString("en-IN", {
                                                  minimumFractionDigits: 2,
                                                  maximumFractionDigits: 2,
                                                }) : "0.00"}
                                            </b>
                                          </span>
                                        </h5>
                                      </div>
                                    </div>
                                    {/* Online payment part */}
                                    <div className="row">
                                      <div className="col-md-6">
                                        {this.renderPaymentForm(
                                          data.paymentStatus,
                                          data.DeliveryStatus ||
                                          this.props.location.state.DeliveryStatus
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </fieldset>
                          </div>
                        </div>
                        <div className="col-md-4" />
                      </div>
                      <hr />
                      {this.IsAddAdditionalServices(
                        data.DeliveryStatus ||
                        this.props.location.state.DeliveryStatus,
                        data.paymentStatus
                      ) ? (
                        <>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="card-body order_edit_css">
                                <div className=" gy-3">
                                  <Element
                                    name="additionalService"
                                    className="element"
                                  >
                                    <legend>Additional Services</legend>
                                  </Element>
                                  {AdditionalServiceStatus == 0 ? (
                                    <span style={{ color: "red" }}>
                                      *Kindly check the selected Additional
                                      Services and make changes if required and
                                      submit.
                                    </span>
                                  ) : (
                                    <span style={{ color: "red" }}>
                                      *Kindly contact to Admin for change in
                                      Additional Services.
                                    </span>
                                  )}
                                  <div
                                    className="slot_para"
                                    style={{ margin: "15px" }}
                                  >
                                    <div className="row">
                                      <div className="col-md-8">
                                        <div className="add_service_para">
                                          <fieldset>
                                            <div className="slot_para">
                                              <h6>Additional Services</h6>
                                              <div className="row mr_0">
                                                <div className="col-md-3 padding_0">
                                                  <span>
                                                    <strong>Services</strong>
                                                  </span>
                                                </div>
                                                <div className="col-md-3 padding_0 text-center">
                                                  <span>
                                                    <strong>Type</strong>
                                                  </span>
                                                </div>
                                                <div className="col-md-3 padding_0 text-center">
                                                  <span>
                                                    <strong>Quantity</strong>
                                                  </span>
                                                </div>
                                                <div className="col-md-3 padding_0 text-right">
                                                  <span>
                                                    <strong>Amount (INR)</strong>
                                                  </span>
                                                </div>
                                              </div>

                                              {data.additionalServices.length > 0 ? (
                                                data.additionalServices.map(
                                                  (service, index) => (
                                                    <div
                                                      key={index}
                                                      className="row mr_0"
                                                    >
                                                      {service.Services ? (
                                                        <>
                                                          <div className="col-md-3 padding_0">
                                                            <span>
                                                              {service.Services}
                                                            </span>
                                                          </div>
                                                          <div className="col-md-3 padding_0 text-center">
                                                            <span>
                                                              {service.Services ==
                                                                "Electricity"
                                                                ? "-"
                                                                : service.Type === "S"
                                                                  ? "Standard"
                                                                  : "Premium"}
                                                            </span>
                                                          </div>
                                                          <div className="col-md-3 padding_0 text-center">
                                                            <span>
                                                              {service.Services ==
                                                                "Electricity"
                                                                ? "-"
                                                                : service.Quantity}
                                                            </span>
                                                          </div>
                                                          <div className="col-md-3 padding_0 text-right">
                                                            <span>
                                                              {service.Services ==
                                                                "Electricity"
                                                                ? ""
                                                                : data.currency ===
                                                                  "INR"
                                                                  ? "₹"
                                                                  : "$"}{" "}
                                                              {service.Services ==
                                                                "Electricity"
                                                                ? "RS. 16/- per kwh"
                                                                : service.GrossAmount
                                                                  ? service.GrossAmount.toLocaleString("en-IN", {
                                                                    minimumFractionDigits: 2,
                                                                    maximumFractionDigits: 2,
                                                                  })
                                                                  : "0.00"}
                                                            </span>
                                                          </div>
                                                        </>
                                                      ) : null}
                                                    </div>
                                                  )
                                                )
                                              ) : (
                                                <div className="row mr_0">
                                                  <div className="col-md-8 text-center">
                                                    <hr />
                                                    <span>No Services Selected</span>
                                                  </div>
                                                </div>
                                              )}

                                              <hr />
                                              <div className="row mr_0">
                                                <div className="col-md-3 padding_0">
                                                  <span>
                                                    <strong>Total</strong>
                                                  </span>
                                                </div>
                                                <div className="col-md-3 padding_0 text-center">
                                                  <span>
                                                    <strong></strong>
                                                  </span>
                                                </div>
                                                <div className="col-md-3 padding_0 text-center">
                                                  <span>
                                                    <strong></strong>
                                                  </span>
                                                </div>
                                                <div className="col-md-3 padding_0 text-right">
                                                  <span>
                                                    <strong> {data.currency == "INR" ? "₹" : "$"}
                                                      {data.Price?.ServiceTotal
                                                        ? data.Price?.ServiceTotal?.toLocaleString("en-IN", {
                                                          minimumFractionDigits: 2,
                                                          maximumFractionDigits: 2,
                                                        })
                                                        : "0.00"}</strong>
                                                  </span>
                                                </div>
                                              </div>
                                            </div>
                                          </fieldset>
                                        </div>
                                      </div>
                                    </div>
                                    <hr />

                                    <div class="company_info">
                                      <div class="row">
                                        <div class="col-md-12">
                                          <h6 class="additional_services">
                                            Included Services
                                          </h6>
                                          <ul class="Included_Services">
                                            {includedServices.length > 0 &&
                                              includedServices != null ? (
                                              includedServices.map(
                                                (data, i) => (
                                                  <li>
                                                    {data.InclusiveServices}
                                                  </li>
                                                )
                                              )
                                            ) : (
                                              <></>
                                            )}
                                          </ul>
                                        </div>
                                      </div>

                                      <div class="row">
                                        <div class="col-md-12">
                                          <div class="form-group">
                                            <h6 class="additional_services">
                                              Additional Paid Services
                                            </h6>

                                            <div className="custom_table">
                                              <div className="hack1">
                                                <div className="hack2">
                                                  <table
                                                    class="table table-bordered table-striped table-sm"
                                                    style={{
                                                      zIndex: "000",
                                                      position: "relative",
                                                    }}
                                                    id="tbl"
                                                  >
                                                    <thead>
                                                      <tr>
                                                        <th
                                                          style={{
                                                            width: "2%",
                                                          }}
                                                        ></th>
                                                        <th className="Service_col_width">
                                                          Services
                                                        </th>
                                                        <th
                                                          class="text-center Service_type_width"
                                                          style={{
                                                            width: "16%",
                                                          }}
                                                        >
                                                          Type
                                                        </th>
                                                        {CurrencyID != 2 ? (
                                                          <th
                                                            class="text-center Service_prize_width"
                                                            style={{
                                                              width: "16%",
                                                            }}
                                                          >
                                                            Price (INR){" "}
                                                          </th>
                                                        ) : (
                                                          <th
                                                            class="text-center"
                                                            style={{
                                                              width: "16%",
                                                            }}
                                                          >
                                                            Price (USD){" "}
                                                          </th>
                                                        )}
                                                        <th
                                                          class="text-center"
                                                          style={{
                                                            width: "10%",
                                                          }}
                                                        >
                                                          Quantity
                                                        </th>
                                                        {CurrencyID != 2 ? (
                                                          <th
                                                            class="text-right Service_prize_width"
                                                            style={{
                                                              width: "16%",
                                                            }}
                                                          >
                                                            Amount (INR){" "}
                                                          </th>
                                                        ) : (
                                                          <th
                                                            class="text-center"
                                                            style={{
                                                              width: "16%",
                                                            }}
                                                          >
                                                            Amount (USD){" "}
                                                          </th>
                                                        )}
                                                      </tr>
                                                    </thead>

                                                    <tbody>
                                                      {/* '₹' : '$' */}
                                                      {additionalServicesList.length >
                                                        0 &&
                                                        additionalServicesList !=
                                                        null ? (
                                                        additionalServicesList.map(
                                                          (std, i) => (
                                                            <>
                                                              {std.Is_SelectedServiceId ==
                                                                1 ? (
                                                                // <>
                                                                //     {
                                                                //         std.Name != "Electricity" ?
                                                                <tr key={i}>
                                                                  <td>
                                                                    <div class="bg">
                                                                      <div class="chiller_cb">
                                                                        <input
                                                                          type="checkbox"
                                                                          onClick={(
                                                                            e
                                                                          ) => {
                                                                            if (
                                                                              PossesionSubmittedUser == ""
                                                                            ) {
                                                                              this.checkbox(
                                                                                i,
                                                                                std.IsSelected,
                                                                                e
                                                                              );
                                                                            } else {
                                                                              return null;
                                                                            }
                                                                          }}
                                                                          id={`checkbox${i}`}
                                                                          checked={
                                                                            std.IsSelected
                                                                          }
                                                                        />
                                                                        <label
                                                                          for={`checkbox${i}`}
                                                                          style={{
                                                                            color:
                                                                              "#979797;",
                                                                          }}
                                                                        >
                                                                          &nbsp;
                                                                        </label>
                                                                        <span></span>
                                                                      </div>
                                                                    </div>
                                                                  </td>
                                                                  <td>
                                                                    <div>
                                                                      {std.Name}{" "}
                                                                      &nbsp;
                                                                      {std.FilePath !=
                                                                        "" ? (
                                                                        <a
                                                                          href="javascript:void(0);"
                                                                          data-toggle="modal"
                                                                          onClick={(
                                                                            e
                                                                          ) =>
                                                                            this.modalShow(
                                                                              std.FilePath,
                                                                              i
                                                                            )
                                                                          }
                                                                          data-target="#Additional_Services_img_Pop"
                                                                        >
                                                                          <i
                                                                            class="fa fa-picture-o"
                                                                            style={{
                                                                              color:
                                                                                "#006fff",
                                                                            }}
                                                                          ></i>
                                                                        </a>
                                                                      ) : (
                                                                        <></>
                                                                      )}
                                                                      &nbsp;
                                                                      {std.ServiceDetails !=
                                                                        null &&
                                                                        std.ServiceDetails !=
                                                                        "" ? (
                                                                        <span class="tooltip-col">
                                                                          <i
                                                                            class="fa fa-info-circle"
                                                                            aria-hidden="true"
                                                                          ></i>
                                                                          <span class="tooltiptext">
                                                                            {
                                                                              std.ServiceDetails
                                                                            }
                                                                          </span>
                                                                        </span>
                                                                      ) : (
                                                                        <></>
                                                                      )}
                                                                    </div>
                                                                  </td>
                                                                  {/* {std.Name != "Electricity" ? */}
                                                                  <td>
                                                                    <select
                                                                      class="form-control"
                                                                      value={
                                                                        std.ServiceType ==
                                                                          "S"
                                                                          ? "Standard"
                                                                          : "Premium"
                                                                      }
                                                                      disabled={
                                                                        !std.IsSelected ||
                                                                        std.Disabled !=
                                                                        2
                                                                      }
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      // onChange={(e) => this.stdPrm(e, i)}
                                                                      onChange={(
                                                                        e
                                                                      ) => {
                                                                        if (
                                                                          PossesionSubmittedUser == ""
                                                                        ) {
                                                                          this.onServicetypechange(
                                                                            e,
                                                                            i,
                                                                            std.Name,
                                                                            std.Quantity
                                                                          );
                                                                        } else {
                                                                          return null;
                                                                        }
                                                                      }}
                                                                    // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                    >
                                                                      {standardPremiumList.length >
                                                                        0 &&
                                                                        standardPremiumList.map(
                                                                          (
                                                                            item
                                                                          ) => (
                                                                            <option
                                                                              key={
                                                                                item.ID
                                                                              }
                                                                              value={
                                                                                item.Type
                                                                              }
                                                                            >
                                                                              {
                                                                                item.Type
                                                                              }
                                                                            </option>
                                                                          )
                                                                        )}
                                                                    </select>
                                                                  </td>
                                                                  {std.Name != 'Event Services' ?
                                                                    <td class="text-center">
                                                                      {std.CurrencyID !=
                                                                        2 ? (
                                                                        std.PriceInINR !=
                                                                          null ? (
                                                                          "₹ " +
                                                                          std.PriceInINR.toLocaleString(
                                                                            "en-IN"
                                                                          )
                                                                        ) : (
                                                                          <></>
                                                                        )
                                                                      ) : std.PriceInUSD !=
                                                                        null ? (
                                                                        "$ " +
                                                                        std.PriceInUSD.toLocaleString(
                                                                          "en-IN"
                                                                        )
                                                                      ) : (
                                                                        <></>
                                                                      )}
                                                                    </td> :
                                                                    <td class="text-center">-</td>
                                                                  }
                                                                  {std.Name != 'Event Services' ?
                                                                    <td class="text-center">
                                                                      <input
                                                                        type="text"
                                                                        className="form-control text-center"
                                                                        value={
                                                                          std.Quantity
                                                                        }
                                                                        onChange={(
                                                                          e
                                                                        ) => {
                                                                          if (
                                                                            PossesionSubmittedUser == ""
                                                                          ) {
                                                                            this.isQuantity(
                                                                              e,
                                                                              i,
                                                                              std.Name,
                                                                              std.MaxQuantity
                                                                            );
                                                                          } else {
                                                                            return null;
                                                                          }
                                                                        }}
                                                                        disabled={
                                                                          !std.IsSelected
                                                                        }
                                                                        style={{
                                                                          outline:
                                                                            "none",
                                                                        }}
                                                                      // maxLength={3}
                                                                      // onKeyDown={(e) => this.handleKeyDown(e)}
                                                                      />
                                                                    </td> :
                                                                    <td class="text-center">-</td>
                                                                  }
                                                                  {std.Name != 'Event Services' ?
                                                                    <>
                                                                      {std.CurrencyID ==
                                                                        1 ? (
                                                                        <td class="text-right">
                                                                          {std.IsSelected ==
                                                                            1
                                                                            ? "₹ " +
                                                                            std.Amount.toLocaleString()
                                                                            : "-"}
                                                                        </td>
                                                                      ) : (
                                                                        <td class="text-right">
                                                                          {std.IsSelected ==
                                                                            1
                                                                            ? "$ " +
                                                                            std.Amount.toLocaleString()
                                                                            : "-"}
                                                                        </td>
                                                                      )}
                                                                    </> :
                                                                    <td class="text-right">
                                                                      <input type="text"
                                                                        className='form-control text-right'
                                                                        value={std.Amount}
                                                                        onChange={(e) => {
                                                                          if (
                                                                            PossesionSubmittedUser == ""
                                                                          ) {
                                                                            this.isAmountQuantity(e, i, std.Name, std.MaxQuantity)
                                                                          } else {
                                                                            return null;
                                                                          }
                                                                        }
                                                                        }
                                                                        disabled={!std.IsSelected || sessionStorage.getItem('roleId') == 3}
                                                                        style={{ outline: 'none' }}
                                                                      />
                                                                    </td>}

                                                                </tr>
                                                              ) : (
                                                                <></>
                                                              )}
                                                            </>
                                                          )
                                                        )
                                                      ) : (
                                                        <tr>
                                                          <td
                                                            colSpan={6}
                                                            className="text-center"
                                                            style={{
                                                              color: "#F96302",
                                                            }}
                                                          >
                                                            Additional services
                                                            will be available
                                                            soon.
                                                          </td>
                                                        </tr>
                                                      )}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-md-12">
                                          <div class="form-group">
                                            <h6 class="additional_services">
                                              Additional Vendor Services
                                            </h6>
                                            <table
                                              class="table table-bordered table-striped table-sm"
                                              id="tbl"
                                            >
                                              <thead>
                                                <tr>
                                                  <th
                                                    style={{ width: "5%" }}
                                                  ></th>
                                                  <th style={{ width: "25%" }}>
                                                    SERVICE
                                                  </th>
                                                  <th style={{ width: "18%" }}>
                                                    SELECT PACKAGE
                                                  </th>
                                                  <th style={{ width: "18%" }}>
                                                    VENDOR NAME
                                                  </th>
                                                  {/* <th>PRICE (INR)</th>
                                                                            <th style={{ width: "10%" }}>QUANTITY</th> */}
                                                  {/* <th style={{ width: "35%" }}>ADDITIONAL REQUIREMENT</th> */}
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {externalServices.length > 0 &&
                                                  externalServices != null ? (
                                                  externalServices.map(
                                                    (data, i) => (
                                                      <tr>
                                                        <td>
                                                          <div class="bg">
                                                            <div class="chiller_cb">
                                                              <input
                                                                type="checkbox"
                                                                onClick={(e) =>
                                                                  this.externalServicesCheckbox(
                                                                    i,
                                                                    data.IsSelected,
                                                                    e
                                                                  )
                                                                }
                                                                id={`externalServicesCheckbox${i}`}
                                                                checked={
                                                                  data.IsSelected
                                                                }
                                                                disabled={
                                                                  PossesionSubmittedUser == ""
                                                                    ? false
                                                                    : true
                                                                }
                                                              />
                                                              <label
                                                                for={`externalServicesCheckbox${i}`}
                                                                style={{
                                                                  color:
                                                                    "#979797;",
                                                                }}
                                                              >
                                                                &nbsp;
                                                              </label>
                                                              <span></span>
                                                            </div>
                                                          </div>
                                                        </td>
                                                        <td>{data.Service}</td>
                                                        {data.IsSelected ==
                                                          1 ? (
                                                          <>
                                                            {data.Package ==
                                                              null ? (
                                                              <td
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  background:
                                                                    "#fcf5f3",
                                                                }}
                                                                onClick={() =>
                                                                  this.serviceModalShow(
                                                                    data.ServiceID,
                                                                    i,
                                                                    data.Service,
                                                                    data.AdditionalRequirement
                                                                  )
                                                                }
                                                              >
                                                                <a title="Select Package">
                                                                  {" "}
                                                                  Select Package
                                                                  <span class="mendatory_class">
                                                                    *
                                                                  </span>
                                                                </a>
                                                              </td>
                                                            ) : (
                                                              <td>
                                                                <a
                                                                  title="Select Package"
                                                                  style={{
                                                                    cursor:
                                                                      "pointer",
                                                                  }}
                                                                  onClick={() =>
                                                                    this.serviceModalShow(
                                                                      data.ServiceID,
                                                                      i,
                                                                      data.Service,
                                                                      data.AdditionalRequirement
                                                                    )
                                                                  }
                                                                >
                                                                  <i
                                                                    class="fa fa-edit"
                                                                    style={{
                                                                      fontSize:
                                                                        "14px",
                                                                    }}
                                                                  ></i>{" "}
                                                                  {data.Package}
                                                                </a>
                                                              </td>
                                                            )}
                                                          </>
                                                        ) : (
                                                          <td>{"-"}</td>
                                                        )}

                                                        <td>
                                                          {data.Package !=
                                                            null &&
                                                            data.IsSelected !=
                                                            0 ? (
                                                            <>
                                                              {data.CompanyName}
                                                            </>
                                                          ) : (
                                                            "-"
                                                          )}
                                                        </td>

                                                      </tr>
                                                    )
                                                  )
                                                ) : (
                                                  <tr>
                                                    <td
                                                      colSpan={12}
                                                      className="text-center"
                                                    >
                                                      Record not found
                                                    </td>
                                                  </tr>
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      </div>

                                      <div class="row">
                                        <div className="col-md-12">
                                          {/* <h6 class="additional_services">Any other</h6> */}
                                          {/* additional_services
                                                            unListed-additional-services */}
                                          <h6 className="additional_services">
                                            Any additional services required not
                                            listed above will be check by
                                            operation team and can be made
                                            available on the basis of type and
                                            avalability.
                                          </h6>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-md-12">
                                          <div class="form-group">
                                            <textarea
                                              maxLength={1000}
                                              value={unlistedAddServices}
                                              disabled={
                                                PossesionSubmittedUser != ""
                                              }
                                              onChange={(e) => {
                                                if (
                                                  PossesionSubmittedUser ==
                                                  ""
                                                ) {
                                                  this.setState({
                                                    unlistedAddServices:
                                                      e.target.value,
                                                  });
                                                } else {
                                                  return null;
                                                }
                                              }}
                                              style={{ height: "80px" }}
                                              class="form-control"
                                              rows="2"
                                              placeholder="Type here..."
                                            ></textarea>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div className="col-md-12">
                                          {/* <h6 class="additional_services">Any other</h6> */}
                                          {/* additional_services
                                                            unListed-additional-services */}
                                          <h6 className="additional_services">
                                            Other Information
                                          </h6>
                                        </div>
                                      </div>
                                      <div class="row">
                                        <div class="col-md-12">
                                          <div class="form-group">
                                            <textarea
                                              maxLength={1000}
                                              value={OtherInformation}
                                              disabled={
                                                PossesionSubmittedUser != ""
                                              }
                                              onChange={(e) => {
                                                if (
                                                  PossesionSubmittedUser ==
                                                  ""
                                                ) {
                                                  this.setState({
                                                    OtherInformation:
                                                      e.target.value,
                                                  });
                                                } else {
                                                  return null;
                                                }
                                              }}
                                              style={{ height: "60px" }}
                                              class="form-control"
                                              rows="2"
                                              placeholder="Type here..."
                                            ></textarea>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {PossesionSubmittedUser == "" ? (
                                      <div class="col-md-12 my_buttons">
                                        <button
                                          onClick={() =>
                                            this.handleSubmitAdditionalSubmit()
                                          }
                                          class="btn btn-primary custom_btn Terms_and_Conditions_btn"
                                        >
                                          Submit{" "}
                                        </button>
                                      </div>
                                    ) : AdditionalServiceApprovalStatus == 1 ? (
                                      <div class="col-md-12 my_buttons">
                                        <button
                                          disabled={true}
                                          class="btn btn-primary custom_btn Terms_and_Conditions_btn"
                                        >
                                          Confirmed{" "}
                                        </button>
                                      </div>
                                    ) : (
                                      <div class="col-md-12 my_buttons">
                                        <button
                                          disabled={PossesionSubmittedUser != ""}
                                          class="btn btn-primary custom_btn Terms_and_Conditions_btn"
                                        >
                                          Submitted{" "}
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : null}
                      {MyOrdersData.map((data) => data.DeliveryStatus).join(
                        ""
                      ) === "Approved" ||
                        MyOrdersData.map((data) => data.DeliveryStatus).join(
                          ""
                        ) === "Confirmed" ||
                        MyOrdersData.map((data) => data.DeliveryStatus).join(
                          ""
                        ) === "Delivered" ? (
                        <div className="card-header">
                          <hr />
                          <Element
                            name="additionalServiceVendor"
                            className="element"
                          >
                            <legend>Additional Vendor Services Details</legend>
                          </Element>

                          {ThirdPartyVendorOrderList.length > 0 ? (
                            ThirdPartyVendorOrderList.map((data, index) => (
                              <fieldset key={index} className="p-4">
                                <div className="row">
                                  <div className="col-md-4">
                                    <h3 style={{ color: "#0a8dc9" }}>
                                      {data.VendorCompany}
                                    </h3>
                                    <h4>
                                      {data.ServiceName}-{data.Package}
                                    </h4>
                                  </div>
                                  <div className="col-md-4"></div>
                                  <div className="col-md-4">
                                    <div className="chat-btn">
                                      <Button
                                        variant="primary"
                                        style={{
                                          backgroundColor: "#35b3e6",
                                          marginLeft: "17rem",
                                        }}
                                        onClick={() =>
                                          this.toggleChat(
                                            data.VendorCompany,
                                            data.ServiceName,
                                            data.OrderID,
                                            data.VendorID,
                                            data.ServiceID
                                          )
                                        }
                                      >
                                        {sortedChatDtl.length === 0
                                          ? "Start Conversation"
                                          : "View Conversation"}{" "}
                                        &nbsp;{" "}
                                        <i
                                          className={`fa ${isChatOpen
                                            ? "fa-chevron-left"
                                            : "fa-chevron-right"
                                            }`}
                                        ></i>
                                      </Button>
                                    </div>
                                  </div>
                                </div>

                                <hr />
                                <div className="outside_input_field row">
                                  <div className="col-md-5">
                                    <div className="align-items-center row btn-sm">
                                      <div className="col-md-4">
                                        <label>Vendor's Approval</label>
                                      </div>
                                      <div className="col-md-4">
                                        {data.IsOrderAcceptedbyVendor ? (
                                          <a
                                            href="javascript:void(0);"
                                            className="btn btn-sm btn-outline-success my_custom_orderPage_btns"
                                          >
                                            Accepted
                                          </a>
                                        ) : (
                                          <a
                                            href="javascript:void(0);"
                                            className="btn btn-sm btn-outline-warning my_custom_orderPage_btns"
                                          >
                                            Pending
                                          </a>
                                        )}
                                      </div>
                                      <div className="col-md-4"></div>
                                    </div>
                                    <div className="align-items-center row">
                                      <hr />
                                      <div className="col-md-4">
                                        <label>Quotation</label>
                                      </div>
                                      {data.quotationFilePath ? (
                                        <>
                                          <div className="col-md-4">
                                            <span
                                              style={{
                                                background: "#f0f0f0",
                                                borderRadius: "20px",
                                                padding: "5px 10px",
                                                display: "inline-block",
                                              }}
                                            >
                                              <a
                                                style={{
                                                  cursor: "pointer",
                                                  color: "red",
                                                  textDecoration: "none",
                                                }}
                                                title="View Quotation"
                                                target="_blank"
                                                href={`${downloadUrl}${data.quotationFilePath}`}
                                              >
                                                {data.quotationFilePath
                                                  .split("/")
                                                  .pop()}
                                              </a>
                                            </span>
                                          </div>
                                          {data.IsQuotationApproved === true ? (
                                            <div className="col-md-4">
                                              <a
                                                href="javascript:void(0);"
                                                className="btn btn-outline-success my_custom_orderPage_btns m-2 btn-sm"
                                              >
                                                Accepted
                                              </a>
                                            </div>
                                          ) : (
                                            <div className="col-md-4">
                                              <a
                                                href="javascript:void(0);"
                                                className="btn btn-sm btn-success my_custom_orderPage_btns mr-2"
                                                onClick={() =>
                                                  this.submitVendorUploads(
                                                    "acceptQuoClient",
                                                    data.IsQuotationApproved,
                                                    data.VendorOrderDtlID,
                                                    data.IsOrderAcceptedbyVendor,
                                                    data.quotationFilePath
                                                  )
                                                }
                                              >
                                                Accept
                                              </a>
                                              <a
                                                href="javascript:void(0);"
                                                className="btn btn-sm btn-danger my_custom_orderPage_btns"
                                                onClick={() =>
                                                  this.submitVendorUploads(
                                                    "rejectQuoClient"
                                                  )
                                                }
                                              >
                                                Reject
                                              </a>
                                            </div>
                                          )}
                                        </>
                                      ) : (
                                        <div
                                          className="col-md-4"
                                          style={{
                                            background: "#f0f0f0",
                                            borderRadius: "20px",
                                            color: "black",
                                            padding: "5px 4px",
                                            textAlign: "center",
                                            display: "inline-block",
                                          }}
                                        >
                                          No Quotation Submitted
                                        </div>
                                      )}
                                      <div className="col-md-4"></div>
                                    </div>
                                    <div className="row align-items-center">
                                      <div className="col-md-4">
                                        <label>Invoice Copy</label>
                                      </div>
                                      {data.invoiceFilePath ? (
                                        <div className="col-md-4">
                                          <span
                                            style={{
                                              background: "#f0f0f0",
                                              borderRadius: "20px",
                                              padding: "5px 10px",
                                              display: "inline-block",
                                            }}
                                          >
                                            <a
                                              style={{
                                                cursor: "pointer",
                                                color: "red",
                                                textDecoration: "none",
                                              }}
                                              title="View Invoice"
                                              target="_blank"
                                              href={`${downloadUrl}${data.invoiceFilePath}`}
                                            >
                                              {data.invoiceFilePath
                                                .split("/")
                                                .pop()}
                                            </a>
                                          </span>
                                        </div>
                                      ) : (
                                        <div
                                          className="col-md-4"
                                          style={{
                                            background: "#f0f0f0",
                                            borderRadius: "20px",
                                            color: "black",
                                            padding: "5px 4px",
                                            textAlign: "center",
                                            display: "inline-block",
                                          }}
                                        >
                                          No Invoice Submitted
                                        </div>
                                      )}
                                      <div className="col-md-4"></div>
                                    </div>
                                    <div className="row mt-4 mb-2">
                                      <div className="col-md-8">
                                        <div className="form-group">
                                          <div className="align-items-center position-relative w-100 d-flex">
                                            <label style={{ marginTop: "8px" }}>
                                              Final Amount
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={data.FinalAmount?.toLocaleString(
                                                "en-IN"
                                              )}
                                              disabled
                                              maxLength={10}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="row align-items-center mt-2 mb-2">
                                      <div className="col-md-4">
                                        <label>Receipt Copy</label>
                                      </div>
                                      {data.receiptFilePath ? (
                                        <div className="col-md-4">
                                          <span
                                            style={{
                                              background: "#f0f0f0",
                                              borderRadius: "20px",
                                              padding: "5px 10px",
                                              display: "inline-block",
                                            }}
                                          >
                                            <a
                                              style={{
                                                cursor: "pointer",
                                                color: "red",
                                                textDecoration: "none",
                                              }}
                                              title="View Receipt"
                                              target="_blank"
                                              href={`${downloadUrl}${data.receiptFilePath}`}
                                            >
                                              {data.receiptFilePath
                                                .split("/")
                                                .pop()}
                                            </a>
                                          </span>
                                        </div>
                                      ) : (
                                        <div
                                          className="col-md-4"
                                          style={{
                                            background: "#f0f0f0",
                                            borderRadius: "20px",
                                            color: "black",
                                            padding: "5px 4px",
                                            textAlign: "center",
                                            display: "inline-block",
                                          }}
                                        >
                                          No Receipt Submitted
                                        </div>
                                      )}
                                      <div className="col-md-9"></div>
                                    </div>
                                  </div>
                                  <div
                                    className="col-md-1"
                                    style={{
                                      borderLeft: "1px solid #0000001a",
                                      height: "200px",
                                    }}
                                  ></div>
                                  <div className="col-md-6">
                                    <div className="row mt-4 mb-2">
                                      <div className="col-md-8">
                                        <div className="form-group">
                                          <div className="align-items-center position-relative w-100 d-flex">
                                            <label style={{ marginTop: "8px" }}>
                                              Additional Amount
                                            </label>
                                            <input
                                              type="text"
                                              className="form-control"
                                              value={data.AdditionalAmount?.toLocaleString(
                                                "en-IN"
                                              )}
                                              disabled
                                              maxLength={10}
                                              onChange={(e) =>
                                                this.setState({
                                                  AdditionalAmount:
                                                    e.target.value,
                                                })
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {data.IsOrderAcceptedbyClient === true ? (
                                      <div className="row mt-2 mb-2 align-items-center">
                                        <div className="col-md-8">
                                          <div className="form-group">
                                            <div className="position-relative w-100 d-flex">
                                              <label
                                                style={{
                                                  width: "40%",
                                                  marginTop: "12px",
                                                }}
                                              >
                                                Confirmation from Client
                                              </label>
                                            </div>
                                            <div className="align-items-center position-relative w-100 d-flex">
                                              <label
                                                style={{ marginTop: "8px" }}
                                              >
                                                Contact Person
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={
                                                  data.OrderAcceptedbyClientContact
                                                }
                                                disabled
                                                maxLength={10}
                                              />
                                              <a
                                                href="javascript:void(0);"
                                                className="btn btn-sm btn-outline-success my_custom_orderPage_btns ml-2"
                                              >
                                                Accepted
                                              </a>
                                            </div>
                                            <div
                                              class="client_signature_box mt-2"
                                              style={{
                                                border: "1px solid #c9c8c8",
                                                width: 400,
                                              }}
                                            >
                                              <img
                                                src={
                                                  data.OrderAcceptedbyClientSignature
                                                }
                                                style={{
                                                  width: 400,
                                                  height: 150,
                                                }}
                                                alt="Saved Signature"
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ) : (
                                      <div className="row mt-2 mb-2 align-items-center">
                                        <div className="col-md-8">
                                          <div className="form-group">
                                            <div className="position-relative w-100 d-flex align-items-center">
                                              <label
                                                style={{
                                                  width: "40%",
                                                  marginTop: "12px",
                                                }}
                                              >
                                                Confirmation from Client
                                              </label>
                                              <div className="w-100">
                                                Additional Amount Not submitted
                                                by vendor
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                    <div className="row align-items-center">
                                      <div className="col-md-4">
                                        <label>Invoice Copy</label>
                                      </div>
                                      {data.additionalInvoiceFilePath ? (
                                        <div className="col-md-4">
                                          <span
                                            style={{
                                              background: "#f0f0f0",
                                              borderRadius: "20px",
                                              padding: "5px 10px",
                                              display: "inline-block",
                                            }}
                                          >
                                            <a
                                              style={{
                                                cursor: "pointer",
                                                color: "red",
                                                textDecoration: "none",
                                              }}
                                              title="View Invoice"
                                              target="_blank"
                                              href={`${downloadUrl}${data.additionalInvoiceFilePath}`}
                                            >
                                              {data.additionalInvoiceFilePath
                                                .split("/")
                                                .pop()}
                                            </a>
                                          </span>
                                        </div>
                                      ) : (
                                        <div
                                          className="col-md-4"
                                          style={{
                                            background: "#f0f0f0",
                                            borderRadius: "20px",
                                            color: "black",
                                            padding: "5px 4px",
                                            textAlign: "center",
                                            display: "inline-block",
                                          }}
                                        >
                                          No Invoice Submitted
                                        </div>
                                      )}
                                      <div className="col-md-4"></div>
                                    </div>
                                    <div className="row align-items-center mt-2 mb-2">
                                      <div className="col-md-4">
                                        <label>Receipt Copy</label>
                                      </div>
                                      {data.additionalReceiptFilePath ? (
                                        <div className="col-md-4">
                                          <span
                                            style={{
                                              background: "#f0f0f0",
                                              borderRadius: "20px",
                                              padding: "5px 10px",
                                              display: "inline-block",
                                            }}
                                          >
                                            <a
                                              style={{
                                                cursor: "pointer",
                                                color: "red",
                                                textDecoration: "none",
                                              }}
                                              title="View Receipt"
                                              target="_blank"
                                              href={`${downloadUrl}${data.additionalReceiptFilePath}`}
                                            >
                                              {data.additionalReceiptFilePath
                                                .split("/")
                                                .pop()}
                                            </a>
                                          </span>
                                        </div>
                                      ) : (
                                        <div
                                          className="col-md-4"
                                          style={{
                                            background: "#f0f0f0",
                                            borderRadius: "20px",
                                            color: "black",
                                            padding: "5px 4px",
                                            textAlign: "center",
                                            display: "inline-block",
                                          }}
                                        >
                                          No Receipt Submitted
                                        </div>
                                      )}
                                      <div className="col-md-9"></div>
                                    </div>
                                  </div>
                                </div>
                              </fieldset>
                            ))
                          ) : (
                            <>
                              <div>
                                {" "}
                                <hr />
                                <h5 class="text-center">
                                  Vendor Approval Pending
                                </h5>
                              </div>
                            </>
                          )}
                        </div>
                      ) : (
                        <></>
                      )}
                      <hr />
                      {/* //Quotation */}

                      {/* //possession */}
                      <div
                        className="thankYou_page"
                        style={{ marginTop: "0px" }}
                      >
                        <div class="row">
                          {PossesionSubmittedUser != "" ? (
                            <>
                              <div class="col-md-6">
                                <div class="card">
                                  <div class="card-header">
                                    <Element
                                      name="checklist"
                                      className="element"
                                    >
                                      <legend>Possession</legend>
                                    </Element>
                                  </div>
                                  <div class="card-body">
                                    <div class="company_info">
                                      <h6 style={{ color: "#35b3e6" }}>
                                        {" "}
                                        Possession Time
                                      </h6>
                                      <table
                                        class="table table-bordered table-striped table-sm"
                                        id="tbl"
                                        style={{ width: "50%", height: '40px' }}
                                      >
                                        <thead>
                                          <tr>
                                            <th>Possession time :</th>
                                            <th style={{ width: "40%" }}>
                                              {moment(possessionTime)
                                                .utc()
                                                .format("DD/MM/YYYY hh:mm:ss")}
                                            </th>
                                          </tr>
                                        </thead>
                                      </table>

                                      <h6 style={{ color: "#35b3e6" }}>
                                        Inhouse Services
                                      </h6>
                                      <table
                                        class="table table-bordered table-striped table-sm"
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th style={{ width: "10px" }}></th>
                                            <th>Services</th>
                                            <th
                                              class="text-center"
                                              style={{ width: "15%" }}
                                            >
                                              Quantity
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {possessionIncludedServicesList.length >
                                            0 &&
                                            possessionIncludedServicesList !=
                                            null ? (
                                            possessionIncludedServicesList.map(
                                              (data, i) => (
                                                <tr>
                                                  <td>
                                                    <div class="bg only_checkbox">
                                                      <div class="chiller_cb">
                                                        <input
                                                          checked={
                                                            data.IsSelected
                                                          }
                                                          id={`ServiceCheck1${i}`}
                                                          type="checkbox"
                                                        />
                                                        <label
                                                          className="lebel-dis"
                                                          for={`ServiceCheck1${i}`}
                                                          style={{
                                                            color: "#979797",
                                                          }}
                                                        >
                                                          &nbsp;
                                                        </label>
                                                        <span></span>
                                                      </div>
                                                    </div>
                                                  </td>
                                                  <td
                                                    style={{
                                                      verticalAlign: "middle",
                                                    }}
                                                  >
                                                    <div>
                                                      {data.InclusiveServices}
                                                    </div>
                                                  </td>
                                                  <td class="text-center">
                                                    <input
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                      type="text"
                                                      value={data.Quantity}
                                                      disabled={true}
                                                      maxLength={3}
                                                      class="form-control coustome-checkbox"
                                                    />
                                                  </td>
                                                </tr>
                                              )
                                            )
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan={6}
                                                className="text-center"
                                                style={{ color: "#F96302" }}
                                              >
                                                Record not found
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>

                                      <h6 style={{ color: "#35b3e6" }}>
                                        {" "}
                                        Additional Paid Services
                                      </h6>
                                      <table
                                        class="table table-bordered table-striped table-sm"
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th style={{ width: "10px" }}></th>
                                            <th>Services</th>
                                            <th colSpan={1}></th>
                                            <th class="text-center">
                                              Quantity
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {possessionInhouseServicesList.length >
                                            0 &&
                                            possessionInhouseServicesList !=
                                            null ? (
                                            possessionInhouseServicesList.map(
                                              (data, i) => (
                                                <tr>
                                                  <td>
                                                    <div class="bg only_checkbox">
                                                      <div class="chiller_cb">
                                                        <input
                                                          id={`ServiceCheck2${i}`}
                                                          checked={
                                                            data.IsSelected
                                                          }
                                                          type="checkbox"
                                                        />
                                                        <label
                                                          className="lebel-dis"
                                                          for={`ServiceCheck2${i}`}
                                                          style={{
                                                            color: "#979797",
                                                          }}
                                                        >
                                                          &nbsp;
                                                        </label>
                                                        <span></span>
                                                      </div>
                                                    </div>
                                                  </td>
                                                  {data.Name !=
                                                    "Electricity" ? (
                                                    <td colSpan={2}>
                                                      <div>{data.Name}</div>
                                                    </td>
                                                  ) : (
                                                    <td>Electricity</td>
                                                  )}
                                                  {data.Name !=
                                                    "Electricity" ? (
                                                    <td
                                                      class="text-center"
                                                      style={{ width: "15%" }}
                                                    >
                                                      <input
                                                        type="text"
                                                        value={data.Quantity}
                                                        maxLength={3}
                                                        disabled={true}
                                                        class="form-control coustome-checkbox"
                                                        style={{
                                                          textAlign: "center",
                                                        }}
                                                      />
                                                    </td>
                                                  ) : (
                                                    <td
                                                      colSpan={2}
                                                      style={{
                                                        color: "#212529",
                                                        marginBottom: "0px",
                                                      }}
                                                    >
                                                      Electricity rate –RS. 16/-
                                                      per kwh
                                                    </td>
                                                  )}
                                                </tr>
                                              )
                                            )
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan={6}
                                                className="text-center"
                                                style={{ color: "#F96302" }}
                                              >
                                                Record not found
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </div>

                                    <h6 style={{ color: "#35b3e6" }}>
                                      External Services
                                    </h6>
                                    <table
                                      class="table table-bordered table-striped table-sm"
                                      id="tbl"
                                    >
                                      <thead>
                                        <tr>
                                          <th>Service</th>
                                          <th>Vendor</th>
                                          {/* <th>Contact Details</th> */}
                                          {/* <th>Clearance</th> */}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {possessionVendorList != "" &&
                                          possessionVendorList.length > 0 ? (
                                          possessionVendorList.map(
                                            (data, i) => (
                                              <tr>
                                                <td>{data.Service}</td>
                                                <td>{data.Vendor}</td>
                                              </tr>
                                            )
                                          )
                                        ) : (
                                          <tr>
                                            <td
                                              colSpan={4}
                                              className="text-center"
                                              style={{ color: "#F96302" }}
                                            >
                                              Record not found
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>

                                    <h6 style={{ color: "#35b3e6" }}>
                                      Consumable
                                    </h6>
                                    <table
                                      class="table table-bordered table-striped table-sm"
                                      id="tbl"
                                    >
                                      <thead>
                                        <tr>
                                          <th colSpan={2}>Consumable</th>
                                          {/* <th style={{width:'5%'}}>Action</th> */}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {possessionConsumableList != "" &&
                                          possessionConsumableList.length > 0 ? (
                                          possessionConsumableList.map(
                                            (data, i) => (
                                              <tr>
                                                <td>{data.Name}</td>
                                                <td style={{ width: "5%" }}>
                                                  <div
                                                    class="bg"
                                                    style={{
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <div class="chiller_cb">
                                                      <input
                                                        type="checkbox"
                                                        id={`possessionConsumable${i}`}
                                                        checked={
                                                          data.IsSelected
                                                        }
                                                      />
                                                      <label
                                                        for={`possessionConsumable${i}`}
                                                        style={{
                                                          color: "#979797;",
                                                        }}
                                                      >
                                                        &nbsp;
                                                      </label>
                                                      <span></span>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            )
                                          )
                                        ) : (
                                          <tr>
                                            <td
                                              colSpan={4}
                                              className="text-center"
                                              style={{ color: "#F96302" }}
                                            >
                                              Record not found
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>

                                    <h6 style={{ color: "#35b3e6" }}>
                                      Material List
                                    </h6>
                                    <div className="search_accordion search_card  m-0">
                                      <div
                                        className="panel-group"
                                        id="accordion"
                                      >
                                        {possessionMaterialNameAndServiceName.length >
                                          0 ? (
                                          possessionMaterialNameAndServiceName.map(
                                            (item, index) => (
                                              <div
                                                className="panel panel-default mb-2"
                                                style={{
                                                  background: "#f3f3f3",
                                                }}
                                              >
                                                <div
                                                  className="panel-heading accordion-toggle collapsed p-2"
                                                  data-toggle="collapse"
                                                  data-parent="#accordion"
                                                  data-target="#collapseOne"
                                                  onClick={() =>
                                                    this.toggleCollapse(
                                                      item.isCollapsed,
                                                      index
                                                    )
                                                  }
                                                >
                                                  <h5
                                                    className="panel-title d-flex"
                                                    style={{
                                                      justifyContent:
                                                        "space-between",
                                                    }}
                                                  >
                                                    {/* <span className='packages'></span> */}
                                                    <span className="packages">
                                                      {item.VendorName} /{" "}
                                                      {item.ServiceName}
                                                    </span>
                                                  </h5>
                                                </div>
                                                <div
                                                  id="collapseContent"
                                                  style={{
                                                    display: !item.isCollapsed
                                                      ? "none"
                                                      : "block",
                                                  }}
                                                >
                                                  <div
                                                    className="thankYou_page"
                                                    style={{ margin: "0px" }}
                                                  >
                                                    <div
                                                      class="row"
                                                      style={{
                                                        padding:
                                                          "0px 21px 0px 33px",
                                                      }}
                                                    >
                                                      <table
                                                        class="table table-bordered table-material mb-2"
                                                        id="tbl"
                                                        style={{
                                                          background: "#ffff",
                                                        }}
                                                      >
                                                        <thead>
                                                          <tr>
                                                            <th
                                                              style={{
                                                                width: "5%",
                                                              }}
                                                            ></th>
                                                            <th>
                                                              Material Name
                                                            </th>
                                                            <th
                                                              style={{
                                                                width: "15%",
                                                              }}
                                                            >
                                                              Quantity
                                                            </th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          {possessionMaterialList !=
                                                            "" &&
                                                            possessionMaterialList.length >
                                                            0 ? (
                                                            possessionMaterialList.map(
                                                              (data, i) => (
                                                                <>
                                                                  {data.VendorID ==
                                                                    item.VendorID ? (
                                                                    <tr>
                                                                      <td
                                                                        style={{
                                                                          width:
                                                                            "5%",
                                                                        }}
                                                                      >
                                                                        <div
                                                                          class="bg"
                                                                          style={{
                                                                            justifyContent:
                                                                              "center",
                                                                            alignItems:
                                                                              "center",
                                                                          }}
                                                                        >
                                                                          <div class="chiller_cb">
                                                                            <input
                                                                              type="checkbox"
                                                                              id={`possessionMaterial${i}`}
                                                                              checked={
                                                                                data.IsSelected
                                                                              }
                                                                            />
                                                                            <label
                                                                              for={`possessionMaterial${i}`}
                                                                              style={{
                                                                                color:
                                                                                  "#979797;",
                                                                              }}
                                                                            >
                                                                              &nbsp;
                                                                            </label>
                                                                            <span></span>
                                                                          </div>
                                                                        </div>
                                                                      </td>
                                                                      <td>
                                                                        {
                                                                          data.MaterialName
                                                                        }
                                                                      </td>
                                                                      <td>
                                                                        <input
                                                                          type="text"
                                                                          className="form-control coustome-checkbox"
                                                                          value={
                                                                            data.PossessionQuantity
                                                                          }
                                                                          disabled={
                                                                            true
                                                                          }
                                                                        />
                                                                      </td>
                                                                    </tr>
                                                                  ) : (
                                                                    <></>
                                                                  )}
                                                                </>
                                                              )
                                                            )
                                                          ) : (
                                                            <tr>
                                                              <td
                                                                colSpan={4}
                                                                className="text-center"
                                                                style={{
                                                                  color:
                                                                    "#F96302",
                                                                }}
                                                              >
                                                                Record not found
                                                              </td>
                                                            </tr>
                                                          )}
                                                        </tbody>
                                                      </table>
                                                      <div class="form-group w-100 mb-3">
                                                        <h6
                                                          style={{
                                                            color: "#35b3e6",
                                                            margin: "0px",
                                                          }}
                                                        >
                                                          Note:
                                                        </h6>
                                                        <textarea
                                                          maxLength={500}
                                                          value={item.Note}
                                                          style={{
                                                            height: "80px",
                                                          }}
                                                          disabled={true}
                                                          class="form-control"
                                                          rows="3"
                                                          placeholder="Type here..."
                                                        ></textarea>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            )
                                          )
                                        ) : (
                                          <table
                                            class="table table-bordered table-striped table-sm"
                                            id="tbl"
                                          >
                                            <tbody>
                                              <td
                                                style={{
                                                  color: "#F96302",
                                                  textAlign: "center",
                                                }}
                                              >
                                                Record not found
                                              </td>
                                            </tbody>
                                          </table>
                                        )}
                                      </div>
                                    </div>

                                    {/* <h6
                                      style={{
                                        color: "#35b3e6",
                                        marginTop: "20px",
                                      }}
                                    >
                                      Center Security List
                                    </h6>
                                    <table
                                      class="table table-bordered table-striped table-sm"
                                      id="tbl"
                                    >
                                      <thead>
                                        <tr>
                                          <th colSpan={2}>
                                            Center Security List
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {possessionSecurityList != "" &&
                                        possessionSecurityList.length > 0 ? (
                                          possessionSecurityList.map(
                                            (data, i) => (
                                              <tr>
                                                <td>{data.Name}</td>
                                                <td style={{ width: "5%" }}>
                                                  <div
                                                    class="bg"
                                                    style={{
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <div class="chiller_cb">
                                                      <input
                                                        type="checkbox"
                                                        id={`possessionSecurityList${i}`}
                                                        checked={
                                                          data.IsSelected
                                                        }
                                                      />
                                                      <label
                                                        for={`possessionSecurityList${i}`}
                                                        style={{
                                                          color: "#979797;",
                                                        }}
                                                      >
                                                        &nbsp;
                                                      </label>
                                                      <span></span>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            )
                                          )
                                        ) : (
                                          <tr>
                                            <td
                                              colSpan={4}
                                              className="text-center"
                                              style={{ color: "#F96302" }}
                                            >
                                              Record not found
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>

                                    <h6
                                      style={{
                                        color: "#35b3e6",
                                        marginTop: "20px",
                                      }}
                                    >
                                      Security List Note:
                                    </h6>
                                    <div class="row">
                                      <div
                                        class="col-md-12"
                                        style={{ padding: "0 15px" }}
                                      >
                                        <div class="form-group">
                                          <textarea
                                            maxLength={500}
                                            value={
                                              PossessionSecurityChecklistNote
                                            }
                                            style={{ height: "150px" }}
                                            disabled={true}
                                            class="form-control"
                                            rows="3"
                                            placeholder="Type here..."
                                          ></textarea>
                                        </div>
                                      </div>
                                    </div> */}

                                    <h6
                                      style={{
                                        color: "#35b3e6",
                                        marginTop: "20px",
                                      }}
                                    >
                                      Electricity
                                    </h6>
                                    <table
                                      class="table table-bordered table-striped table-sm"
                                      id="tbl"
                                    >
                                      <thead>
                                        <tr>
                                          <th>
                                            Electricity Units Reading on
                                            Possesion
                                          </th>
                                          <th style={{ width: "20%" }}>
                                            <input
                                              style={{ textAlign: "center" }}
                                              disabled={true}
                                              value={electricityPossesion}
                                              type="text"
                                              maxLength={10}
                                              class="form-control coustome-checkbox"
                                            />
                                          </th>
                                        </tr>
                                      </thead>
                                    </table>

                                    <div
                                      class="Checklist_div mb-3"
                                      style={{ marginTop: "30px" }}
                                    >
                                      <div className="bg checklist">
                                        <div class="chiller_cb" style={{}}>
                                          <input
                                            id={`possessionCheckListAllSelected`}
                                            checked={
                                              possessionCheckListAllSelected
                                            }
                                            type="checkbox"
                                          />
                                          <label
                                            for={`possessionCheckListAllSelected`}
                                            style={{
                                              fontSize: "13px",
                                              color: "#212529",
                                              fontWeight: "normal",
                                            }}
                                          >
                                            {" "}
                                            Select All
                                          </label>
                                          <span></span>
                                          <span></span>
                                        </div>
                                      </div>
                                      {possessionCheckList.length > 0 &&
                                        possessionCheckList != null ? (
                                        possessionCheckList.map((data, i) => (
                                          <>
                                            <div className="bg checklist">
                                              <div
                                                class="chiller_cb"
                                                style={{ marginLeft: "10px" }}
                                              >
                                                <input
                                                  id={`possessionCheckList${i}`}
                                                  checked={data.IsSelected}
                                                  type="checkbox"
                                                />
                                                <label
                                                  for={`possessionCheckList${i}`}
                                                  style={{
                                                    fontSize: "13px",
                                                    color: "#212529",
                                                    fontWeight: "normal",
                                                  }}
                                                >
                                                  {data.Name}
                                                  <span
                                                    class="mendatory_class"
                                                    style={{
                                                      marginLeft: "18px",
                                                      border: "none",
                                                    }}
                                                  >
                                                    *
                                                  </span>
                                                </label>
                                                <span></span>
                                                <span></span>
                                              </div>
                                            </div>
                                          </>
                                        ))
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan={6}
                                            className="text-center"
                                            style={{ color: "#F96302" }}
                                          >
                                            Record not found
                                          </td>
                                        </tr>
                                      )}
                                    </div>

                                    <div
                                      class="d-flex align-items-center"
                                      style={{ justifyContent: "space-between", flexWrap: 'wrap' }}
                                    >
                                      <div className="d-flex">
                                        <div>
                                          <label>Contact Name And Number<span class="mendatory_class">*</span></label>
                                          <textarea
                                            value={PossessionContactNameAndNumber}
                                            disabled={true}
                                            // onChange={(e) => this.setState({ PossessionContactNameAndNumber: e.target.value })}
                                            style={{ resize: 'none', height: '100px' }}
                                            className="form-control"
                                            cols={100}
                                          />
                                        </div>
                                      </div>
                                      <div className="d-flex">
                                        <div>
                                          <label>Client Signature<span class="mendatory_class">*</span></label>
                                          <div
                                            class="client_signature_box"
                                            style={{ border: "1px solid #c9c8c8" }}
                                          >

                                            <img
                                              src={possessionSignatureData}
                                              style={{ width: 250, height: 125 }}
                                              alt="Saved Signature"
                                            />

                                          </div>
                                        </div>

                                      </div>
                                    </div>

                                    <div
                                      class="d-flex align-items-center mt-4"
                                      style={{ justifyContent: "space-between", flexWrap: 'wrap' }}
                                    >
                                      <div className="d-flex">
                                        <div>
                                          <label>Operations Contact Name And Number<span class="mendatory_class">*</span></label>
                                          <textarea
                                            value={PosssesionOperationNameContact}
                                            disabled={true}
                                            // onChange={(e) => this.setState({ PosssesionOperationNameContact: e.target.value })}
                                            style={{ resize: 'none', height: '100px' }}
                                            className="form-control"
                                            cols={100}
                                          />
                                        </div>

                                      </div>
                                    </div>

                                    <div
                                      class="d-flex align-items-center"
                                      style={{ justifyContent: "space-between", flexWrap: 'wrap' }}
                                    >
                                      <div className="d-flex">
                                        <div>
                                          <label>Operations Signature<span class="mendatory_class">*</span></label>
                                          <div
                                            class="client_signature_box"
                                            style={{ border: "1px solid #c9c8c8" }}
                                          >

                                            <img
                                              src={oppPossessionSignatureData}
                                              style={{ width: 250, height: 125 }}
                                              alt="Saved Signature"
                                            />

                                          </div>
                                        </div>

                                      </div>
                                      <div style={{ marginTop: "110px", display: 'flex', flexDirection: 'column' }} >

                                        <span style={{ color: "#979797" }}>Possession Submitted by {PossesionSubmittedUser}</span>
                                        <span style={{ color: "#979797" }}>{moment(PossesionSubmittedDate).utc().format("DD/MM/YYYY hh:mm:ss")}</span>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : null}

                          {FinalExitSubmit == true &&
                            ExitSubmittedDate != "" ? (
                            <>
                              <div class="col-md-6">
                                <div class="card">
                                  <div class="card-header">
                                    <Element
                                      name="checklist"
                                      className="element"
                                    >
                                      <legend>Exit</legend>
                                    </Element>
                                  </div>
                                  <div class="card-body">
                                    <div class="company_info">
                                      <div className="row">
                                        <div className="col-6">
                                          <h6 style={{ color: "#35b3e6" }}>
                                            {" "}
                                            Exit Time
                                          </h6>
                                          <table
                                            class="table table-bordered table-striped table-sm"
                                            id="tbl"
                                            style={{ width: "100%", height: '40px' }}
                                          >
                                            <thead>
                                              <tr>
                                                <th>Exit time :</th>
                                                <th style={{ width: "40%" }}>
                                                  {moment(exitTime)
                                                    .utc()
                                                    .format("DD/MM/YYYY hh:mm:ss")}
                                                </th>
                                              </tr>
                                            </thead>
                                          </table>
                                        </div>
                                        <div className="col-6">
                                          <h6 style={{ color: "#35b3e6" }}>
                                            {" "}
                                            Additional hours
                                          </h6>
                                          <table
                                            class="table table-bordered table-striped table-sm"
                                            id="tbl"
                                            style={{ width: "100%" }}
                                          >
                                            <thead>
                                              <tr>
                                                <th>Additional hours Utilized</th>
                                                <th style={{ width: "40%" }}>
                                                  <input
                                                    style={{ textAlign: "center" }}
                                                    value={AdditionHours}
                                                    disabled={true}
                                                    onChange={(e) =>
                                                      this.setState({
                                                        AdditionHours:
                                                          e.target.value.replace(
                                                            /\D/,
                                                            ""
                                                          ),
                                                      })
                                                    }
                                                    type="text"
                                                    maxLength={3}
                                                    class="form-control coustome-checkbox"
                                                  />
                                                </th>
                                              </tr>
                                            </thead>
                                          </table>
                                        </div>
                                      </div>
                                      <h6 style={{ color: "#35b3e6" }}>
                                        Inhouse Services
                                      </h6>
                                      <table
                                        class="table table-bordered table-striped table-sm"
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th style={{ width: "10px" }}></th>
                                            <th>Services</th>
                                            <th
                                              class="text-center"
                                              style={{ width: "15%" }}
                                            >
                                              Quantity
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {exitIncludedServicesList.length >
                                            0 &&
                                            exitIncludedServicesList != null ? (
                                            exitIncludedServicesList.map(
                                              (data, i) => (
                                                <tr>
                                                  <td>
                                                    <div class="bg only_checkbox">
                                                      <div class="chiller_cb">
                                                        <input
                                                          checked={
                                                            data.IsSelected ||
                                                            data.Is_checked
                                                          }
                                                          id={`existIncludedCheckbox${i}`}
                                                          type="checkbox"
                                                        />
                                                        <label
                                                          className="lebel-dis"
                                                          for={`existIncludedCheckbox${i}`}
                                                          style={{
                                                            color: "#979797",
                                                          }}
                                                        >
                                                          &nbsp;
                                                        </label>
                                                        <span></span>
                                                      </div>
                                                    </div>
                                                  </td>
                                                  <td>
                                                    <div>
                                                      {data.InclusiveServices}
                                                    </div>
                                                  </td>
                                                  <td class="text-center">
                                                    <input
                                                      type="text"
                                                      value={data.Quantity}
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                      maxLength={3}
                                                      disabled={true}
                                                      class="form-control coustome-checkbox"
                                                    />
                                                  </td>
                                                </tr>
                                              )
                                            )
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan={6}
                                                className="text-center"
                                                style={{ color: "#F96302" }}
                                              >
                                                Record not found
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>

                                      <h6 style={{ color: "#35b3e6" }}>
                                        {" "}
                                        Additional Paid Services
                                      </h6>
                                      <table
                                        class="table table-bordered table-striped table-sm"
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th style={{ width: "10px" }}></th>
                                            <th>Services</th>
                                            <th colSpan={2}></th>
                                            <th
                                              class="text-center"
                                              style={{ width: "15%" }}
                                            >
                                              Quantity
                                            </th>
                                            <th
                                              class="text-center"
                                              style={{ width: "131px" }}
                                            >
                                              Additional Quantity
                                            </th>
                                            {/* <th
                                    class="text-center"
                                    style={{ width: "15%" }}
                                  >
                                    Rate
                                  </th>
                                  <th
                                    class="text-center"
                                    style={{ width: "15%" }}
                                  >
                                    Amount (INR)
                                  </th> */}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {exitInhouseServicesList.length > 0 &&
                                            exitInhouseServicesList != null ? (
                                            exitInhouseServicesList.map(
                                              (data, i) => (
                                                <tr>
                                                  <td>
                                                    <div class="bg only_checkbox">
                                                      <div class="chiller_cb">
                                                        <input
                                                          id={`exitInhouseServicesList${i}`}
                                                          checked={
                                                            data.IsSelected ||
                                                            data.Is_checked
                                                          }
                                                          // disabled={true}
                                                          type="checkbox"
                                                        />
                                                        <label
                                                          className="lebel-dis"
                                                          for={`exitInhouseServicesList${i}`}
                                                          style={{
                                                            color: "#979797",
                                                          }}
                                                        >
                                                          &nbsp;
                                                        </label>
                                                        <span></span>
                                                      </div>
                                                    </div>
                                                  </td>
                                                  {data.Name !=
                                                    "Electricity" ? (
                                                    <td colSpan={3}>
                                                      <div>{data.Name}</div>
                                                    </td>
                                                  ) : (
                                                    <td>
                                                      <div>Electricity</div>
                                                    </td>
                                                  )}
                                                  {data.Name !=
                                                    "Electricity" ? (
                                                    <>
                                                      <td class="text-center">
                                                        <input
                                                          style={{
                                                            textAlign: "center",
                                                          }}
                                                          type="text"
                                                          value={data.Quantity}
                                                          disabled={true}
                                                          class="form-control coustome-checkbox"
                                                        />
                                                      </td>
                                                    </>
                                                  ) : (
                                                    <td
                                                      colSpan={3}
                                                      style={{
                                                        color: "#212529",
                                                        marginBottom: "0px",
                                                      }}
                                                    >
                                                      Electricity rate –RS. 16/-
                                                      per kwh
                                                    </td>
                                                  )}
                                                  <td class="text-center">
                                                    <input
                                                      style={{
                                                        textAlign: "center",
                                                      }}
                                                      type="text"
                                                      value={
                                                        data.AdditionalQuantity
                                                      }
                                                      disabled={true}
                                                      maxLength={3}
                                                      class="form-control coustome-checkbox"
                                                    />
                                                  </td>
                                                </tr>
                                              )
                                            )
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan={6}
                                                className="text-center"
                                                style={{ color: "#F96302" }}
                                              >
                                                Record not found
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>

                                      <h6 style={{ color: "#35b3e6" }}>
                                        External Services
                                      </h6>
                                      <table
                                        class="table table-bordered table-striped table-sm"
                                        style={{
                                          zIndex: "000",
                                          position: "relative",
                                        }}
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th>Service</th>
                                            <th>Vendor</th>
                                            <th>
                                              Contact Details
                                              <span class="mendatory_class">
                                                *
                                              </span>
                                            </th>
                                            <th style={{ width: "5%" }}>
                                              Clearance
                                              <span class="mendatory_class">
                                                *
                                              </span>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {exitVendorList != "" &&
                                            exitVendorList.length > 0 ? (
                                            exitVendorList.map((data, i) => (
                                              <tr>
                                                <td>{data.ServiceName}</td>
                                                <td>{data.VendorName}</td>
                                                <td>
                                                  <input
                                                    value={data.ContactDetails}
                                                    type="text"
                                                    className="form-control"
                                                    disabled={true}
                                                    maxLength={500}
                                                  />
                                                </td>
                                                <td>
                                                  <div
                                                    class="bg"
                                                    style={{
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <div class="chiller_cb">
                                                      <input
                                                        type="checkbox"
                                                        id={`vendorCheckboxSelect${i}`}
                                                        checked={
                                                          data.IsClearanceGiven
                                                        }
                                                      />
                                                      <label
                                                        for={`vendorCheckboxSelect${i}`}
                                                        style={{
                                                          color: "#979797;",
                                                        }}
                                                      >
                                                        &nbsp;
                                                      </label>
                                                      <span></span>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            ))
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan={4}
                                                className="text-center"
                                                style={{ color: "#F96302" }}
                                              >
                                                Record not found
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>

                                      <h6 style={{ color: "#35b3e6" }}>
                                        Consumable
                                      </h6>
                                      <table
                                        class="table table-bordered table-striped table-sm"
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th colSpan={2}>Consumable</th>
                                            {/* <th style={{width:'5%'}}>Action</th> */}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {exitConsumableList != "" &&
                                            exitConsumableList.length > 0 ? (
                                            exitConsumableList.map(
                                              (data, i) => (
                                                <tr>
                                                  <td>{data.Name}</td>
                                                  <td style={{ width: "5%" }}>
                                                    <div
                                                      class="bg"
                                                      style={{
                                                        justifyContent:
                                                          "center",
                                                        alignItems: "center",
                                                      }}
                                                    >
                                                      <div class="chiller_cb">
                                                        <input
                                                          type="checkbox"
                                                          id={`exitConsumable${i}`}
                                                          checked={
                                                            data.IsSelected
                                                          }
                                                        />
                                                        <label
                                                          for={`exitConsumable${i}`}
                                                          style={{
                                                            color: "#979797;",
                                                          }}
                                                        >
                                                          &nbsp;
                                                        </label>
                                                        <span></span>
                                                      </div>
                                                    </div>
                                                  </td>
                                                </tr>
                                              )
                                            )
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan={4}
                                                className="text-center"
                                                style={{ color: "#F96302" }}
                                              >
                                                Record not found
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>

                                      <h6 style={{ color: "#35b3e6" }}>
                                        Material List
                                      </h6>
                                      <div className="search_accordion search_card  m-0">
                                        <div
                                          className="panel-group"
                                          id="accordion"
                                        >
                                          {exitMaterialNameAndServiceName.length >
                                            0 ? (
                                            exitMaterialNameAndServiceName.map(
                                              (item, index) => (
                                                <>
                                                  <div
                                                    className="panel panel-default mb-2"
                                                    style={{
                                                      background: "#f3f3f3",
                                                    }}
                                                  >
                                                    <div
                                                      className="panel-heading accordion-toggle collapsed p-2"
                                                      data-toggle="collapse"
                                                      data-parent="#accordion"
                                                      data-target="#collapseOne"
                                                      onClick={() =>
                                                        this.toggleCollapse2(
                                                          item.isCollapsed,
                                                          index
                                                        )
                                                      }
                                                    >
                                                      <h4
                                                        className="panel-title d-flex"
                                                        style={{
                                                          justifyContent:
                                                            "space-between",
                                                        }}
                                                      >
                                                        {/* <span className='packages'></span> */}
                                                        <span className="packages">
                                                          {item.VendorName} /{" "}
                                                          {item.ServiceName}
                                                        </span>
                                                      </h4>
                                                    </div>
                                                    <div
                                                      id="collapseContent"
                                                      style={{
                                                        display:
                                                          !item.isCollapsed
                                                            ? "none"
                                                            : "block",
                                                      }}
                                                    >
                                                      <div
                                                        className="thankYou_page"
                                                        style={{
                                                          margin: "0px",
                                                        }}
                                                      >
                                                        <div
                                                          class="row"
                                                          style={{
                                                            padding:
                                                              "0px 21px 0px 33px",
                                                          }}
                                                        >
                                                          <table
                                                            class="table table-bordered table-material"
                                                            id="tbl"
                                                            style={{
                                                              background:
                                                                "#ffff",
                                                            }}
                                                          >
                                                            <thead>
                                                              <tr>
                                                                <th
                                                                  style={{
                                                                    width: "5%",
                                                                  }}
                                                                ></th>
                                                                <th>
                                                                  Material Name
                                                                </th>
                                                                <th
                                                                  style={{
                                                                    width:
                                                                      "15%",
                                                                  }}
                                                                >
                                                                  Quantity
                                                                </th>
                                                              </tr>
                                                            </thead>
                                                            <tbody>
                                                              {exitMaterialList !=
                                                                "" &&
                                                                exitMaterialList.length >
                                                                0 ? (
                                                                exitMaterialList.map(
                                                                  (data, i) => (
                                                                    <>
                                                                      {data.VendorID ==
                                                                        item.VendorID ? (
                                                                        <tr>
                                                                          <td
                                                                            style={{
                                                                              width:
                                                                                "5%",
                                                                            }}
                                                                          >
                                                                            <div
                                                                              class="bg"
                                                                              style={{
                                                                                justifyContent:
                                                                                  "center",
                                                                                alignItems:
                                                                                  "center",
                                                                              }}
                                                                            >
                                                                              <div class="chiller_cb">
                                                                                <input
                                                                                  type="checkbox"
                                                                                  id={`exitMaterial${i}`}
                                                                                  checked={
                                                                                    data.IsSelected
                                                                                  }
                                                                                />
                                                                                <label
                                                                                  for={`exitMaterial${i}`}
                                                                                  style={{
                                                                                    color:
                                                                                      "#979797;",
                                                                                  }}
                                                                                >
                                                                                  &nbsp;
                                                                                </label>
                                                                                <span></span>
                                                                              </div>
                                                                            </div>
                                                                          </td>
                                                                          <td>
                                                                            {
                                                                              data.MaterialName
                                                                            }
                                                                          </td>
                                                                          <td>
                                                                            <input
                                                                              type="text"
                                                                              className="form-control coustome-checkbox"
                                                                              disabled={
                                                                                true
                                                                              }
                                                                              value={
                                                                                data.PossessionQuantity
                                                                              }
                                                                            />
                                                                          </td>
                                                                        </tr>
                                                                      ) : (
                                                                        <></>
                                                                      )}
                                                                    </>
                                                                  )
                                                                )
                                                              ) : (
                                                                <tr>
                                                                  <td
                                                                    colSpan={4}
                                                                    className="text-center"
                                                                    style={{
                                                                      color:
                                                                        "#F96302",
                                                                    }}
                                                                  >
                                                                    Record not
                                                                    found
                                                                  </td>
                                                                </tr>
                                                              )}
                                                            </tbody>
                                                          </table>
                                                          <div class="form-group w-100 mb-3">
                                                            <h6
                                                              style={{
                                                                color:
                                                                  "#35b3e6",
                                                                margin: "0px",
                                                              }}
                                                            >
                                                              Note:
                                                            </h6>
                                                            <textarea
                                                              maxLength={500}
                                                              value={item.Note}
                                                              style={{
                                                                height: "80px",
                                                              }}
                                                              disabled={true}
                                                              class="form-control"
                                                              rows="3"
                                                              placeholder="Type here..."
                                                            ></textarea>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </>
                                              )
                                            )
                                          ) : (
                                            <table
                                              class="table table-bordered table-striped table-sm"
                                              id="tbl"
                                            >
                                              <tbody>
                                                <td
                                                  style={{
                                                    color: "#F96302",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  Record not found
                                                </td>
                                              </tbody>
                                            </table>
                                          )}
                                        </div>
                                      </div>

                                      <h6 style={{ color: "#35b3e6" }}>
                                        Electricity
                                      </h6>
                                      <table
                                        class="table table-bordered table-striped table-sm"
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th>
                                              Electricity Units Reading on Exit{" "}
                                            </th>
                                            <th style={{ width: "40%" }}>
                                              <input
                                                style={{ textAlign: "center" }}
                                                disabled={true}
                                                value={electricityExit}
                                                type="text"
                                                maxLength={10}
                                                class="form-control coustome-checkbox"
                                              />
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr>
                                            <td>Total Consumed units</td>
                                            <td style={{ textAlign: "center" }}>
                                              {electricityExit <
                                                electricityPossesion
                                                ? 0
                                                : electricityExit -
                                                electricityPossesion}
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>

                                      <div
                                        class="Checklist_div mb-3"
                                        style={{ marginTop: "30px" }}
                                      >
                                        <div className="bg checklist">
                                          <div class="chiller_cb" style={{}}>
                                            <input
                                              id={`exitCheckListAllSelected`}
                                              checked={exitCheckListAllSelected}
                                              disabled={true}
                                              type="checkbox"
                                            />
                                            <label
                                              for={`exitCheckListAllSelected`}
                                              style={{
                                                fontSize: "13px",
                                                color: "#212529",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              {" "}
                                              Select All
                                            </label>
                                            <span></span>
                                            <span></span>
                                          </div>
                                        </div>
                                        {exitInstructionList.length > 0 &&
                                          exitInstructionList != null ? (
                                          exitInstructionList.map((data, i) => (
                                            <>
                                              <div
                                                className="bg checklist"
                                                style={{ marginLeft: "10px" }}
                                              >
                                                <div class="chiller_cb">
                                                  <input
                                                    id={`exitInstructionCheckbox${i}`}
                                                    checked={data.IsSelected}
                                                    type="checkbox"
                                                  />
                                                  <label
                                                    for={`exitInstructionCheckbox${i}`}
                                                    style={{
                                                      fontSize: "13px",
                                                      color: "#212529",
                                                      fontWeight: "normal",
                                                    }}
                                                  >
                                                    {data.Name}
                                                    <span
                                                      class="mendatory_class"
                                                      style={{
                                                        marginLeft: "18px",
                                                        border: "none",
                                                      }}
                                                    >
                                                      *
                                                    </span>
                                                  </label>
                                                  <span></span>
                                                </div>
                                              </div>
                                            </>
                                          ))
                                        ) : (
                                          <tr>
                                            <td
                                              colSpan={6}
                                              className="text-center"
                                              style={{ color: "#F96302" }}
                                            >
                                              Record not found
                                            </td>
                                          </tr>
                                        )}

                                        <div class="row mt-2">
                                          <div className="col-md-12">
                                            <h6 className="additional_services">
                                              Remark
                                            </h6>
                                          </div>
                                        </div>
                                        <div class="row">
                                          <div class="col-md-12">
                                            <div class="form-group">
                                              <textarea
                                                maxLength={500}
                                                value={unlistedAddServices}
                                                style={{ height: "180px" }}
                                                disabled={true}
                                                class="form-control"
                                                rows="3"
                                                placeholder="Type here..."
                                              ></textarea>
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        class="d-flex align-items-center"
                                        style={{ justifyContent: "space-between", flexWrap: 'wrap' }}
                                      >
                                        <div className="d-flex">
                                          <div>
                                            <label>Client Contact Name And Number<span class="mendatory_class">*</span></label>
                                            <textarea
                                              value={ExitContactNameAndNumber}
                                              disabled={true}
                                              // onChange={(e) => this.setState({ ExitContactNameAndNumber: e.target.value })}
                                              style={{ resize: 'none', height: '100px' }}
                                              className="form-control"
                                              cols={100}
                                            />
                                          </div>

                                        </div>
                                        <div className="d-flex">
                                          <div>
                                            <label>Client Signature<span class="mendatory_class">*</span></label>
                                            <div
                                              class="client_signature_box"
                                              style={{ border: "1px solid #c9c8c8" }}
                                            >

                                              <img
                                                src={ExitSignatureData}
                                                style={{ width: 250, height: 125 }}
                                                alt="Saved Signature"
                                              />

                                            </div>
                                          </div>

                                        </div>
                                      </div>
                                      <h6
                                        style={{
                                          color: "#35b3e6",
                                          marginTop: "20px",
                                        }}
                                      >
                                        Center Security List
                                      </h6>
                                      <table
                                        class="table table-bordered table-striped table-sm"
                                        id="tbl"
                                      >
                                        <thead>
                                          <tr>
                                            <th colSpan={2}>
                                              Center Security List
                                            </th>
                                            {/* <th style={{width:'5%'}}>Action</th> */}
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {exitSecurityList != "" &&
                                            exitSecurityList.length > 0 ? (
                                            exitSecurityList.map((data, i) => (
                                              <tr>
                                                <td>{data.Name}</td>
                                                <td style={{ width: "5%" }}>
                                                  <div
                                                    class="bg"
                                                    style={{
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                    }}
                                                  >
                                                    <div class="chiller_cb">
                                                      <input
                                                        type="checkbox"
                                                        id={`exitSecurityList${i}`}
                                                        checked={
                                                          data.IsSelected
                                                        }
                                                      />
                                                      <label
                                                        for={`exitSecurityList${i}`}
                                                        style={{
                                                          color: "#979797;",
                                                        }}
                                                      >
                                                        &nbsp;
                                                      </label>
                                                      <span></span>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            ))
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan={4}
                                                className="text-center"
                                                style={{ color: "#F96302" }}
                                              >
                                                Record not found
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>

                                      <h6
                                        style={{
                                          color: "#35b3e6",
                                          marginTop: "20px",
                                        }}
                                      >
                                        Security List Note:
                                      </h6>
                                      <div class="row">
                                        <div
                                          class="col-md-12"
                                          style={{ padding: "0 15px" }}
                                        >
                                          <div class="form-group">
                                            <textarea
                                              maxLength={500}
                                              value={ExitSecurityChecklistNote}
                                              style={{ height: "150px" }}
                                              disabled={true}
                                              class="form-control"
                                              rows="3"
                                              placeholder="Type here..."
                                            ></textarea>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        class="d-flex align-items-center mt-4"
                                        style={{ justifyContent: "space-between", flexWrap: 'wrap' }}
                                      >
                                        <div className="d-flex">
                                          <div>
                                            <label>Operations Contact Name And Number<span class="mendatory_class">*</span></label>
                                            <textarea
                                              value={ExitOperationNameContact}
                                              disabled={true}
                                              // onChange={(e) => this.setState({ ExitOperationNameContact: e.target.value })}
                                              style={{ resize: 'none', height: '100px' }}
                                              className="form-control"
                                              cols={100}
                                            />
                                          </div>

                                        </div>
                                      </div>
                                      <div
                                        class="d-flex align-items-center"
                                        style={{ justifyContent: "space-between", flexWrap: 'wrap' }}
                                      >
                                        <div className="d-flex">
                                          <div>
                                            <label>Operations Signature<span class="mendatory_class">*</span></label>
                                            <div
                                              class="client_signature_box"
                                              style={{ border: "1px solid #c9c8c8" }}
                                            >
                                              {console.log(oppExitSignatureData, "oppExitSignatureData")}
                                              <img
                                                src={oppExitSignatureData}
                                                style={{ width: 250, height: 125 }}
                                                alt="Saved Signature"
                                              />

                                            </div>
                                          </div>

                                        </div>


                                        <div style={{ marginTop: "110px", display: existDataListFlag ? 'flex' : '', flexDirection: existDataListFlag ? 'column' : '' }} className="d-flex">


                                          <>
                                            <span style={{ color: "#979797" }}>Exit Submitted by {ExitSubmittedUser}</span>
                                            <span style={{ color: "#979797" }}>{moment(ExitSubmittedDate).utc().format("DD/MM/YYYY hh:mm:ss")}</span>
                                          </>

                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </>
                          ) : null}
                        </div>
                      </div>
                      <div className="card-footer">
                        <div className="align-items-center gy-3">
                          <div className="row">
                            <div className="col-md-6"></div>
                            <div className="col-md-6">
                              <div className="row">
                                {this.IsNoDue(
                                  data.Is_NoDue,
                                  data.DeliveryStatus,
                                  AdditionalServiceStatus,
                                  data.NoDueBy,
                                  data.NoDueDate
                                )}
                                {this.Is_ExitPass(
                                  data.Is_ExitPass,
                                  data.DeliveryStatus,
                                  data.IsExitPassBy,
                                  data.IsExitPassDate
                                )}

                                {this.IsEventClosure(
                                  data.Is_Closure,
                                  data.DeliveryStatus
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12 text-left">
                              <a
                                href="javascript:void(0);"
                                onClick={() => this.backToOrders()}
                                className="btn btn-warning my_custom_orderPage_btns m-2"
                              >
                                Back to List
                              </a>
                              {/* <a
                        href="javascript:void(0);"
                        className="btn btn-primary my_custom_orderPage_btns m-2"
                      >
                        Additional Services
                      </a> */}
                              {this.IsCancelledButton(
                                data.DeliveryStatus,
                                data.Is_NoDue
                              ) ? null : (
                                <>
                                  <a
                                    href="javascript:void(0);"
                                    onClick={() =>
                                      this.deleteModalShow(
                                        data.OrderID,
                                        this.props.location.state.OrderNo ||
                                        OrderID,
                                        this.props.location.state.CompanyName ||
                                        companyName,
                                        this.props.location.state
                                          .PrimaryEmailID || primaryEmailID,
                                        data.RoleID,
                                        this.props.location.state.OrderAmount ||
                                        MyOrdersData.map((data) => data)
                                      )
                                    }
                                    className="btn btn-dark my_custom_orderPage_btns m-2"
                                  >
                                    Cancel Order
                                  </a>
                                </>
                              )}
                              {this.isCreditDebit(data.DeliveryStatus) ? (
                                <>
                                  <a
                                    onClick={() =>
                                      this.navigateToCreditNote(
                                        data.OrderID,
                                        this.props.location.state.ClientID ||
                                        MyOrdersData.map(
                                          (data) => data.ClientID
                                        ),
                                        this.props.location.state
                                          .PrimaryEmailID || primaryEmailID,
                                        data.RoleID
                                      )
                                    }
                                    href="javascript:void(0);"
                                    className="btn btn-success my_custom_orderPage_btns m-2"
                                  >
                                    View Credit Note
                                  </a>
                                  <a
                                    href="javascript:void(0);"
                                    onClick={() =>
                                      this.navigateToDebitNote(
                                        data.OrderID,
                                        this.props.location.state.ClientID ||
                                        MyOrdersData.map(
                                          (data) => data.ClientID
                                        ),
                                        this.props.location.state
                                          .PrimaryEmailID || primaryEmailID,
                                        data.RoleID
                                      )
                                    }
                                    className="btn btn-success my_custom_orderPage_btns m-2"
                                  >
                                    View Debit Note
                                  </a>
                                </>
                              ) : null}
                              {this.IsModifyButton(
                                data.Is_NoDue,
                                data.DeliveryStatus,
                                data.OrderID,
                                data.OrderNo,
                                data.StatusID,
                                data.CenterID,
                                data.summary
                                  .map((data) => data.BookingDate)
                                  .join(",")
                              )}
                            </div>
                          </div>
                          <Modal
                            show={PiShow}
                            // onHide={this.piModalClose}
                            size="md"
                          >
                            <Modal.Header>
                              <Modal.Title>
                                Download Proforma & Booking Form
                              </Modal.Title>
                              <span
                                onClick={() => this.piModalClose()}
                                style={{
                                  cursor: "pointer",
                                  fontWeight: "800",
                                }}
                              >
                                X
                              </span>
                            </Modal.Header>

                            <Modal.Body>
                              <Tab.Container defaultActiveKey="pi">
                                <Nav
                                  variant="tabs"
                                  className="nav nav-tabs nav-tabs-custom nav-success mb-3 myOrderTabs"
                                  role="tablist"
                                >
                                  <Nav.Item>
                                    <Nav.Link eventKey="pi">
                                      Proforma Invoice
                                    </Nav.Link>
                                  </Nav.Item>
                                  <Nav.Item>
                                    <Nav.Link eventKey="bookingform">
                                      Booking Form
                                    </Nav.Link>
                                  </Nav.Item>
                                </Nav>
                                <Tab.Content>
                                  <Tab.Pane eventKey="pi">
                                    <div class="form-group">
                                      <h5>Proforma Invoice List</h5>
                                      <table className="table table-striped table-hover">
                                        <thead>
                                          <tr>
                                            <th scope="col">Sr.No</th>
                                            <th scope="col">
                                              Proforma Invoice No.
                                            </th>
                                            <th scope="col">
                                              Proforma Invoice Type
                                            </th>
                                            <th scope="col">Download</th>
                                          </tr>
                                        </thead>
                                        <tbody id="show_proformainvoices">
                                          {proformaList.length > 0 ? (
                                            proformaList.map((data) =>
                                              data.map((data2, i) => (
                                                <tr key={data2.ProformaInvoiceID}>
                                                  <td colSpan="">{i + 1}</td>
                                                  <td>
                                                    {data2.ProformaInvoice_No}
                                                  </td>
                                                  <td>
                                                    {data2.ProformaType === "Additionalservices" ? "Rental & Additional Services" : data2.ProformaType ===
                                                      ("Slot Booking") ? "Rental" : "Additional Amount"}
                                                  </td>
                                                  <td>
                                                    <a
                                                      title="Download Proforma"
                                                      style={{ cursor: "pointer" }}
                                                      onClick={() =>
                                                        this.downloadPerformaInvoice(
                                                          data2.ProformaInvoiceID,
                                                          data2.ProformaInvoice_No, data2.proformaType
                                                        )
                                                      }
                                                    >
                                                      <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                                                    </a>
                                                  </td>
                                                </tr>
                                              ))
                                            )
                                          ) : (
                                            <tr>
                                              <td colSpan="4">
                                                No Proforma Details Found!
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </Tab.Pane>
                                  <Tab.Pane eventKey="bookingform">
                                    <div class="form-group">
                                      <h5>Booking Form</h5>
                                      <table className="table table-striped table-hover">
                                        <thead>
                                          <tr>
                                            <th scope="col">
                                              Application No
                                            </th>
                                            <th scope="col">
                                              Order No.
                                            </th>
                                            <th scope="col">Download</th>
                                          </tr>
                                        </thead>
                                        <tbody id="show_proformainvoices">
                                          {StatusID > 10 ? <>
                                            <tr>
                                              <td>{OrderID}</td>
                                              <td>{OrderNo}</td>
                                              <td>
                                                <a
                                                  title="Download Booking Form"
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() => this.downloadBookingForm(OrderID, OrderNo)}
                                                >
                                                  <i className="fa fa-file-pdf-o action_btn_table" />{" "}
                                                </a>
                                              </td>
                                            </tr>
                                          </> : <>
                                            <tr>
                                              <td colSpan="3" />
                                              No Booking Form Available!
                                            </tr>
                                          </>}
                                        </tbody>
                                      </table>
                                    </div>
                                  </Tab.Pane>
                                </Tab.Content>
                              </Tab.Container>
                            </Modal.Body>

                            <Modal.Footer>
                              <Button
                                variant="success"
                                onClick={() => this.piModalClose()}
                              >
                                Close
                              </Button>
                            </Modal.Footer>
                          </Modal>
                          <Modal
                            show={deleteShow}
                            // onHide={this.deleteModalClose}
                            size="lg"
                          >
                            <Modal.Header>
                              <Modal.Title>Cancel Order: {OrderNo}</Modal.Title>
                              <span
                                onClick={() => this.deleteModalClose()}
                                style={{
                                  cursor: "pointer",
                                  fontWeight: "800",
                                }}
                              >
                                X
                              </span>
                            </Modal.Header>

                            <Modal.Body>
                              <div class="form-group">
                                <h5>CANCELLATION & REFUND</h5>
                                <hr />
                                <ul>
                                  <li>
                                    Once the ITME Center receives the online
                                    application forms for booking, cancellation
                                    of participation or reduction in
                                    requirements/packages will not be allowed
                                    after confirmation.
                                  </li>
                                  <li>
                                    If on any terms the event if canceled by the
                                    client then the cancellation charges will be
                                    as follows:
                                    <ol>
                                      <li>
                                        <strong>
                                          Event Cancelled 15 days prior – 25 %
                                          of the Total amount.
                                        </strong>
                                      </li>
                                      <li>
                                        <strong>
                                          Event Cancelled 10 days prior –75 % of
                                          the Total amount.
                                        </strong>
                                      </li>
                                      <li>
                                        <strong>
                                          Event Cancelled 5 days prior – 100 %
                                          of the Total amount.
                                        </strong>
                                      </li>
                                    </ol>
                                  </li>
                                  <li>
                                    The date on which written communication
                                    conveying full or partial cancellation is
                                    received by the Authority will be considered
                                    as the effective date for determining the
                                    cancellation charges.
                                  </li>
                                  <li>
                                    The advance amount / refundable amount and
                                    security deposit (if any) will be paid after
                                    deducting applicable taxes, banking charges,
                                    and administrative charges.
                                  </li>
                                </ul>
                              </div>
                              <hr />
                              <div class="form-group">
                                <label>Reason</label>
                                <select
                                  id="country"
                                  name="Reason"
                                  value={CancellationReasonID}
                                  onChange={(e) => {
                                    const selectedReasonId = e.target.value;
                                    console.log(
                                      "Selected State ID:",
                                      selectedReasonId
                                    );

                                    this.setState({
                                      CancellationReasonID: selectedReasonId,
                                    });
                                  }}
                                  className="form-control floating-control"
                                >
                                  <option value="">SELECT REASON</option>
                                  {cancellationReasonList?.length > 0 &&
                                    cancellationReasonList.map((data) => (
                                      <option
                                        key={data.CancellationReasonID}
                                        value={data.CancellationReasonID}
                                      >
                                        {data.Name}
                                      </option>
                                    ))}
                                </select>
                              </div>
                              <div class="form-group">
                                <label>Cancellation Note</label>
                                <textarea
                                  value={cancelNote}
                                  onChange={(e) =>
                                    this.setState({
                                      cancelNote: e.target.value,
                                    })
                                  }
                                  class="form-control"
                                  rows={3}
                                  defaultValue={""}
                                />
                              </div>
                            </Modal.Body>

                            <Modal.Footer>
                              <Button
                                variant="success"
                                onClick={() => this.handleDelete(OrderID)} // "SUBMIT" button
                              >
                                Request
                              </Button>
                              <Button
                                variant="secondary"
                                onClick={() => this.deleteModalClose()} // "SUBMIT" button
                              >
                                close
                              </Button>
                            </Modal.Footer>
                          </Modal>
                          <Modal
                            show={isOpen}
                            size="lg"
                          // onHide={this.serviceModalClose}
                          >
                            <Modal.Header className="pb-0">
                              <Modal.Title style={{ width: "100%" }}>
                                <div
                                  className=" d-flex mr-5 mb-4"
                                  style={{ justifyContent: "space-between" }}
                                >
                                  <div className="pack-name">
                                    <span>
                                      {" "}
                                      Available package for{" "}
                                      <span
                                        style={{
                                          fontSize: "20px",
                                          color: "#1976D2",
                                        }}
                                      >
                                        {serviceName}
                                      </span>
                                    </span>
                                  </div>
                                  <div className="d-flex">
                                    <div className="mr-4 m-1">Pricing : </div>
                                    <div>
                                      <Box sx={{ width: 200 }}>
                                        <Slider
                                          value={SliderValue}
                                          onChangeCommitted={(e, value) =>
                                            this.onSliderHandleChange(e, value)
                                          }
                                          onChange={(e) =>
                                            this.setState({
                                              SliderValue: e.target.value,
                                            })
                                          }
                                          valueLabelDisplay="on"
                                          max={100000}
                                          marks={marks}
                                          step={null}
                                        />
                                      </Box>
                                    </div>
                                    {/* <div>
                                        <button
                                            onClick={() => this.onSearchPackage()}
                                            class="btn btn-info ml-3 p-1"
                                        >
                                            Search
                                        </button>
                                    </div> */}
                                  </div>
                                </div>
                              </Modal.Title>
                              <span
                                onClick={this.serviceModalClose}
                                style={{ cursor: "pointer", fontWeight: "800" }}
                              >
                                X
                              </span>
                            </Modal.Header>

                            <Modal.Body
                              className="pb-0 p-3 cat-pop"
                              style={{ marginBottom: "0px", overflowY: "auto" }}
                            >
                              {/* <div>
                            <span className='mr-2'>Minimum Price : </span>
                            <input
                                placeholder='0'
                                type="text"
                                className='form-control'
                                value={minPrice != 0 ? minPrice : ''}
                                onChange={(e) => this.onPrice(e, 'min')}
                                maxLength={6}
                                disabled
                            />
                        </div>
                        <div>
                            <span className='mr-2'>Maximum Price : </span>
                            <input
                                placeholder='0'
                                type="text"
                                className='form-control'
                                value={maxPrice != 0 ? maxPrice : ''}
                                onChange={(e) => this.onPrice(e, 'max')}
                                maxLength={6}
                                disabled
                            />
                        </div> */}
                              <div className="">
                                <div
                                  className="search_accordion search_card  m-0"
                                  style={{ background: "none" }}
                                >
                                  <div className="panel-group" id="accordion">
                                    {vendorNameList.length > 0 ? (
                                      vendorNameList.map((item, i) => (
                                        <div
                                          className="panel panel-default mb-2"
                                          style={{ background: "#f3f3f3" }}
                                        >
                                          <div
                                            className="panel-heading accordion-toggle collapsed p-2"
                                            data-toggle="collapse"
                                            data-parent="#accordion"
                                            data-target="#collapseOne"
                                            onClick={() =>
                                              this.toggleCollapseAdditionalService(
                                                item.isCollapsed,
                                                i
                                              )
                                            }
                                          >
                                            <h4
                                              className="panel-title d-flex"
                                              style={{
                                                justifyContent: "space-between",
                                              }}
                                            >
                                              <span
                                                style={{ marginTop: "5px" }}
                                              >
                                                {item.name}
                                              </span>
                                              <span className="packages">
                                                {item.frequency} Options
                                              </span>
                                            </h4>
                                          </div>
                                          <div
                                            id="collapseContent"
                                            style={{
                                              display: !item.isCollapsed
                                                ? "none"
                                                : "block",
                                            }}
                                          >
                                            <div
                                              className="thankYou_page"
                                              style={{ marginTop: "0px" }}
                                            >
                                              <div class="row">
                                                <div class="col-md-12">
                                                  {vendorPackageList.length >
                                                    0 &&
                                                    vendorPackageList != "" ? (
                                                    vendorPackageList.map(
                                                      (data, i) => (
                                                        <>
                                                          {data.VendorID ==
                                                            item.VendorID ? (
                                                            <div
                                                              class="card"
                                                              style={{
                                                                marginBottom:
                                                                  "10px",
                                                              }}
                                                            >
                                                              <div class="card-body p-2">
                                                                <div class="company_info d-flex">
                                                                  <div class="bg">
                                                                    <div class="chiller_cb">
                                                                      <input
                                                                        id={`vendorPackageCheckbox${i}`}
                                                                        type="checkbox"
                                                                        // onClick={(e) => console.log("sagar------", e.target.checked)}
                                                                        onClick={(
                                                                          e
                                                                        ) =>
                                                                          this.vendorPackageCheckbox(
                                                                            i,
                                                                            data.IsSelected,
                                                                            e
                                                                          )
                                                                        }
                                                                        checked={
                                                                          data.IsSelected
                                                                        }
                                                                        disabled={
                                                                          possessionCheckList.length ==
                                                                            0
                                                                            ? false
                                                                            : true
                                                                        }
                                                                      />
                                                                      <label
                                                                        for={`vendorPackageCheckbox${i}`}
                                                                        style={{
                                                                          color:
                                                                            "#000",
                                                                          fontSize:
                                                                            "13px",
                                                                        }}
                                                                      >
                                                                        {" "}
                                                                        &emsp;{" "}
                                                                      </label>
                                                                      <span></span>
                                                                    </div>
                                                                  </div>

                                                                  <div
                                                                    style={{
                                                                      width:
                                                                        "100%",
                                                                    }}
                                                                  >
                                                                    <p className="m-0">
                                                                      {
                                                                        data.VendorName
                                                                      }{" "}
                                                                      /{" "}
                                                                      <spa className="pac-nam">
                                                                        {
                                                                          data.Package
                                                                        }
                                                                      </spa>
                                                                    </p>
                                                                    <div
                                                                      class="card"
                                                                      style={{
                                                                        width:
                                                                          "100%",
                                                                        margin:
                                                                          "5px 0 5px 0",
                                                                      }}
                                                                    >
                                                                      <div class="card-body p-2">
                                                                        <pre
                                                                          style={{
                                                                            margin: 0,
                                                                            padding: 0,
                                                                          }}
                                                                          dangerouslySetInnerHTML={{
                                                                            __html:
                                                                              data.PackageDetails,
                                                                          }}
                                                                        />
                                                                      </div>
                                                                    </div>
                                                                    {data.FilePath !=
                                                                      null ? (
                                                                      <p className="m-0">
                                                                        {" "}
                                                                        Images:{" "}
                                                                        <a
                                                                          title="Show Images"
                                                                          style={{
                                                                            cursor:
                                                                              "pointer",
                                                                            fontSize:
                                                                              "18px",
                                                                          }}
                                                                          onClick={() =>
                                                                            this.vendorModalShow(
                                                                              data.FilePath
                                                                            )
                                                                          }
                                                                        >
                                                                          <i class="fa fa-image"></i>
                                                                        </a>
                                                                      </p>
                                                                    ) : (
                                                                      <></>
                                                                    )}
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          ) : (
                                                            <></>
                                                          )}
                                                        </>
                                                      )
                                                    )
                                                  ) : (
                                                    <tr>
                                                      <td
                                                        colSpan={12}
                                                        className="text-center"
                                                      >
                                                        Record not found
                                                      </td>
                                                    </tr>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      ))
                                    ) : (
                                      <></>
                                    )}
                                    {vendorPackageList.length > 0 &&
                                      vendorPackageList != "" ? (
                                      <>
                                        <p className="m-0 pt-2 bot-add">
                                          Additional Requirement:
                                        </p>
                                        <CKEditor
                                          editor={ClassicEditor}
                                          data={addRequirement}
                                          disabled={
                                            possessionCheckList.length == 0
                                              ? false
                                              : true
                                          }
                                          onChange={(event, editor) => {
                                            const data = editor.getData();
                                            this.additionRequirement(data);
                                          }}
                                        />
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </Modal.Body>
                            <div className="model-footer model-footer p-2 pt-0 pr-3">
                              <div style={{ textAlign: "right" }}>
                                {vendorPackageList.length > 0 &&
                                  vendorPackageList != "" ? (
                                  possessionCheckList.length == 0 ? (
                                    <>
                                      <button
                                        onClick={() =>
                                          this.setState({ isOpen: false })
                                        }
                                        class="btn btn-outline-success mr-2"
                                      >
                                        Submit
                                      </button>
                                    </>
                                  ) : (
                                    <></>
                                  )
                                ) : (
                                  <></>
                                )}
                                <button
                                  onClick={() => this.serviceModalClose()}
                                  class="btn btn-outline-secondary mr-2"
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>
                          </Modal>

                          <Modal
                            show={show}
                            onHide={this.vendorModalClose}
                            size="md"
                          >
                            <Modal.Header>
                              <Modal.Title>Vendor Images</Modal.Title>
                              <span
                                onClick={this.vendorModalClose}
                                style={{ cursor: "pointer", fontWeight: "800" }}
                              >
                                X
                              </span>
                            </Modal.Header>

                            <Modal.Body style={{ marginBottom: "0px" }}>
                              {/* {
                            fileList.length && */}

                              <OwlCarousel
                                style={{ zIndex: "1" }}
                                items={1}
                                loop
                                nav
                                margin={20}
                              >
                                {fileList != "" ? (
                                  fileList.map((imageUrl, i) => (
                                    <>
                                      {console.log(
                                        "imageUrl--",
                                        imageUrl.trim()
                                      )}
                                      <img
                                        alt=""
                                        title=""
                                        src={downloadUrl + imageUrl.trim()}
                                        className="booking_page_img"
                                      />
                                    </>
                                  ))
                                ) : (
                                  <></>
                                )}
                              </OwlCarousel>
                              {/* } */}
                            </Modal.Body>
                          </Modal>

                          <Modal
                            show={showtable}
                            onHide={this.tablePackageDetailsClose}
                            size="md"
                          >
                            <Modal.Header>
                              <Modal.Title>Vendor Package Details</Modal.Title>
                              <span
                                onClick={this.tablePackageDetailsClose}
                                style={{ cursor: "pointer", fontWeight: "800" }}
                              >
                                X
                              </span>
                            </Modal.Header>

                            <Modal.Body style={{ marginBottom: "0px" }}>
                              {/* {
                            fileList.length && */}
                              <div>
                                <pre
                                  dangerouslySetInnerHTML={{
                                    __html: showPackageDetailsData,
                                  }}
                                />
                              </div>
                              {/* } */}
                            </Modal.Body>
                          </Modal>
                        </div>
                      </div>
                    </div>
                  ))}
                {/* <div class="total_card_count">
                    <div class="card">
                      <div class="card-body bg_grey">
                        <div class="d-flex total_div">
                          <div class="total_text">Total : </div>
                          <h5 class="fs-14 mb-0 total_count_text">₹ <span class="product-line-price">2,26,500</span></h5>
                        </div>
                      </div>
                    </div>
                  </div> */}
              </div>
            </div>
          </main>
          <div className={`chat-container ${isChatOpen ? "chat-open" : ""}`}>
            <div className="chat-box p-2">
              <div className="chat-header">
                <div class="row">
                  <div class="col-md-9">
                    <h6 class="p-2">
                      {chatVendorCompany} - {chatServiceName}
                    </h6>
                  </div>
                  <div class="col-md-3 text-right">
                    <Button variant="light" onClick={this.toggleChat}>
                      X
                    </Button>
                  </div>
                </div>
                <hr />
              </div>
              <div className="chat-messages">
                {sortedChatDtl.length === 0 ? (
                  <>
                    <div className="message incoming">
                      {isChatLoading ? "Loading..." : "Start conversation"}
                    </div>
                  </>
                ) : (
                  sortedChatDtl.map((message, index) => {
                    const isOutgoing =
                      (roleId === "3" && message.isClient) ||
                      (roleId === "13" && !message.isClient);
                    const currentDate = moment(message.datetime).format(
                      "YYYY-MM-DD"
                    );
                    const showDateSeparator =
                      index === 0 ||
                      moment(message.datetime).format("YYYY-MM-DD") !==
                      moment(sortedChatDtl[index - 1].datetime).format(
                        "YYYY-MM-DD"
                      );

                    return (
                      <>
                        {showDateSeparator && (
                          <div className="date-separator">
                            {moment(message.datetime).format("MMM DD, YYYY")}
                          </div>
                        )}
                        <div
                          key={index}
                          className={`message ${isOutgoing ? "outgoing" : "incoming"
                            }`}
                        >
                          <div className="message-content">{message.chat}</div>
                          <span className="time">
                            {moment(message.datetime).format("h:mm A")}
                          </span>
                        </div>
                      </>
                    );
                  })
                )}
              </div>
              <div className="chat-input">
                <div className="row p-2">
                  <div className="col-md-9">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Type your message..."
                      value={chat}
                      onChange={(e) => this.setState({ chat: e.target.value })}
                    />
                  </div>
                  <div className="col-md-3">
                    <Button
                      variant="primary"
                      onClick={() =>
                        this.sendMessage(
                          chatOrderID,
                          chatVendorID,
                          chatServiceID
                        )
                      }
                    >
                      Send
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <style type="text/css">{floatingLabelCSSOrders}</style>
          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    fill_action,
    order_edit_details,
    order_cancel_reason_action,
    download_performa_invoice_action,
    client_detail_action,
    client_add_action,
    download_no_due_action,
    generate_nodue_action,
    payment_action,
    generate_unique_no_action,
    get_additional_services_action,
    postUpdate_additional_services_action,
    get_booking_Details_action,
    get_possession_list_action,
    get_exist_list_action,
    download_exitPass_action,
    getServiceVendorPackageDetail_action,
    thirdParty_VendorOrder_detail_action,
    insertUpdate_thirdParty_vendorOrderDtl_action,
    chat_detail_action,
    insert_chat_action, create_payment_order_action,
    download_booking_form_action
  })(MyOrdersEdit)
);
